import { de } from './de';
import type { Translations } from './en';

// Untranslated sections fall back to German via `...de`; translated sections
// (top-level + nav…editReservation) override below. Translate the rest by
// adding override blocks (mirror the keys added to en.ts).
export const vi: Translations = {
  ...de,

  back: 'Quay lại',
  save: 'Lưu thay đổi',
  saveShort: 'Lưu',
  createShort: 'Tạo',
  saving: 'Đang lưu…',
  loading: 'Đang tải…',
  cancel: 'Hủy',
  ok: 'Đồng ý',
  confirm: 'Xác nhận',
  close: 'Đóng',
  edit: 'Sửa',
  delete: 'Xóa',
  no: 'Không',
  error: 'Đã có lỗi xảy ra',
  saved: 'Đã lưu',
  prevMonth: 'Tháng trước',
  nextMonth: 'Tháng sau',
  pickDate: 'Chọn ngày',

  signOut: 'Đăng xuất',
  signOutConfirm: 'Bạn có chắc muốn đăng xuất không?',
  versionCopied: 'Đã sao chép phiên bản',
  versionCopyHint: 'Chạm để sao chép phiên bản',
  companyCredit:
    'Phần mềm và bản quyền thuộc sở hữu của công ty Ninety Six Digital. Để tìm hiểu thêm các dịch vụ liên quan tới quảng cáo, phần mềm quản lý kinh doanh và các giải pháp AI, xin mời liên hệ qua',
  companyCreditAnd: 'và',

  unsavedChangesTitle: 'Bỏ thay đổi?',
  unsavedChangesText: 'Bạn có thay đổi chưa lưu. Bạn có muốn bỏ chúng không?',
  discardChanges: 'Bỏ thay đổi',

  payments: {
    title: 'Thanh toán',
    onlineTitle: 'Nhà cung cấp thanh toán online',
    intro:
      'Nhà cung cấp có sẵn (PayPal, Menucat). Kết nối bao nhiêu tuỳ bạn - mỗi nhà cung cấp bật lên sẽ hiện thành một lựa chọn riêng khi thanh toán, tiền được thu tự động và về thẳng tài khoản của bạn.',
    paymentWindowTitle: 'Thời gian thanh toán',
    paymentWindowFooter:
      'Đơn chưa thanh toán được giữ mở bao lâu để khách chuyển khoản và tải biên lai. Quá thời gian này đơn tự huỷ và không tải biên lai được nữa. Đặt riêng theo từng loại đơn.',
    paymentWindowDialogTitle: 'Số phút để thanh toán (1–1440)',
    paymentWindowPrompt: (label: string) =>
      `Đơn ${label} chờ thanh toán bao nhiêu phút trước khi bị huỷ?`,
    paymentWindowValue: (mins: number) => `Huỷ sau ${mins} phút kể từ khi đặt`,
    paymentWindowSet: (label: string, mins: number) =>
      `${label}: đơn chưa trả sẽ huỷ sau ${mins} phút`,
    paymentWindowInvalid: 'Nhập số phút nguyên từ 1 đến 1440.',
    manualTitle: 'Phương thức bạn tự thêm',
    manualIntro:
      'Chuyển khoản, VietQR hoặc ví điện tử bạn tự cấu hình - bạn nhập thông tin tài khoản + QR, khách trả offline rồi upload biên lai. Khác với nhà cung cấp phía trên, loại này không thu tự động.',
    none: 'Chưa kết nối nhà cung cấp thanh toán nào.',
    connect: '+ Kết nối nhà cung cấp',
    update: 'Cập nhật',
    live: 'Thật',
    testMode: 'Chế độ thử',
    providerPaypal: 'PayPal Business',
    providerPaycat: 'Menucat (thẻ)',
    activatedToast: 'Đã dùng cho thanh toán online',
    deactivatedToast: 'Đã tắt thanh toán online',
    connectTitle: 'Kết nối nhà cung cấp',
    updateTitle: 'Cập nhật kết nối',
    providerLabel: 'Nhà cung cấp',
    paypalChoice: 'PayPal Business',
    paycatChoice: 'Menucat',
    paypalCredsTitle: 'Thông tin API PayPal',
    clientId: 'Client ID',
    clientIdPlaceholder: 'Từ app PayPal Business của bạn',
    secret: 'Secret',
    secretPlaceholder: 'Dán app secret',
    webhookId: 'Webhook ID (tùy chọn)',
    webhookIdPlaceholder: 'Bật xác nhận thanh toán tức thì',
    paypalFooter:
      'Tạo một REST app trong tài khoản PayPal Business (Developer Dashboard) và dán Client ID + Secret vào đây. Tiền sẽ về thẳng tài khoản PayPal của bạn.',
    webhookFooter:
      'Khi kết nối, hệ thống tự đăng ký webhook với PayPal để xác nhận đơn đã trả tức thì - không cần thao tác gì. Nếu không đăng ký được, đơn vẫn xác nhận, chỉ chậm hơn chút (kiểm tra mỗi phút).',
    paycatCredsTitle: 'Thông tin Paycat',
    serviceUrl: 'URL dịch vụ',
    tenantId: 'Tenant ID',
    tenantSecret: 'Tenant secret',
    settingsTitle: 'Cài đặt',
    useForCheckout: 'Dùng cho thanh toán online',
    useForCheckoutHelp:
      'Hiện nhà cung cấp này khi khách thanh toán. Các nhà cung cấp chạy song song - bật cái này không tắt cái khác, khách tự chọn. Chỉ khoá Test và Live của CÙNG nhà cung cấp mới loại trừ nhau.',
    settingsFooter:
      'Bật Dùng cho thanh toán online sẽ hiện nhà cung cấp này - ở chế độ chọn phía trên - bên cạnh những cái đang chạy. Nhập khoá thật kèm bật tuỳ chọn này để chuyển nhà cung cấp này sang thật chỉ trong một bước.',
    errNoWhitespace: 'Bỏ khoảng trắng — khóa API không có khoảng trắng.',
    errClientIdEmail:
      'Cái này trông giống email đăng nhập PayPal, không phải Client ID của ứng dụng REST.',
    errInvalidUrl: 'Nhập địa chỉ https:// hợp lệ.',
    errCheck: 'Kiểm tra lại.',
    connectFailed: 'Không kết nối được nhà cung cấp thanh toán. Vui lòng thử lại.',
    connectedToast: 'Đã kết nối nhà cung cấp thanh toán',
    unsavedTitle: 'Chưa lưu',
    unsavedText: (name) => `Bạn đã nhập thông tin cho ${name}. Lưu lại, hay bỏ và chuyển?`,
    save: 'Lưu',
    discardSwitch: 'Bỏ & chuyển',
    cancel: 'Hủy',
    disconnect: 'Ngắt kết nối',
    disconnectConfirm:
      'Ngắt kết nối nhà cung cấp này? Thông tin đã lưu sẽ bị xoá - muốn dùng lại phải nhập lại từ đầu.',
    disconnectedToast: 'Đã ngắt kết nối nhà cung cấp',
    notConnected: 'Chưa kết nối',
    connectShort: 'Kết nối',
    overwriteNote:
      'Provider này đã được kết nối. Lưu sẽ ghi đè kết nối cũ - mỗi provider chỉ giữ một.',
    modeTest: 'Sandbox',
    modeLive: 'Thật',
    stateConnected: 'Đã kết nối',
    stateActive: 'Đang dùng - khách trả ở đây',
    sandboxBannerTitle: 'Đang ở chế độ Sandbox',
    sandboxBannerBody:
      'Cửa hàng đang ở chế độ SANDBOX - khách KHÔNG bị trừ tiền thật. Chuyển nhà cung cấp đang dùng sang Thật để nhận thanh toán thật.',
    modeSectionTitle: 'Khoá Sandbox hay Thật',
    modeSectionFooter:
      'Chọn bộ khoá bạn đang nhập. Sandbox dùng môi trường thử của nhà cung cấp và không bao giờ trừ tiền thật; Thật nhận thanh toán thật. Bạn có thể lưu cả hai và chuyển bất cứ lúc nào.',
    modeHasCreds: 'Đã có khoá lưu cho chế độ này - lưu sẽ ghi đè.',
    modeNoCreds: 'Chưa có khoá nào lưu cho chế độ này.',
    downgradeTitle: 'Chuyển sang Sandbox?',
    downgradeText:
      'Cửa hàng sẽ NGỪNG nhận tiền thật và chuyển sang chế độ SANDBOX (thử). Tiếp tục?',
    // ── Checkout badges: an owner-written pill beside ONE payment method ──
    badgesTitle: 'Nhãn ở trang thanh toán',
    badgesFooter:
      'Ghi chú ngắn cạnh một hình thức thanh toán, ví dụ “Nên chọn”. Khách sẽ thấy đúng như bạn nhập.',
    badgeDialogTitle: 'Nhãn thanh toán',
    badgePrompt: (method: string) =>
      `Chữ hiển thị cạnh ${method} khi thanh toán. Để trống để xóa nhãn.`,
    badgeNone: 'Không có nhãn',
    badgeTooLong: (max: number) => `Tối đa ${max} ký tự.`,
    badgeSetToast: (method: string) => `Đã thêm nhãn cho ${method}`,
    badgeClearedToast: (method: string) => `Đã xóa nhãn của ${method}`,
    badgeMethodCash: 'Tiền mặt',
    badgeMethodCardOnHandoff: 'Thẻ khi nhận hàng',
  },

  nav: {
    operations: 'Vận hành',
    functionality: 'Chức năng',
    reservations: 'Đặt bàn',
    orders: 'Đơn hàng',
    tables: 'Bàn',
    customers: 'Khách hàng',
    menu: 'Thực đơn',
    discount: 'Khuyến mãi',
    reports: 'Báo cáo',
    customerService: 'Chăm sóc khách hàng',
    settings: 'Cài đặt',
    actionCenter: 'Trung tâm thao tác',
    pendingQueue: 'Hàng chờ',
    aiAssistant: 'Trợ lý AI',
    inbox: 'Hộp thư',
    collapse: 'Thu gọn',
    expand: 'Mở rộng',
  },

  views: {
    list: 'Danh sách',
    timeline: 'Dòng thời gian',
    week: 'Tuần',
    plan: 'Sơ đồ',
  },

  settings: {
    title: 'Cài đặt',
    searchSettings: 'Tìm cài đặt',
    dashboard: 'Bảng điều khiển',
    account: 'Tài khoản',
    email: 'Email',
    restaurant: 'Nhà hàng',
    reservations: 'Đặt bàn',
    capacity: 'Sức chứa',
    tables: 'Bàn',
    tablePlan: 'Sơ đồ bàn',
    menu: 'Thực đơn',
    menus: 'Thực đơn, danh mục & món ăn',
    myRestaurant: 'Nhà hàng của tôi',
    storefront: 'Cửa hàng',
    notifications: 'Thông báo',
    pushNotifications: 'Thông báo đẩy',
    restaurantSetup: 'Hồ sơ doanh nghiệp',
    switchRestaurant: 'Đổi nhà hàng',
    searchRestaurants: 'Tìm nhà hàng',
    noRestaurantsMatch: 'Không có nhà hàng phù hợp',
    switchRestaurantConfirm: 'Chuyển sang nhà hàng khác?',
    language: 'Ngôn ngữ',
    mail: {
      title: 'Thông báo',
      reservationTitle: 'Đặt bàn',
      reservationCustomer: 'Gửi email cho khách về lượt đặt bàn',
      reservationOwner: 'Thông báo trên app cho chủ & nhân viên khi có đặt bàn mới',
      reservationOwnerEmail: 'Email cho chủ & nhân viên khi có đặt bàn mới',
      reservationReminder: 'Gửi email nhắc khách trước giờ đặt bàn',
      customerPickupTitle: 'Email cho khách về đơn lấy tại quầy',
      customerDeliveryTitle: 'Email cho khách về đơn giao hàng',
      ownerPickupTitle: 'Email cho chủ & nhân viên về đơn lấy tại quầy',
      ownerDeliveryTitle: 'Email cho chủ & nhân viên về đơn giao hàng',
      pushPickupTitle: 'Thông báo trên app về đơn lấy tại quầy',
      pushDeliveryTitle: 'Thông báo trên app về đơn giao hàng',
      customerGroup: 'Email cho khách',
      ownerGroup: 'Thông báo trên app cho bạn & nhân viên',
      byOrderType: 'theo loại đơn',
      byPayment: 'theo phương thức thanh toán',
      ownerEmailGroup: 'Email cho chủ & nhân viên',
      allMaster: 'Tất cả phương thức',
      cash: 'Tiền mặt',
      manual: 'Chuyển khoản',
      online: 'Thẻ / PayPal',
      customerNote:
        'Tắt = khách không nhận email cho phương thức đó. Trạng thái đơn trong app vẫn cập nhật.',
      ownerNote: 'Tắt = bạn và nhân viên không nhận push/hộp thư cho đơn mới trả theo cách đó.',
    },
  },

  notifications: {
    title: 'Thông báo đẩy',
    statusTitle: 'Trạng thái thông báo',
    deviceIphone: 'iPhone hoặc iPad này',
    deviceAndroid: 'Thiết bị Android này',
    deviceBrowser: 'Trình duyệt này',
    statusOn: 'Bật',
    statusOnDetail: 'Bạn sẽ nhận cảnh báo trên thiết bị này theo thời gian thực.',
    statusOff: 'Tắt',
    statusOffDetail: 'Cảnh báo chưa được bật. Bật để được thông báo theo thời gian thực.',
    statusBlocked: 'Đã chặn',
    statusBlockedNative: 'Thông báo đang bị chặn. Bật cho ứng dụng này trong Cài đặt thiết bị.',
    statusBlockedWeb:
      'Thông báo đang bị chặn. Bật trong cài đặt trang của trình duyệt, rồi tải lại trang này.',
    statusBrowserBlocked: 'Bị trình duyệt chặn',
    statusBrowserBlockedDetail:
      'Trình duyệt này chặn thông báo đẩy. Trên Brave, mở Cài đặt → Quyền riêng tư và bảo mật rồi bật “Use Google services for push messaging”, sau đó khởi động lại Brave. Hoặc dùng Chrome hay ứng dụng trên điện thoại.',
    statusUnsupported: 'Không hỗ trợ',
    statusUnsupportedDetail: 'Trình duyệt này không nhận được thông báo đẩy.',
    statusUnconfigured: 'Không khả dụng',
    statusUnconfiguredDetail: 'Thông báo đẩy chưa được thiết lập trong bản dựng này.',
    statusChecking: 'Đang kiểm tra…',
    statusCheckingDetail: 'Đang kiểm tra quyền thông báo…',
    enableButton: 'Bật thông báo',
    reservationSection: 'Đặt bàn',
    newBooking: 'Đặt bàn mới',
    cancellation: 'Khách hủy đặt bàn',
    noShow: 'Cảnh báo vắng mặt',
    orderSection: 'Đặt món trực tuyến',
    prepSection: 'Thời gian bếp',
    prepReminder: 'Nhắc bắt đầu chuẩn bị',
    prepReminderHint:
      'Báo cho nhân viên khi đến lúc nấu đơn đặt trước, tính ngược từ giờ giao/nhận.',
    hint: 'Chọn các sự kiện bạn muốn được cảnh báo theo thời gian thực. Cảnh báo chỉ đến khi trạng thái phía trên là "Bật".',
    testSection: 'Thông báo thử',
    testDelayTitle: 'Gửi sau',
    testDelaySeconds: (n) => `${n} giây`,
    testButton: 'Gửi thông báo thử',
    testHint:
      'Nhấn nút rồi thoát khỏi ứng dụng - thông báo thử sẽ đến thiết bị này sau khoảng thời gian bạn chọn.',
    testPushTitle: 'Thông báo thử',
    testPushBody: 'Thông báo đẩy đang hoạt động trên thiết bị này.',
    testScheduled: (n) => `Đã gửi thông báo thử - sẽ đến sau ${n} giây.`,
    testNoDevice: 'Chưa có thiết bị nào được đăng ký. Hãy bật thông báo trước.',
  },

  reservations: {
    pause: {
      cellLabel: 'Đặt bàn',
      open: 'Đang mở',
      off: 'Đã tắt',
      pausedUntilClose: 'Tạm dừng · đóng cửa',
      pausedUntilTime: (time) => `Tạm dừng · ${time}`,
      action: {
        heading: 'Đặt bàn',
        pause30: 'Tạm dừng 30 phút',
        pause1hour: 'Tạm dừng 1 giờ',
        pauseHours: (n) => `Tạm dừng ${n} giờ`,
        pauseUntilClose: 'Tạm dừng đến giờ đóng cửa',
        resumeNow: 'Tiếp tục ngay',
        cancel: 'Hủy',
      },
      toast: {
        pausedFor: (minutes) => `Đã tạm dừng đặt bàn trong ${minutes} phút`,
        pausedUntilClose: 'Đã tạm dừng đặt bàn đến giờ đóng cửa',
        resumed: 'Đã tiếp tục nhận đặt bàn',
      },
    },
    title: 'Đặt bàn',
    pending: 'Chờ xác nhận',
    upcoming: 'Sắp tới',
    today: 'Hôm nay',
    newReservation: 'Đặt bàn mới',
    detailTitle: 'Đặt bàn',
    guest: 'Khách',
    guests: 'Khách',
    partyOf: 'Nhóm',
    notes: 'Ghi chú',
    all: 'Tất cả',
    filterAria: 'Bộ lọc',
    status: {
      PENDING: 'Chờ xác nhận',
      CONFIRMED: 'Đã xác nhận',
      CANCELLED: 'Đã hủy',
      REJECTED: 'Từ chối',
      NO_SHOW: 'Không đến',
      ARRIVED: 'Đã đến',
      COMPLETED: 'Hoàn thành',
    },
    actions: {
      confirm: 'Xác nhận',
      reject: 'Từ chối',
      cancel: 'Hủy',
      noShow: 'Không đến',
      arrived: 'Đánh dấu đã đến',
    },
    count: (n) => `${n} lượt đặt`,
    covers: (bookings, guests) => `${bookings} hẹn · ${guests} khách`,
    peak: (time, guests) => `Cao điểm ${time} · ${guests} khách`,
    nextWindow: (guests) => `2 giờ tới: ${guests} khách`,
    guestsCount: (guests) => `${guests} khách`,
    guestsByHour: 'Khách theo giờ',
    nowLabel: 'Bây giờ',
    slotCap: (n) => `tối đa ${n}/khung`,
    advCap: (pacing, concurrent) => `${pacing}/15' · ${concurrent} cùng lúc`,
    defaultShift: 'Mặc định',
    displayStatus: {
      pending: 'Chờ xác nhận',
      confirmed: 'Đã xác nhận',
      rejected: 'Từ chối',
      cancelled: 'Đã hủy',
      rescheduled: 'Đã đổi lịch',
      waiting: 'Chờ đến',
      arrived: 'Đã đến',
      seated: 'Đã xếp bàn',
      'in-progress': 'Đang phục vụ',
      completed: 'Hoàn thành',
      'no-show': 'Không đến',
    },
    occasion: {
      BIRTHDAY: '🎂 Sinh nhật',
      ANNIVERSARY: '💛 Kỷ niệm',
      DATE: '🌹 Hẹn hò',
      BUSINESS: '💼 Công việc',
    },
    seating: {
      WINDOW: 'Cạnh cửa sổ',
      OUTDOOR: 'Ngoài trời',
      QUIET: 'Góc yên tĩnh',
      BOOTH: 'Bàn khoang',
      BABY_CHAIR: 'Ghế em bé',
      HIGH_CHAIR: 'Ghế cao',
      WHEELCHAIR_ACCESS: 'Lối cho xe lăn',
      GROUND_FLOOR: 'Tầng trệt',
      NO_PREFERENCE: 'Không yêu cầu',
    },
    swipe: { accept: 'Chấp nhận', decline: 'Từ chối' },
    toast: {
      confirmed: 'Đã xác nhận đặt bàn',
      rejected: 'Đã từ chối đặt bàn',
      cancelled: 'Đã hủy đặt bàn',
      arrived: 'Đã đánh dấu đã đến',
      seated: 'Đã đánh dấu đã xếp bàn',
      inProgress: 'Đã đánh dấu đang phục vụ',
      completed: 'Đã đánh dấu hoàn thành',
      noShow: 'Đã đánh dấu không đến',
    },
    errors: {
      confirm: 'Không thể xác nhận đặt bàn.',
      reject: 'Không thể từ chối đặt bàn.',
      cancel: 'Không thể hủy đặt bàn.',
    },
    prompts: {
      rejectReason: 'Lý do từ chối:',
      rejectTitle: 'Từ chối đặt bàn',
      cancelConfirm: 'Hủy đặt bàn này?',
      cancelTitle: 'Hủy đặt bàn',
    },
    empty: {
      errorTitle: 'Lỗi khi tải đặt bàn',
      errorDesc: 'Vui lòng thử lại.',
      noneTitle: 'Chưa có đặt bàn',
      noneDesc: 'Không có đặt bàn cho ngày này.',
      timelineTitle: 'Chưa có gì để hiển thị',
      timelineDesc: 'Thêm bàn trong thiết lập sức chứa, các lượt đặt sẽ hiện tại đây dạng thanh.',
      planTitle: 'Chưa có bàn nào',
      planDesc: 'Thêm bàn trong Cài đặt → Thiết lập đặt bàn để xem sơ đồ mặt bằng.',
    },
    pendingQueue: {
      title: (n) => `Chờ xác nhận (${n})`,
      emptyTitle: 'Đã xử lý hết!',
      emptyDesc: 'Không có đặt bàn nào chờ duyệt.',
      filterByDate: 'Lọc theo ngày',
      showAll: 'Xem tất cả',
      emptyDateTitle: 'Không có đơn ngày này',
      emptyDateDesc: 'Không có đặt bàn chờ duyệt cho ngày đã chọn.',
    },
    source: {
      ONLINE: 'Trực tuyến',
      PHONE: 'Điện thoại',
      WALK_IN: 'Khách vãng lai',
      THIRD_PARTY: 'Bên thứ ba',
    },
    plan: {
      noZone: 'Không có khu vực',
      seatCount: (seats) => `${seats} chỗ ngồi`,
      tableAria: (name, seats) => `Bàn ${name}, ${seats} chỗ ngồi`,
    },
    timeline: {
      unzoned: 'Chưa phân khu vực',
      unassignedCount: (n) => `Chưa xếp bàn · ${n}`,
    },
    week: {
      summary: (count, covers) => `${count} · ${covers} khách`,
      none: 'Chưa có đặt bàn',
    },
    detail: {
      labels: 'Nhãn',
      none: 'Chưa chọn đặt bàn',
      noneDesc: 'Chọn một lượt đặt từ danh sách để xem chi tiết tại đây.',
      notFound: 'Không tìm thấy đặt bàn',
      minutesShort: 'phút',
      conflict: (n) => `${n} lượt đặt khác trong khung giờ này`,
      call: 'Gọi',
      message: 'Nhắn tin',
      phoneCopied: 'Đã copy số điện thoại',
      status: 'Trạng thái',
      specialRequests: 'Yêu cầu đặc biệt',
      occasion: 'Dịp',
      seating: 'Chỗ ngồi & lối vào',
      guestInfo: 'Thông tin khách',
      phone: 'Điện thoại',
      email: 'Email',
      source: 'Nguồn',
      internalNote: 'Ghi chú nội bộ',
      cancellationReason: 'Lý do hủy',
      timeline: 'Dòng thời gian',
      events: {
        created: 'Đã tạo',
        confirmed: 'Đã xác nhận',
        arrived: 'Đã đến',
        completed: 'Hoàn thành',
        cancelled: 'Đã hủy',
        noShow: 'Không đến',
      },
      aria: {
        close: 'Đóng',
        call: 'Gọi cho khách',
        message: 'Nhắn tin cho khách',
        edit: 'Sửa đặt bàn',
      },
    },
    menu: {
      confirm: 'Xác nhận đặt bàn',
      decline: 'Từ chối đặt bàn',
      cancel: 'Hủy đặt bàn',
      reactivate: 'Khôi phục đặt bàn',
      markArrived: 'Đánh dấu đã đến',
      markSeated: 'Đánh dấu đã xếp bàn',
      markNoShow: 'Đánh dấu không đến',
      markCompleted: 'Đánh dấu hoàn thành',
      markNotStarted: 'Chưa bắt đầu',
      markInProgress: 'Đang diễn ra',
      markRescheduled: 'Đổi lịch',
    },
  },

  audit: {
    orderKind: {
      CREATED: 'Đã đặt',
      CONFIRMED: 'Đã xác nhận',
      COMPLETED: 'Đã hoàn tất',
      CANCELLED: 'Đã hủy',
      PROOF_UPLOADED: 'Đã tải lên chứng từ thanh toán',
      PROOF_ACCEPTED: 'Đã chấp nhận chứng từ thanh toán',
      PROOF_REJECTED: 'Đã từ chối chứng từ thanh toán',
      PAYMENT_COLLECTED: 'Đã nhận thanh toán',
      PAYMENT_VOIDED: 'Đã hủy thanh toán',
      REFUND_ISSUED: 'Đã hoàn tiền',
      PREP_REMINDER_SENT: 'Đã gửi nhắc chuẩn bị',
      PREP_ADVANCED: 'Đã bắt đầu chuẩn bị',
      PREP_RECALLED: 'Đã thu hồi chuẩn bị',
    },
    reservationEvent: {
      CREATED: 'Đã tạo',
      CONFIRMED: 'Đã xác nhận',
      REJECTED: 'Đã từ chối',
      CANCELLED_BY_GUEST: 'Khách hủy',
      CANCELLED_BY_STAFF: 'Nhân viên hủy',
      MODIFIED: 'Đã chỉnh sửa',
      REACTIVATED: 'Đã kích hoạt lại',
      AUTO_ARRIVED: 'Tự động ghi nhận đến',
      AUTO_COMPLETED: 'Tự động hoàn tất',
      NO_SHOW_ALERTED: 'Đã báo vắng mặt',
      ARRIVAL_MARKED: 'Đã cập nhật đến',
      STATUS_CHANGED: 'Đã đổi trạng thái',
    },
    actor: {
      OWNER: 'Chủ nhà hàng',
      STAFF: 'Nhân viên',
      CUSTOMER: 'Khách hàng',
      SYSTEM: 'Hệ thống',
      GUEST: 'Khách',
    },
  },

  restaurantSetup: {
    title: 'Thiết lập nhà hàng',
    basicInfo: 'Thông tin cơ bản',
    hours: 'Giờ mở cửa',
    basicInfoSection: 'Thông tin cơ bản',
    venueLanguageSection: 'Ngôn ngữ',
    venueLanguage: 'Ngôn ngữ nhà hàng',
    venueLanguageFooter:
      'Ngôn ngữ dùng trên phiếu in và làm mặc định cho bảng điều khiển và cửa hàng trực tuyến.',
    name: 'Tên nhà hàng',
    namePlaceholder: 'Nhà hàng của tôi',
    description: 'Mô tả',
    descriptionPlaceholder: 'Mô tả ngắn hiển thị cho khách hàng',
    address: 'Đường và số nhà',
    addressPlaceholder: '123 Đường Chính',
    postalCode: 'Mã bưu chính',
    postalCodePlaceholder: '10115',
    city: 'Thành phố',
    cityPlaceholder: 'Berlin',
    country: 'Quốc gia',
    contactEmail: 'Email liên hệ',
    contactEmailPlaceholder: 'xin.chao@nha-hang.com',
    contactPhone: 'Điện thoại liên hệ',
    contactPhonePlaceholder: '+84 28 1234 5678',
    contactPhoneInvalid: 'Nhập số điện thoại hợp lệ như +84 28 1234 5678.',
    socialSection: 'Mạng xã hội & website',
    facebookUrl: 'Facebook',
    facebookUrlPlaceholder: '@nhahangcuatoi',
    instagramUrl: 'Instagram',
    instagramUrlPlaceholder: '@nhahangcuatoi',
    tiktokUrl: 'TikTok',
    tiktokUrlPlaceholder: '@nhahangcuatoi',
    websiteUrl: 'Website',
    websiteUrlPlaceholder: 'nhahangcuatoi.com',
    socialFooter:
      'Hiển thị cho khách trên trang đặt món của bạn. Có thể dán link đầy đủ hoặc chỉ tên tài khoản. Để trống để gỡ link.',
    openingHours: 'Giờ mở cửa',
    closed: 'Đóng cửa',
    openingHoursNote: 'Để chỉnh sửa giờ mở cửa, vui lòng liên hệ hỗ trợ.',
    saveFailed: 'Lưu thất bại',
  },

  editReservation: {
    title: 'Chỉnh sửa Đặt bàn',
    date: 'Ngày',
    time: 'Giờ',
    partySize: 'Số khách',
    duration: 'Thời lượng (phút)',
    guestName: 'Tên khách',
    guestEmail: 'Email khách',
    guestPhone: 'SĐT khách',
    internalNote: 'Ghi chú nội bộ',
    save: 'Lưu',
    sectionWhen: 'Thời gian & số khách',
    sectionGuest: 'Khách',
    sectionOccasion: 'Dịp',
    sectionSeating: 'Chỗ ngồi & lối vào',
    sectionInternal: 'Nội bộ',
    guestNamePlaceholder: 'Tên khách',
    notePlaceholder: 'Ghi chú nội bộ…',
    updated: 'Đã cập nhật đặt bàn',
    updateFailed: 'Không thể cập nhật đặt bàn.',
  },

  createReservation: {
    fullName: 'Họ và tên',
    namePlaceholder: 'vd. Nguyễn Văn A',
    existingGuests: 'Khách hiện có - chạm để dùng lại',
    searchExistingPlaceholder: 'Tìm theo tên hoặc số điện thoại…',
    change: 'Đổi',
    sectionBooking: 'Đặt bàn',
    submit: 'Tạo',
    created: 'Đã tạo đặt bàn',
    createFailed: 'Không thể tạo đặt bàn. Vui lòng thử lại.',
    nameRequired: 'Vui lòng nhập tên khách.',
    nameInvalid: 'Tên khách không được chứa số hoặc ký tự đặc biệt.',
    emailInvalid:
      'Nhập email hợp lệ như name@example.com - không có khoảng trắng hay dấu chấm liền nhau (..). Hoặc để trống.',
    phoneInvalid: 'Nhập số điện thoại hợp lệ - 7 đến 14 chữ số, không tính mã quốc gia.',
    phoneRequired: 'Đặt bàn qua điện thoại cần có số điện thoại.',
    timeInPast: 'Giờ đặt bàn đã trôi qua. Vui lòng chọn ngày hoặc giờ muộn hơn.',
    timeRequired: 'Vui lòng nhập giờ đặt bàn.',
    optional: '(không bắt buộc)',
    noRestaurant: 'Chưa chọn nhà hàng.',
    returningGuest: (n: number) => `Đã đặt ${n} lần`,
    partySizeOverLimit: (max: number) => `Vượt quá giới hạn ${max} khách`,
    partySizeOverLimitTitle: 'Nhóm lớn',
    partySizeOverLimitConfirm: (max: number) => `Số khách vượt giới hạn ${max}. Vẫn tạo đặt bàn?`,
    slotFullWarning: 'Khung giờ này đã đạt giới hạn sức chứa.',
    slotFullTitle: 'Khung giờ đã đầy',
    slotFullConfirm: 'Khung giờ này đã đạt giới hạn sức chứa. Vẫn tạo đặt bàn?',
  },

  aiAssistant: {
    title: 'Trợ lý',
    conversations: 'Cuộc trò chuyện',
    archived: 'Đã lưu trữ',
    noConversations: 'Chưa có cuộc trò chuyện nào.',
    untitled: 'Cuộc trò chuyện mới',
    newChat: 'Trò chuyện mới',
    threadActions: 'Tùy chọn cuộc trò chuyện',
    loadingConversation: 'Đang tải cuộc trò chuyện…',
    loadHistoryError: 'Không tải được cuộc trò chuyện này.',
    loadThreadsError: 'Không tải được danh sách cuộc trò chuyện.',
    retry: 'Thử lại',
    greetingTitle: 'Xin chào',
    greetingBody: 'Hôm nay tôi có thể giúp gì cho bạn?',
    attachImage: 'Đính kèm ảnh',
    removeAttachment: 'Gỡ tệp đính kèm',
    attachment: 'Ảnh',
    uploading: 'Đang tải lên…',
    uploadFailed: 'Tải lên thất bại',
    inputPlaceholder: 'Nhắn cho trợ lý…',
    send: 'Gửi',
    stop: 'Dừng',
    sendFailed: 'Trợ lý không thể trả lời. Vui lòng thử lại.',
    rename: 'Đổi tên',
    archive: 'Lưu trữ',
    unarchive: 'Khôi phục',
    delete: 'Xóa',
    cancel: 'Hủy',
    deleteTitle: 'Xóa cuộc trò chuyện này?',
    threadActionFailed: 'Không cập nhật được cuộc trò chuyện.',
    approve: 'Đồng ý',
    deny: 'Từ chối',
    approvalPending: 'Đang chờ bạn xác nhận',
    approvalDenied: 'Đã từ chối',
    approvalRunning: 'Đang áp dụng…',
    approvalDone: 'Đã áp dụng',
    approvalFailed: 'Không áp dụng được thay đổi',
    toolWorking: 'Đang xử lý…',
    toolFailed: 'Thất bại',
    tools: {
      get_menu: 'Thực đơn',
      get_item_availability: 'Tình trạng món',
      set_prices: 'Đổi giá',
      set_item_availability: 'Đổi tình trạng món',
      manage_products: 'Sửa món',
      manage_categories: 'Sửa danh mục',
      list_reservations: 'Đặt bàn',
      get_reservation: 'Chi tiết đặt bàn',
      check_availability: 'Kiểm tra chỗ trống',
      create_reservation: 'Đặt bàn mới',
      cancel_reservation: 'Hủy đặt bàn',
      assign_tables: 'Xếp bàn',
      search_customers: 'Tìm khách hàng',
      get_customer: 'Chi tiết khách hàng',
      create_customer: 'Khách hàng mới',
      get_opening_hours: 'Giờ mở cửa',
      get_profile: 'Hồ sơ nhà hàng',
      update_opening_hours: 'Đổi giờ mở cửa',
      update_profile: 'Cập nhật hồ sơ',
      toggle_online_ordering: 'Đặt món online',
      toggle_table_ordering: 'Gọi món tại bàn',
      get_table_state: 'Tình trạng bàn',
      list_open_tabs: 'Hóa đơn đang mở',
      get_session: 'Chi tiết hóa đơn',
      fire_round: 'Gửi món xuống bếp',
      void_item: 'Hủy món',
      take_payment: 'Ghi nhận thanh toán',
      close_tab: 'Đóng hóa đơn',
      move_session: 'Chuyển bàn',
      get_revenue: 'Doanh thu',
      get_covers: 'Lượt khách',
      get_top_dishes: 'Món bán chạy',
      get_peak_hours: 'Giờ cao điểm',
    },
    summary: {
      price: (name, price) => `${name}: ${price}`,
      inStock: (name) => `${name}: còn món`,
      soldOut: (name) => `${name}: hết món`,
      create: (name) => `Tạo “${name}”`,
      update: (name) => `Sửa “${name}”`,
      rename: (from, to) => `Đổi tên “${from}” thành “${to}”`,
      remove: (name) => `Xóa “${name}”`,
      reservation: (name, date, time, party) => `${name} · ${date} ${time} · ${party} khách`,
      tables: (name, tables) => `${name}: ${tables}`,
      hoursDay: (day, hours) => `${day}: ${hours}`,
      closed: 'đóng cửa',
      on: 'Bật',
      off: 'Tắt',
      pickup: 'Mang đi',
      delivery: 'Giao hàng',
      table: (label) => `Bàn ${label}`,
      move: (from, to) => `Bàn ${from} → bàn ${to}`,
      cash: 'Tiền mặt',
      bankTransfer: 'Chuyển khoản',
      tip: (amount) => `Tiền tip: ${amount}`,
      profileFields: {
        name: 'Tên',
        address: 'Địa chỉ',
        phone: 'Điện thoại',
        email: 'Email',
        description: 'Mô tả',
      },
    },
    widgets: {
      reservationsTitle: (date) => `Đặt bàn · ${date}`,
      reservationsSummary: (count, guests) => `${count} lượt đặt · ${guests} khách`,
      noReservations: 'Không có đặt bàn.',
      partySize: (count) => `${count} khách`,
      status: {
        PENDING: 'Chờ xác nhận',
        CONFIRMED: 'Đã xác nhận',
        REJECTED: 'Đã từ chối',
        CANCELLED: 'Đã hủy',
      },
      revenueTitle: 'Doanh thu',
      netSales: 'Doanh thu thuần',
      grossSales: 'Doanh thu gộp',
      orders: 'Đơn hàng',
      online: 'Online',
      dineIn: 'Tại bàn',
      covers: 'Lượt khách',
      tips: 'Tiền tip',
      availabilityTitle: 'Tình trạng món',
      availabilitySummary: (total, soldOut) => `${total} món · ${soldOut} hết món`,
      soldOut: 'Hết món',
      inactive: 'Đã ẩn',
    },
  },

  auth: {
    title: 'Bảng điều khiển nhà hàng',
    subtitle: 'Đăng nhập để quản lý nhà hàng của bạn',
    emailLabel: 'Email',
    emailPlaceholder: 'ban@nhahang.com',
    passwordLabel: 'Mật khẩu',
    passwordPlaceholder: '••••••••',
    signInButton: 'Đăng nhập',
    validation: {
      emailPasswordRequired: 'Nhập email và mật khẩu của bạn.',
      invalidCredentials: 'Email hoặc mật khẩu không đúng. Vui lòng thử lại.',
    },
    selectRestaurant: {
      title: 'Chọn nhà hàng',
      loading: 'Đang tải nhà hàng của bạn...',
      empty: 'Không tìm thấy nhà hàng nào',
      noAccess: 'Tài khoản của bạn không có quyền truy cập nhà hàng nào.',
      loadError: 'Không thể tải thông tin người dùng.',
    },
  },

  customers: {
    title: 'Khách hàng',
    searchPlaceholder: 'Tìm theo tên, email hoặc số điện thoại',
    loadingError: 'Không thể tải khách hàng',
    loadingErrorDescription: 'Kiểm tra kết nối và thử lại.',
    noMatches: 'Không có kết quả',
    noMatchesDescription: 'Không có khách hàng nào khớp với tìm kiếm này.',
    empty: 'Chưa có khách hàng',
    emptyDescription: 'Khách hàng sẽ xuất hiện ở đây sau khi họ đặt bàn hoặc đặt hàng.',
    visitCount: (count) => `${count} lượt ghé`,
    create: {
      title: 'Khách hàng mới',
      firstName: 'Tên',
      lastName: 'Họ',
      phone: 'Số điện thoại',
      email: 'Email',
      dateOfBirth: 'Ngày sinh',
      notes: 'Ghi chú',
      required: 'Bắt buộc',
      optional: 'Tùy chọn',
      notesPlaceholder: 'Ghi chú nội bộ về khách hàng này',
      submit: 'Thêm khách hàng',
      submitting: 'Đang thêm…',
      fixErrors: 'Vui lòng điền các trường bắt buộc.',
      requiredError: 'Trường này là bắt buộc.',
      invalidEmail: 'Nhập email hợp lệ như name@example.com (địa chỉ đầy đủ).',
      created: 'Đã tạo khách hàng',
      createdPhoneError: 'Đã tạo khách hàng - không thể lưu số điện thoại',
      createFailed: 'Không thể tạo khách hàng. Vui lòng thử lại.',
    },
    detail: {
      title: 'Khách hàng',
      done: 'Xong',
      loadingError: 'Không thể tải khách hàng',
      profile: 'Hồ sơ',
      firstName: 'Tên',
      lastName: 'Họ',
      emailLabel: 'Email',
      emailPlaceholder: 'Tùy chọn',
      dateOfBirth: 'Ngày sinh',
      phoneNumbers: 'Số điện thoại',
      primary: 'Số chính',
      noPhoneNumbers: 'Không có số điện thoại',
      addPhoneButton: 'Thêm số điện thoại',
      addPhoneDialog: 'Số điện thoại',
      phoneAdded: 'Đã thêm số điện thoại',
      removePhoneConfirm: (phone) => `Xóa số điện thoại ${phone}?`,
      removePhoneDialog: 'Xóa số điện thoại',
      phoneRemoved: 'Đã xóa số điện thoại',
      primarySet: 'Đã đặt làm số chính',
      removeAction: 'Xóa',
      notes: 'Ghi chú',
      notesPlaceholder: 'Ghi chú nội bộ về khách hàng này',
      activity: 'Hoạt động',
      totalVisits: 'Tổng lượt ghé',
      lastVisit: 'Lần ghé gần nhất',
      status: 'Trạng thái',
      active: 'Đang hoạt động',
      activeYes: 'Có',
      activeNo: 'Không',
      customerActivated: 'Đã kích hoạt khách hàng',
      customerDeactivated: 'Đã vô hiệu hóa khách hàng',
      name: 'Tên',
      invalidValue: 'Giá trị không hợp lệ',
      deleteCustomer: 'Xóa khách hàng',
      deleteCustomerFallback: 'khách hàng này',
      deleteCustomerConfirm: (who) => `Xóa ${who}? Họ sẽ bị xóa khỏi danh sách khách hàng của bạn.`,
      deleteCustomerTitle: 'Xóa khách hàng',
      customerDeleted: 'Đã xóa khách hàng',
    },
  },

  emailFeature: {
    validation: {
      recipientRequired: 'Vui lòng nhập địa chỉ email người nhận.',
    },
  },

  giftCards: {
    title: 'Thẻ quà tặng',
    issueSection: 'Phát hành thẻ quà tặng',
    startingBalance: (currency) => `Số dư ban đầu (${currency})`,
    recipientName: 'Tên người nhận (tùy chọn)',
    recipientNamePlaceholder: 'Nguyễn Văn A',
    issuing: 'Đang phát hành…',
    issueCard: 'Phát hành thẻ',
    couldntLoadCards: 'Không thể tải thẻ quà tặng',
    noCardsYet: 'Chưa có thẻ quà tặng',
    noCardsDescription:
      'Phát hành thẻ quà tặng trả trước để khách có thể dùng thanh toán hóa đơn nhà hàng. Nhấn +.',
    detailTitle: 'Thẻ quà tặng',
    voidCardConfirm: (code) => `Hủy ${code}? Số dư còn lại sẽ mất và thẻ không thể sử dụng nữa.`,
    voidCardTitle: 'Hủy thẻ quà tặng',
    enterNonZeroAmount: 'Nhập số tiền khác không (thêm dấu − để trừ).',
    reasonRequired: 'Bắt buộc có lý do.',
    balanceAdjusted: 'Đã điều chỉnh số dư',
    code: 'Mã',
    balance: 'Số dư',
    initial: 'Số tiền ban đầu',
    status: 'Trạng thái',
    recipient: 'Người nhận',
    adjustBalance: 'Điều chỉnh số dư',
    voidCard: 'Hủy thẻ',
    adjustment: (currency) => `Điều chỉnh (${currency}, thêm dấu − để trừ)`,
    adjustmentPlaceholder: '10.00 hoặc -5.00',
    reason: 'Lý do',
    reasonPlaceholder: 'Thiện chí / điều chỉnh',
    applying: 'Đang áp dụng…',
    apply: 'Áp dụng',
    history: 'Lịch sử',
    enterStartingBalance: 'Nhập số dư ban đầu.',
    cardIssued: (code) => `Đã phát hành thẻ quà tặng ${code}`,
    couldntLoadCard: 'Không thể tải thẻ',
  },

  kitchen: {
    title: 'Bếp',
    sourceOnline: 'Đơn trực tuyến',
    sourceDineIn: 'Tại chỗ',
    bumpServed: 'Đã phục vụ',
    bumpStart: 'Bắt đầu',
    bumpReady: 'Sẵn sàng',
    recallAction: 'Gọi lại',
    errorTitle: 'Không thể tải bảng',
    emptyTitle: 'Đã xong tất cả',
    emptyDescription: 'Không có phiếu nào trong hàng đợi.',
    laneCooking: 'Đang nấu',
    laneReadyToServe: 'Sẵn sàng phục vụ',
  },

  loyalty: {
    title: 'Chương trình khách hàng thân thiết',
    pointsBalance: 'Số dư điểm',
    entryType: {
      earned: 'Tích lũy',
      redeemed: 'Đã đổi',
      adjusted: 'Đã điều chỉnh',
    },
    validation: {
      nonZeroAmount: 'Vui lòng nhập số tiền khác không.',
      reasonRequired: 'Bắt buộc có lý do.',
    },
    pointsAdjusted: 'Đã điều chỉnh điểm',
    adjustment: {
      label: 'Điều chỉnh (điểm, + hoặc −)',
      placeholder: 'vd: 50 hoặc -20',
    },
    reason: {
      label: 'Lý do',
      placeholder: 'Thiện chí / điều chỉnh',
    },
    applyAdjustment: 'Áp dụng điều chỉnh',
    adjustPoints: 'Điều chỉnh điểm',
    couldNotLoad: 'Không thể tải cài đặt khách hàng thân thiết',
    program: 'Chương trình khách hàng thân thiết',
    earning: {
      title: 'Tích điểm',
      label: (currency) => `${currency} chi tiêu - điểm tích lũy`,
      info: (currency) => `vd: 1 điểm cho mỗi ${currency} trên tổng phụ món ăn`,
    },
    redemption: {
      title: 'Đổi điểm',
      label: (currency) => `1 điểm trị giá (giảm ${currency})`,
      placeholder: '0.10',
      info: 'Khách đổi điểm để được giảm giá khi thanh toán',
    },
    settingsSaved: 'Đã lưu cài đặt khách hàng thân thiết',
    info: {
      note: 'Điểm được tích trên tổng phụ món ăn của đơn hàng hoặc lượt ghé nhà hàng đã hoàn tất (không gồm phí giao hàng, thuế và tiền tip). Điểm đổi được áp dụng dưới dạng giảm giá cho đơn hàng tiếp theo.',
    },
  },

  menu: {
    title: 'Thực đơn',
    noMenusYet: 'Chưa có thực đơn',
    createMenuDescription: 'Tạo một thực đơn để thêm các mục và món ăn.',
    createMenu: 'Tạo thực đơn',
    menuNamePrompt: 'Tên thực đơn (tiếng Anh)',
    newMenu: 'Thực đơn mới',
    menuCreated: 'Đã tạo thực đơn',
    renameMenu: 'Đổi tên thực đơn',
    editMenuNameAvailability: 'Sửa tên & khả dụng',
    renamed: 'Đã đổi tên',
    cantDeleteActiveMenu: 'Không thể xóa thực đơn đang hoạt động',
    deleteMenuConfirm: (menuName) => `Xóa "${menuName}" cùng tất cả các mục và món ăn của nó?`,
    deleteMenu: 'Xóa thực đơn',
    setAsActiveMenu: 'Đặt làm thực đơn đang hoạt động',
    isNowActive: (menuName) => `"${menuName}" hiện đang hoạt động`,
    activeMenuInfo:
      'Chỉ thực đơn đang hoạt động được hiển thị cho khách hàng. Chạm vào một thực đơn để chỉnh sửa các mục và món ăn của nó.',
    active: 'Đang hoạt động',
    rename: 'Đổi tên',
    newCategory: 'Danh mục mới',
    editCategory: 'Chỉnh sửa danh mục',
    categoryName: 'Tên',
    categoryDescription: 'Mô tả',
    channelVisibility: 'Hiện ở kênh đặt hàng',
    channelVisibilityHelp: 'Tắt để ẩn cả mục này (và các món) ở loại đơn đó.',
    showOnPickup: 'Hiện khi lấy tại quầy',
    showOnDelivery: 'Hiện khi giao hàng',
    nameRequired: 'Bắt buộc nhập tên',
    availabilitySchedule: 'Lịch hiển thị',
    restrictToCertainTimes: 'Giới hạn theo khung giờ nhất định',
    window: (index) => `Khung giờ ${index}`,
    from: 'Từ',
    to: 'Đến',
    addWindow: '+ Thêm khung giờ',
    scheduleNote: 'Lịch sử dụng múi giờ của nhà hàng và độc lập với giờ mở cửa.',
    emptyMenu: 'Thực đơn trống',
    addCategoryDescription: 'Thêm một danh mục như Đồ uống, Món chính hoặc Tráng miệng.',
    addCategory: 'Thêm danh mục',
    dragToReorder: 'Kéo để sắp xếp lại các danh mục',
    renameMenuTooltip: 'Đổi tên thực đơn',
    doneReordering: 'Hoàn tất sắp xếp',
    reorderSections: 'Sắp xếp lại các danh mục',
    archivedItems: 'Món đã xóa',
    archivedItemsTitle: 'Món đã xóa',
    archivedItemsEmpty: 'Không có món đã xóa',
    archivedItemsHint: 'Món đã xóa được giữ ở đây. Khôi phục để đưa món trở lại thực đơn.',
    restore: 'Khôi phục',
    itemRestored: 'Đã khôi phục món',
    reorderOptions: 'Sắp xếp lại tùy chọn',
    dragToReorderOptions: 'Kéo để sắp xếp lại các tùy chọn',
    deleteMenuConfirmText: (menuName) => `Xóa "${menuName}" cùng mọi thứ bên trong?`,
    inactiveMenuNote:
      'Thực đơn này chưa hoạt động - khách hàng chưa nhìn thấy. Dùng ⋯ để kích hoạt.',
    menuActivated: 'Đã kích hoạt thực đơn',
    addItem: 'Thêm món',
    searchItems: 'Tìm món',
    jumpToSection: 'Nhảy tới nhóm',
    noItemsMatch: 'Không có món khớp',
    addMultiple: 'Thêm nhiều món',
    newProducts: 'Món mới',
    allergenLabeling: {
      title: 'Chất gây dị ứng & phụ gia',
      sectionTitle: 'Ghi nhãn chất gây dị ứng',
      sectionHelp: 'Thiết lập các chất gây dị ứng và phụ gia hiển thị trên món ăn của bạn.',
      sectionSubtitle: 'Bảng chất gây dị ứng và danh sách mã của bạn',
      modeHeading: 'Cách bạn ghi nhãn chất gây dị ứng',
      modeNote: 'Chọn cách nhà hàng này liệt kê chất gây dị ứng. Có thể đổi bất cứ lúc nào.',
      aboutMode: (title: string) => `Về ${title}`,
      simpleTitle: 'Bảng tự do',
      simpleFeatures: [
        'Dán văn bản hoặc tải lên một ảnh',
        'Khách thấy đúng như bạn viết',
        'Đơn giản nhất — không cần thiết lập',
      ],
      simpleDetails:
        'Bảng chất gây dị ứng/phụ gia đã in của bạn — văn bản hoặc ảnh — được hiển thị cho khách như nguồn chuẩn. Không xử lý gì cả.',
      advancedTitle: 'Danh sách mã',
      advancedFeatures: [
        'Danh sách mã và ý nghĩa của bạn',
        'Món ăn tham chiếu tới mã của bạn',
        'Nhãn từng món rõ ràng hơn',
      ],
      advancedDetails:
        'Giữ danh sách mã có cấu trúc (ví dụ a = Gluten). Gắn mã cho từng món; khách thấy mã và ý nghĩa của nó.',
      originTextLabel: 'Văn bản hoặc ghi chú',
      originTextPlaceholder: 'Dán chú thích dạng văn bản, hoặc thêm ghi chú giúp đọc ảnh…',
      originImageTitle: 'Ảnh bảng',
      notesHint:
        'Tùy chọn. Kết hợp với ảnh — ví dụ "biểu tượng S và R nghĩa là thịt heo và thịt bò".',
      uploadImage: 'Tải ảnh lên',
      replaceImage: 'Thay ảnh',
      removeImage: 'Xóa',
      imageFailed: 'Tải ảnh thất bại',
      tableTitle: 'Danh sách mã',
      previewTitle: 'Xem trước mã',
      previewHint: 'Từ bảng của bạn. Chuyển sang „Danh sách mã" để chỉnh sửa.',
      previewEmptyText:
        'Mã sẽ xuất hiện ở đây sau khi được thêm trong Danh sách mã (hoặc đọc từ bảng của bạn trong chat).',
      emptyTitle: 'Chưa có mã',
      keyPlaceholder: 'Mã',
      descPlaceholder: 'Mô tả',
      addRow: 'Thêm mã',
      removeRow: 'Xoá mã',
      saved: 'Đã lưu',
      saveFailed: 'Không thể lưu',
      parseFailed: 'Đã lưu, nhưng không đọc được mã. Hãy lưu lại, hoặc thêm trong Danh sách mã.',
      duplicateKey: (key: string) => `Mã trùng: ${key}`,
      kindLabel: (k: 'ALLERGEN' | 'ADDITIVE' | 'DIETARY'): string =>
        ({ ALLERGEN: 'Dị ứng', ADDITIVE: 'Phụ gia', DIETARY: 'Chế độ ăn' })[k],
    },
    productForm: {
      noAllergenTable: 'Chưa có bảng chất gây dị ứng.',
      setUpAllergenTable: 'Thiết lập',
      searchAllergenCodes: 'Tìm mã…',
      editAllergenCodes: 'Sửa mã',
      general: 'Chung',
      name: 'Tên',
      code: 'Mã món',
      editCode: 'Sửa mã món',
      noCode: 'Không có',
      codePlaceholder: 'vd. A12',
      codeTakenBy: (dish: string) => `Mã này đang dùng cho "${dish}"`,
      description: 'Mô tả',
      basePrice: 'Giá gốc',
      newProduct: 'Món mới',
      editName: 'Sửa tên',
      editDescription: 'Sửa mô tả',
      options: 'Tùy chọn',
      optionName: 'Tên tùy chọn',
      optionNamePlaceholder: 'vd. Kích cỡ, Topping',
      required: 'Bắt buộc',
      allowMultiple: 'Cho chọn nhiều',
      selectionLimits: 'Giới hạn chọn',
      minToPick: 'Chọn tối thiểu',
      maxToPick: 'Chọn tối đa (trống = không giới hạn)',
      choiceName: 'Tên lựa chọn',
      choiceNamePlaceholder: 'vd. Lớn, Thêm phô mai',
      extraPrice: 'Giá thêm',
      defaultSelection: 'Chọn mặc định',
      addChoice: 'Thêm lựa chọn',
      deleteChoice: 'Xóa lựa chọn',
      noChoices: 'Chưa có lựa chọn',
      availability: 'Hiển thị',
      visibleToCustomers: 'Hiện với khách',
      hiddenChoicesFooter: 'Lựa chọn ẩn không hiện với khách',
      hiddenProductsFooter: 'Món ẩn không xuất hiện trên menu',
      inStock: 'Còn hàng',
      outOfStockChoicesFooter: 'Lựa chọn hết hàng vẫn hiện nhưng không đặt được',
      outOfStockProductsFooter: 'Món hết hàng vẫn hiện nhưng không đặt được',
      allergens: 'Dị ứng',
      labels: 'Nhãn',
      pricing: 'Giá',
      channelPrice: 'Giá theo kênh',
      channelPrices: 'Giá theo kênh',
      dineIn: 'Tại chỗ',
      pickup: 'Mang đi',
      delivery: 'Giao hàng',
      photo: 'Ảnh',
      addPhoto: 'Thêm ảnh',
      replacePhoto: 'Thay ảnh',
      removePhoto: 'Xóa ảnh',
      photoTooLarge: 'Ảnh quá lớn. Vui lòng dùng ảnh dưới 10 MB.',
      photoWrongType: 'Định dạng ảnh không hỗ trợ. Dùng JPEG, PNG, WebP hoặc HEIC.',
      photoUploadFailed: 'Không lưu được ảnh. Vui lòng thử lại.',
    },
    hideCategory: 'Ẩn danh mục',
    showCategory: 'Hiển thị danh mục',
    deleteCategory: 'Xóa danh mục',
    deleteCategoryConfirm: (categoryName) => `Xóa "${categoryName}" cùng các món ăn của nó?`,
    hidden: 'đã ẩn',
    outOfStock: 'Hết hàng',
    plusAddItem: '+ Thêm món',
    newProduct: 'Sản phẩm mới',
    optionName: 'Tên tùy chọn',
    optionNamePlaceholder: 'vd. Kích cỡ, Topping',
    required: 'Bắt buộc',
    allowMultipleSelections: 'Cho phép chọn nhiều',
    minimumToPick: 'Số lượng chọn tối thiểu',
    maximumToPick: 'Số lượng chọn tối đa (để trống = không giới hạn)',
    guestsPickRange: 'Khách chọn trong khoảng tối thiểu/tối đa.',
    guestsPickOne: (required) => `Khách chọn đúng một mục${required ? '.' : ' (hoặc không chọn).'}`,
    selectionMode: 'Kiểu chọn',
    pickOneMode: 'Chọn một',
    pickManyMode: 'Chọn nhiều',
    guestsPickAny: 'Khách tick bao nhiêu mục cũng được (hoặc không chọn).',
    newChoice: 'Lựa chọn mới',
    editChoice: 'Chỉnh sửa lựa chọn',
    choiceName: 'Tên lựa chọn',
    choiceNamePlaceholder: 'vd. Cỡ lớn, Thêm phô mai',
    extraPrice: 'Giá thêm',
    defaultSelection: 'Lựa chọn mặc định',
    visibleToCustomers: 'Hiển thị cho khách hàng',
    inStock: 'Còn hàng',
    allergens: 'Chất gây dị ứng',
    deleteChoice: 'Xóa lựa chọn',
    deleteChoiceConfirm: (choiceName) => `Xóa lựa chọn "${choiceName}"?`,
    noChoicesYet: 'Chưa có lựa chọn',
    addChoice: 'Thêm lựa chọn',
    default: 'Mặc định',
    outOfStockChip: 'Hết hàng',
    hiddenChip: 'Đã ẩn',
    editOption: 'Chỉnh sửa tùy chọn',
    deleteOption: 'Xóa tùy chọn',
    deleteOptionConfirm: (optionName) => `Xóa tùy chọn "${optionName}" cùng các lựa chọn của nó?`,
    pricing: 'Định giá',
    basePrice: 'Giá cơ bản',
    basePriceFooter:
      'Giá niêm yết mặc định. Bảng giá riêng theo kênh (giao hàng/lấy tại quầy) sẽ thay thế khi được thiết lập.',
    noOverridesYet:
      'Bảng giá theo từng kênh (giao hàng, lấy tại quầy...) được cấu hình riêng; sản phẩm này chưa có giá ghi đè.',
    noDescription: 'Không có mô tả',
    general: 'Chung',
    options: 'Tùy chọn',
    noOptionsYet: 'Chưa có tùy chọn - sản phẩm này được đặt nguyên trạng.',
    addOption: '+ Thêm tùy chọn',
    newOptions: 'Tùy chọn mới',
    newChoices: 'Lựa chọn mới',
    saveAllOptions: 'Lưu tất cả',
    optionsSaved: 'Đã lưu tùy chọn',
    optional: 'Không bắt buộc',
    optionNeedsChoice: 'Thêm ít nhất một lựa chọn trước khi lưu tùy chọn này.',
    optionEditHint: 'Lựa chọn không có giá sẽ không tính thêm tiền.',
    optionLimits: {
      pickSeveral: 'Cho chọn nhiều',
      limitHowMany: 'Giới hạn số lượng',
      minimum: 'Tối thiểu',
      maximum: 'Tối đa',
      minPrompt: (lo: number, hi: number) => `Khách phải chọn ít nhất bao nhiêu? (${lo} đến ${hi})`,
      maxPrompt: (lo: number, hi: number) =>
        `Khách được chọn nhiều nhất bao nhiêu? (${lo} đến ${hi})`,
      notSaved: 'Chưa lưu',
      notInteger: 'Chưa lưu. Hãy nhập một số nguyên.',
      outOfRange: (field: string, lo: number, hi: number) =>
        `Chưa lưu. ${field} phải từ ${lo} đến ${hi}.`,
      minAboveMax: (max: number) => `Chưa lưu. Tối thiểu không được lớn hơn Tối đa (${max}).`,
      maxBelowMin: (min: number) => `Chưa lưu. Tối đa không được nhỏ hơn Tối thiểu (${min}).`,
      summary: {
        exactly: (n: number) => `Khách phải chọn đúng ${n}`,
        upTo: (n: number) => `Khách chọn tối đa ${n}`,
        range: (min: number, max: number) => `Khách chọn từ ${min} đến ${max}`,
        atLeast: (n: number) => `Khách chọn ít nhất ${n}`,
        any: 'Khách có thể chọn bao nhiêu tùy ý, hoặc không chọn',
      },
      phrase: {
        exactly: (n: number) => `chọn ${n}`,
        upTo: (n: number) => `tối đa ${n}`,
        range: (min: number, max: number) => `chọn ${min}-${max}`,
        atLeast: (n: number) => `chọn ít nhất ${n}`,
        any: 'chọn tùy ý',
      },
      stockWarning: (inStock: number, total: number) =>
        `Chỉ còn ${inStock}/${total} lựa chọn trong kho - khách chưa thể đặt món này cho đến khi có hàng lại.`,
      legacy: {
        minAboveN: (min: number, n: number) =>
          `Tối thiểu (${min}) lớn hơn số lựa chọn trong nhóm (${n}).`,
        maxAboveN: (max: number, n: number) =>
          `Tối đa (${max}) lớn hơn số lựa chọn trong nhóm (${n}).`,
        minAboveMax: (min: number, max: number) => `Tối thiểu (${min}) lớn hơn Tối đa (${max}).`,
      },
      fixRule: 'Sửa quy tắc',
      clampTitle: 'Giảm giới hạn?',
      clampBody: (option: string, choice: string, n: number, rule: string) =>
        `${option}: ${rule}. Nếu bỏ ${choice} chỉ còn ${n} lựa chọn, nên`,
      clampChange: {
        min: (n: number) => `Tối thiểu sẽ đổi thành ${n}.`,
        max: (n: number) => `Tối đa sẽ đổi thành ${n}.`,
        both: (n: number) => `Tối thiểu và Tối đa sẽ đổi thành ${n}.`,
      },
      lowerAndDelete: (n: number) => `Giảm xuống ${n} và xóa`,
    },
    optionNameRequiredAll: 'Vui lòng điền tên cho tất cả tùy chọn trước khi lưu.',
    optionNameDuplicate: (name: string) =>
      `Tùy chọn "${name}" bị trùng tên. Mỗi tùy chọn phải có tên khác nhau.`,
    choiceNameRequiredAll: 'Vui lòng điền tên cho tất cả lựa chọn trước khi lưu.',
    choiceNameDuplicate: (name: string) =>
      `Lựa chọn "${name}" bị trùng tên. Mỗi lựa chọn phải có tên khác nhau.`,
    addOptionHint:
      'Mỗi tùy chọn là một nhóm lựa chọn (vd. Kích cỡ, Topping). Thêm nhiều nhóm rồi bấm Lưu tất cả; thêm giá trị bên trong sau khi lưu.',
    availability: 'Tình trạng',
    visibleToCustomersFooter: 'Sản phẩm bị ẩn sẽ không xuất hiện trong thực đơn',
    inStockFooter: 'Sản phẩm không sẵn có vẫn hiển thị nhưng không thể đặt',
    labels: 'Nhãn',
    editName: 'Chỉnh sửa tên',
    editDescription: 'Chỉnh sửa mô tả',
    createProduct: 'Tạo sản phẩm',
    productCreated: 'Đã tạo sản phẩm',
    missingCategory: 'Thiếu mục - hãy mở từ một mục thực đơn.',
    createProductNoteFooter:
      'Bạn có thể thêm mô tả, chất gây dị ứng, nhãn và tùy chọn sau khi tạo.',
    deleteProduct: 'Xóa sản phẩm',
    deleteProductConfirm: (productName) => `Xóa "${productName}" cùng mọi thứ bên trong?`,
    product: 'Sản phẩm',
    productNotFound: 'Không tìm thấy sản phẩm.',
    englishNameRequired: 'Vui lòng nhập tên.',
    englishValueRequired: 'Bắt buộc nhập giá trị tiếng Anh',
    fieldRequired: 'Trường này là bắt buộc',
    newOption: 'Tùy chọn mới',
    channelPriceEditTitle: (channel: string) => `Giá ${channel}`,
    channelPricesFooter:
      'Tại chỗ là giá mặc định. Để trống mang đi hoặc giao hàng để dùng giá này, hoặc nhập số tiền để tính giá khác cho kênh đó.',
    pricesSaved: 'Đã lưu giá',
    overridesBaseFooter: (base: string) =>
      `Ghi đè giá gốc (${base}) chỉ cho kênh này. Xóa để quay lại dùng giá gốc.`,
    useBasePrice: 'Dùng giá gốc',
    basePriceSectionFooter: 'Giá mặc định, cùng với giá riêng tùy chọn cho mang đi và giao hàng.',
    priceFree: 'Miễn phí',
    failedToLoad: 'Không thể tải thực đơn',
    notLiveAnywhereNote:
      'Thực đơn này chưa hiển thị ở kênh đặt hàng nào - khách hàng chưa thấy nó. Hãy chọn thực đơn này cho một kênh trong Thực đơn → Thực đơn đang dùng.',
    itemColumn: 'Món',
    priceColumn: 'Giá',
    priceFrom: 'từ',
    optionsCount: (n: number) => `${n} tùy chọn`,
    allMenus: 'Tất cả thực đơn',
    allMenusHelp:
      'Bảng trên chọn thực đơn nào mỗi kênh đang hiển thị. Chạm vào một thực đơn để chỉnh sửa các mục và món ăn của nó.',
    editMenu: 'Chỉnh sửa thực đơn',
    liveMenus: 'Thực đơn đang dùng',
    liveMenu: 'Thực đơn đang dùng',
    differentMenuPerChannel: 'Thực đơn khác nhau theo từng kênh',
    assignMenuPerChannelHelp: 'Chọn thực đơn cho từng kênh đặt hàng.',
    liveMenuHelp: 'Thực đơn khách hàng thấy khi đặt tại chỗ, mang đi và giao hàng.',
    menuFieldLabel: 'Thực đơn',
    mixed: 'Khác nhau',
    noneHidden: 'Không có - ẩn',
    noSelection: 'Không có',
    selectedCount: (n: number) => `Đã chọn ${n}`,
    category: 'Danh mục',
    items: 'Món',
    addCategoryFirst: 'Hãy thêm một danh mục trước.',
    addCategoryFirstThenItems: 'Hãy thêm một danh mục trước, sau đó thêm món vào đó.',
    itemNameRequiredForPrice: 'Bắt buộc nhập tên cho mỗi món có giá.',
    enterAtLeastOneItem: 'Nhập ít nhất một tên món.',
    itemsAddedToast: (n: number) => `Đã thêm ${n} món`,
    itemNamePlaceholder: 'Tên món *',
    basePriceAriaLabel: (currency: string) => `Giá gốc (${currency})`,
    removeItem: 'Xóa',
    addRow: 'Thêm dòng',
    addAnotherItem: 'Thêm món khác',
    simpleMode: 'Nhiều món',
    advancedMode: '1 món chi tiết',
    groupName: 'Tên nhóm',
    requiredGroupDefault: 'Bắt buộc',
    requiredChoicesHint: 'Lựa chọn ít nhất 1',
    optionalChoicesHint: 'Không bắt buộc phải chọn',
    optionalGroupDefault: 'Tuỳ chọn',
    dayLabelsShort: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
  },

  menuQuickEdit: {
    placeholder: 'Hỏi AI, ví dụ “tăng giá pizza 5%”',
    fullMenu: 'Toàn bộ menu',
    productPlaceholder: 'Hỏi AI, ví dụ “thêm phô mai giá 1,50”',
    tagNew: 'Mới',
    tagRemoved: 'Đã xoá',
    tagMoved: 'Đã chuyển',
    shown: 'Hiển thị',
    hidden: 'Đã ẩn',
    inStock: 'Còn hàng',
    soldOut: 'Hết hàng',
    isDefault: 'Mặc định',
    notDefault: 'Không mặc định',
    basePrice: 'giá gốc',
    hours: 'Giờ bán',
    always: 'Luôn luôn',
    allergens: 'Dị ứng',
    labels: 'Nhãn',
    order: 'Thứ tự',
    pickup: 'Tự đến lấy',
    delivery: 'Giao hàng',
    none: 'không có',
    rules: {
      required: 'bắt buộc',
      optional: 'tuỳ chọn',
      pickOne: 'chọn 1',
      pickAny: 'chọn tuỳ ý',
      pickUpTo: (n: number) => `chọn tối đa ${n}`,
      pickAtLeast: (n: number) => `chọn ít nhất ${n}`,
      pickRange: (min: number, max: number) => `chọn ${min}–${max}`,
    },
    summary: {
      items: (n: number) => `${n} món`,
      sections: (n: number) => `${n} danh mục`,
      prices: (n: number) => `${n} giá`,
      added: (n: number) => `${n} thêm mới`,
      removed: (n: number) => `${n} đã xoá`,
      renamed: (n: number) => `${n} đổi tên`,
      descriptions: (n: number) => `${n} mô tả`,
      moved: (n: number) => `${n} đã chuyển`,
      stock: (n: number) => `${n} thay đổi tồn kho`,
      visibility: (n: number) => `${n} ẩn/hiện`,
      allergens: (n: number) => `${n} cập nhật dị ứng`,
      labels: (n: number) => `${n} cập nhật nhãn`,
      hours: (n: number) => `${n} thay đổi giờ bán`,
      rules: (n: number) => `${n} quy tắc nhóm`,
      defaults: (n: number) => `${n} mặc định`,
    },
  },

  promotionsQuickEdit: {
    placeholder: 'Hỏi AI, ví dụ “giảm 10% đơn mang đi T3–T5 sau 17:00”',
    restoredTag: 'Khôi phục',
    summary: {
      created: (n: number) => `${n} mới`,
      updated: (n: number) => `${n} đã đổi`,
      archived: (n: number) => `${n} lưu trữ`,
      restored: (n: number) => `${n} khôi phục`,
    },
    conflict: {
      replaces: (example: string, other: string) => `${example}: thay cho “${other}”`,
      stacks: (example: string, other: string) => `${example}: cộng dồn với “${other}”`,
      loses: (example: string, other: string) =>
        `${example}: “${other}” giảm nhiều hơn nên khuyến mãi này không áp dụng`,
    },
  },

  exceptionsQuickEdit: {
    placeholder: 'Hỏi AI, ví dụ “đóng cửa dịp Giáng sinh”',
    summary: {
      created: (n: number) => `${n} mới`,
      updated: (n: number) => `${n} đã đổi`,
      removed: (n: number) => `${n} đã xoá`,
    },
  },

  aiChangeset: {
    propose: 'Soạn thay đổi',
    proposing: 'Đang soạn thay đổi…',
    previousChange: 'Thay đổi trước',
    nextChange: 'Thay đổi tiếp theo',
    changesOnly: 'Chỉ thay đổi',
    apply: 'Áp dụng',
    discard: 'Bỏ',
    staleNotice: (items: string) => `Đã thay đổi trong lúc chờ, hãy kiểm tra lại: ${items}`,
    appliedToast: (n: number) => `Đã áp dụng ${n} thay đổi`,
    appliedPartialToast: (applied: number, total: number) =>
      `Chỉ áp dụng được ${applied}/${total} thay đổi, hãy kiểm tra phần còn lại`,
    undo: 'Hoàn tác',
    undoneToast: 'Đã hoàn tác thay đổi',
    undoStale: 'Không hoàn tác được: một số món đã thay đổi trong lúc đó.',
  },

  aiDock: {
    menuTitle: 'AI thực đơn',
    exceptionsTitle: 'AI ngày lễ',
    promotionsTitle: 'AI khuyến mãi',
    productTitle: 'AI món ăn',
    sharedWithTeam: 'Chia sẻ với nhóm của bạn',
    expand: 'Xem cuộc trò chuyện với AI',
    collapse: 'Ẩn cuộc trò chuyện với AI',
    attach: 'Đính kèm ảnh hoặc PDF',
    send: 'Gửi',
    removeAttachment: 'Xóa tệp đính kèm',
    uploading: 'Đang tải lên…',
    readingStart: 'Đang đọc thực đơn…',
    readingPage: (page: number, total: number) => `Đang đọc trang ${page}/${total}…`,
    dishesSoFar: (n: number) => `Đã có ${n} món · bạn có thể rời trang`,
    importFailed: 'Không đọc được thực đơn.',
    pagesNotRead: (pages: string) =>
      `Không đọc được: ${pages}. Hãy đính kèm trang đó và nhờ AI thêm các món của trang.`,
    lockedByOther: 'Người khác đang chỉnh sửa bằng AI. Vui lòng thử lại sau giây lát.',
    loadOlder: 'Xem tin nhắn cũ hơn',
    emptyHistory:
      'Nhờ AI đổi giá, thêm món hoặc sửa tên. Cả nhóm của bạn đều thấy cuộc trò chuyện này.',
    teammate: 'Thành viên',
    menuCreated: 'Đã tạo thực đơn',
    deleteMenuConfirm: 'Xóa thực đơn này?',
    deleteMenu: 'Xóa',
    tryAgain: 'Thử lại',
    undoCreated: 'Hoàn tác (xóa thực đơn)',
    changesApplied: (n: number) => `Đã áp dụng ${n} thay đổi`,
    changesPartlyApplied: (applied: number, missing: number) =>
      `Đã áp dụng ${applied}, ${missing} chưa được áp dụng`,
    applyingChanges: (n: number) => `Đang áp dụng ${n} thay đổi…`,
    reviewChanges: (n: number) => `Xem ${n} thay đổi`,
    discarded: 'Đã bỏ',
    undone: 'Đã hoàn tác',
    changesPosition: (position: string, total: number) => `${position} / ${total} thay đổi`,
  },

  menuCreate: {
    title: 'Tạo bằng AI',
    nameLabel: 'Tên thực đơn',
    namePlaceholder: 'Để trống, AI sẽ gợi ý',
    sources: 'Thực đơn của bạn',
    sourcesHelp: 'Ảnh hoặc PDF thực đơn, hoặc đường dẫn tới thực đơn.',
    camera: 'Chụp ảnh',
    addFiles: 'Thêm ảnh hoặc PDF',
    removeSource: 'Xóa',
    linkLabel: 'Đường dẫn',
    linkPlaceholder: 'https://nha-hang-cua-ban.com/thuc-don',
    invalidLink: 'Nhập đường dẫn đầy đủ bắt đầu bằng https://',
    hintLabel: 'AI cần biết gì thêm?',
    hintPlaceholder: 'VD: “Chỉ thực đơn trưa, bỏ qua trang đồ uống”',
    keepItemNumbers: 'Giữ số thứ tự món',
    offNote: 'Thực đơn sẽ tắt cho đến khi bạn xuất bản.',
    create: 'Tạo thực đơn',
    unsupportedFiles: (names: string) =>
      `Không dùng được ${names}. Hãy dùng PNG, JPEG, WebP hoặc PDF.`,
    tooManySources: (max: number) => `Tối đa ${max} tệp`,
  },

  menuChecklist: {
    toCheck: (n: number) => `${n} mục cần kiểm tra`,
    noPriceCount: (n: number) => `${n} chưa có giá`,
    unknownAllergensCount: (n: number) => `${n} dị ứng không rõ`,
    noPrice: 'Chưa có giá',
    addLegend: (n: number) => `Thêm ${n} mã từ chú thích thực đơn`,
    legendIntro: 'Các mã này có trên thực đơn nhưng chưa có trong danh sách dị ứng của bạn.',
    addCodes: 'Thêm vào danh sách dị ứng',
    unknownCode: (code: string) => `'${code}' không có trong danh sách dị ứng`,
  },

  menuImportReview: {
    title: 'Kiểm tra bản nhập',
    open: 'So với bản gốc',
    openFlagged: (n: number) => `So với bản gốc · ${n} món cần xem`,
    page: (n: number, total: number) => `Trang ${n}/${total}`,
    previousPage: 'Trang trước',
    nextPage: 'Trang sau',
    flaggedOnly: 'Chỉ món cần xem',
    allDishes: 'Tất cả món',
    showPage: 'Bản gốc',
    showDishes: 'Món',
    flaggedCount: (n: number) => `${n} món cần xem`,
    noDishes: 'Không đọc được món nào từ trang này.',
    noFlagged: 'Trang này không có món cần xem.',
    sourceMissing: 'Tệp gốc không còn nữa.',
    openOriginal: 'Mở bản gốc',
    unavailableTitle: 'Không có bản gốc để so',
    unavailableText:
      'Thực đơn này không lưu trang nguồn. Thực đơn nhập trước khi có tính năng này không thể kiểm tra ở đây.',
    liveNote: 'Thực đơn này đang hoạt động. Các cảnh báo chỉ để tham khảo.',
    noPrice: 'Chưa có giá',
    priceOutlier: (typical: string) =>
      `Giá chênh nhiều so với các món cùng mục (thường ${typical})`,
    unknownCodes: (codes: string) => `Không có trong danh sách dị ứng: ${codes}`,
    itemNumberDropped: (code: string) => `Số món ${code} bị trùng nên đã bỏ qua`,
    pickLimit: (limits: string) => `Khách phải chọn đúng số lượng: ${limits}`,
  },

  notificationsFeature: {
    couldntLoadNotifications: 'Không thể tải thông báo',
    allCaughtUp: 'Đã xem hết',
    noNotifications: 'Không có thông báo.',
    today: 'Hôm nay',
    earlier: 'Trước đó',
    markAllRead: 'Đánh dấu tất cả đã đọc',
    notificationsSheet: 'Thông báo',
  },

  openingHours: {
    editClosure: 'Chỉnh sửa ngày nghỉ',
    addClosure: 'Thêm ngày nghỉ',
    reason: 'Lý do',
    reasonPlaceholder: 'Vd. Ngày Giáng sinh, tiệc nhân viên',
    appliesToLabel: 'Áp dụng cho',
    allServices: 'Tất cả dịch vụ',
    servicesSelected: (n: number) => `${n} dịch vụ`,
    pickAtLeastOneService: 'Chọn ít nhất một dịch vụ',
    dineIn: 'Tại chỗ',
    pickup: 'Lấy tại quầy',
    delivery: 'Giao hàng',
    reservation: 'Đặt bàn',
    whatHappens: 'Điều gì xảy ra',
    whatHappensHint:
      'Ngày lễ đóng cửa cả ngày. Ngoại lệ vẫn mở nhưng với giờ khác cho những ngày này - ví dụ mở trễ hơn hoặc đóng sớm hơn.',
    holiday: 'Ngày lễ',
    exception: 'Ngoại lệ',
    closedAllDay: 'Đóng cửa cả ngày',
    specialHours: 'Giờ đặc biệt',
    dates: 'Ngày',
    from: 'Từ',
    to: 'Đến',
    startDateAriaLabel: 'Ngày bắt đầu',
    endDateAriaLabel: 'Ngày kết thúc',
    singleDayHint: 'Chỉ một ngày? Đặt Từ và Đến cùng một ngày.',
    shiftLabel: (number) => `Ca ${number}`,
    openLabel: 'Mở cửa',
    removeHoursAriaLabel: 'Xóa giờ',
    addHours: 'Thêm giờ',
    hoursReplaceWeeklyNote:
      'Những giờ này thay thế giờ mở cửa hàng tuần thông thường vào các ngày đã chọn.',
    pickStartEndDate: 'Chọn ngày bắt đầu và ngày kết thúc.',
    endDateBeforeStart: 'Ngày kết thúc không thể trước ngày bắt đầu.',
    addSpecialHours: 'Thêm ít nhất một bộ giờ đặc biệt.',
    checkSpecialHours: 'Kiểm tra giờ đặc biệt - giờ mở phải trước giờ đóng.',
    closureUpdated: 'Đã cập nhật ngày nghỉ',
    closureAdded: 'Đã thêm ngày nghỉ',
    couldNotSave: 'Không thể lưu - hãy thử lại.',
    holidaysClosures: 'Ngày lễ & ngày nghỉ',
    removeClosureConfirm: 'Xóa ngày nghỉ',
    removeClosureQuestion: (label) => `Xóa ngày nghỉ cho ${label}?`,
    closureRemoved: 'Đã xóa ngày nghỉ',
    couldNotRemove: 'Không thể xóa - hãy thử lại.',
    couldNotLoadClosures: 'Không thể tải ngày nghỉ',
    noClosuresYet: 'Chưa có ngày nghỉ',
    noClosuresDescription:
      'Thêm một ngày lễ hoặc một ngày có giờ đặc biệt để ghi đè lịch hàng tuần. Chạm vào +.',
    closedBadge: 'Đóng cửa',
    specialBadge: 'Đặc biệt',
    closuresOverrideNote:
      'Ngày nghỉ ghi đè giờ mở cửa hàng tuần. Một ngày đóng cửa sẽ gỡ bỏ các khung đặt hàng trực tuyến và đặt bàn; giờ đặc biệt thay thế chúng cho các ngày đã chọn.',
    title: 'Giờ mở cửa',
    service: 'Dịch vụ',
    hoursFor: 'Giờ cho',
    hoursServiceNote:
      'Mỗi dịch vụ có giờ mở cửa hàng tuần riêng. Giờ lấy tại quầy và giao hàng điều khiển trang đặt hàng trực tuyến; giờ đặt bàn điều khiển lịch đặt chỗ.',
    oneOffClosedDays: 'Ngày đóng cửa một lần và giờ đặc biệt',
    monday: 'Thứ Hai',
    tuesday: 'Thứ Ba',
    wednesday: 'Thứ Tư',
    thursday: 'Thứ Năm',
    friday: 'Thứ Sáu',
    saturday: 'Thứ Bảy',
    sunday: 'Chủ Nhật',
    hoursLabel: 'Giờ mở cửa',
    hours: 'Giờ',
    generalHoursNote:
      'Đây là giờ mở cửa chung của nhà hàng. Đặt bàn, lấy tại quầy và giao hàng tự động áp dụng theo giờ này - đặt giờ riêng cho một kênh trong cài đặt của kênh đó nếu khác. Ngày lễ một lần và ngày có giờ đặc biệt nằm trong mục Ngày lễ & ngày nghỉ.',
    openTimeAria: (label) => `${label} mở cửa`,
    closeTimeAria: (label) => `${label} đóng cửa`,
    enabledWithoutHours: (label) =>
      `${label} đang bật nhưng chưa có giờ - hãy thêm giờ hoặc tắt đi`,
    checkTimes: (label) => `Kiểm tra giờ cho ${label}`,
    noOvernightOrders: (label) =>
      `${label}: giờ đóng phải sau giờ mở - giờ nhận đơn không được qua nửa đêm.`,
    openAfterClose: (label) => `${label}: giờ mở cửa không được sau giờ đóng cửa.`,
    shiftsOverlap: (label) =>
      `${label}: các khung giờ bị chồng nhau - hãy điều chỉnh để chúng không giao nhau.`,
    invalidHoursTitle: 'Giờ không hợp lệ',
    openingSaved: 'Đã lưu giờ mở cửa',
    saveFailed: 'Lưu thất bại',
    couldNotLoadHours: 'Không thể tải giờ mở cửa',
    checkConnection: 'Kiểm tra kết nối của bạn và thử lại.',
    saveButtonLabel: (service) => `Lưu giờ mở cửa ${service}`,
    followingTheseHours: 'Đang theo giờ này',
    setCustomHours: 'Đặt giờ riêng',
    nowFollowingGeneral: 'Hiện đang theo giờ chung',
    confirmFollowTitle: 'Chuyển sang giờ chung?',
    confirmFollowMessage:
      'Thao tác này sẽ xóa giờ riêng theo tuần của kênh này. Kênh sẽ theo giờ mở cửa chung của nhà hàng.',
    failedSetCustom: 'Không thể đặt giờ riêng',
    failedUpdate: 'Cập nhật thất bại',
    orderHoursTitle: 'Giờ nhận đơn',
    pickupHoursTitle: 'Giờ lấy tại quầy',
    deliveryHoursTitle: 'Giờ giao hàng',
    reservationHoursTitle: 'Giờ nhận đặt bàn',
    pickupFollowNote:
      'Lấy tại quầy theo giờ mở cửa chung của nhà hàng. Bật giờ riêng để đặt riêng thời điểm nhận đơn lấy tại quầy.',
    deliveryFollowNote:
      'Giao hàng theo giờ mở cửa chung của nhà hàng. Bật giờ riêng để đặt riêng thời điểm giao hàng.',
    reservationFollowNote:
      'Đặt bàn theo giờ mở cửa chung của nhà hàng. Bật giờ riêng để đặt riêng thời điểm có thể đặt bàn.',
    openingTime: 'Giờ mở cửa',
    deleteThisClosure: 'Xóa ngày nghỉ này',
    removeThisClosureQuestion: 'Xóa ngày nghỉ này?',
    statusOpenUntil: (time) => `Mở cửa · đến ${time}`,
    statusClosedOpensAt: (time) => `Đóng cửa · mở lúc ${time}`,
    statusClosedOpensDay: (day, time) => `Đóng cửa · mở ${day} ${time}`,
  },

  orderSetup: {
    title: 'Cài đặt đặt hàng',
    orderTypes: {
      title: 'Loại đặt hàng',
      noConfig: 'Chưa cấu hình loại đặt hàng nào.',
      footer:
        'Chạm vào một kênh để bật/tắt hoặc chuyển đổi thanh toán tiền mặt và thẻ. Tắt một kênh sẽ ẩn hoàn toàn khỏi khách hàng - để tạm dừng nhanh thay vì tắt, hãy dùng phần tình trạng bên dưới.',
      cashStatus: (status, cardStatus) => `Tiền mặt ${status} · Thẻ ${cardStatus}`,
      cashOnly: (status) => `Tiền mặt ${status}`,
      disabled: 'Khách hàng không thể đặt theo cách này',
      on: 'Bật',
      off: 'Tắt',
      actionLabel: (label) => `Cài đặt ${label}`,
      turnOff: (label) => `Tắt ${label}`,
      turnOn: (label) => `Bật ${label}`,
      stopCash: 'Ngừng nhận tiền mặt',
      acceptCash: 'Nhận tiền mặt',
      stopCard: 'Ngừng nhận thanh toán thẻ',
      acceptCard: 'Nhận thanh toán thẻ trực tuyến',
      turnedOff: (label) => `Đã tắt ${label}`,
      turnedOn: (label) => `Đã bật ${label}`,
      cashOff: 'Đã tắt thanh toán tiền mặt',
      cashOn: 'Đã bật thanh toán tiền mặt',
      onlineCardOff: 'Đã tắt thanh toán thẻ trực tuyến',
      onlineCardOn: 'Đã bật thanh toán thẻ trực tuyến',
    },
    minimumOrder: {
      title: 'Đơn hàng tối thiểu',
      noConfig: 'Chưa cấu hình loại đặt hàng nào.',
      smallestBasket: 'Giỏ hàng nhỏ nhất cho phép',
      noMinimum: 'Không tối thiểu',
      footer:
        'Tổng giá trị giỏ hàng nhỏ nhất mà khách có thể thanh toán, theo từng kênh. Đặt 0 để không có mức tối thiểu.',
      prompt: (orderType) => `Tổng đơn hàng tối thiểu ${orderType} (0 = không tối thiểu)`,
      set: (orderType, amount) => `Đã đặt đơn hàng tối thiểu ${orderType} thành ${amount}`,
      removed: (orderType) => `Đã gỡ đơn hàng tối thiểu ${orderType}`,
    },
    availability: {
      title: 'Tình trạng',
      accepting: 'Đang nhận đơn',
      pausedUntilClose: 'Tạm dừng đến giờ đóng cửa',
      pausedResumes: (time) => `Tạm dừng · tiếp tục lúc ${time}`,
      paused: 'Tạm dừng',
      live: 'Đang hoạt động',
      footer:
        'Trạng thái thực tế của việc nhận đơn mới. Chạm vào một kênh để tạm dừng khi đông khách hoặc gặp sự cố bếp (theo thời gian / đến giờ đóng cửa) hoặc để tiếp tục. Việc này độc lập với việc bật loại đặt hàng ở trên - các đơn hiện có không bị ảnh hưởng.',
      orderingLabel: (label) => `Đặt hàng ${label}`,
      pause30: 'Tạm dừng 30 phút',
      pause1Hour: 'Tạm dừng 1 giờ',
      pauseUntilClose: 'Tạm dừng đến giờ đóng cửa',
      resumeNow: 'Tiếp tục ngay',
      pausedFor: (label, minutes) => `Đã tạm dừng ${label} trong ${minutes} phút`,
      pausedUntilCloseToast: (label) => `Đã tạm dừng ${label} đến giờ đóng cửa`,
      resumed: (label) => `Đã tiếp tục ${label}`,
    },
    deliveryZones: {
      title: 'Khu vực giao hàng',
      noZones:
        'Chưa có khu vực giao hàng - giao hàng không khả dụng cho đến khi thêm ít nhất một khu vực.',
      mapArea: 'Vùng bản đồ',
      within: (km) => `Trong vòng ${km} km`,
      noRangeSet: 'Chưa đặt phạm vi',
      addZone: '+ Thêm khu vực giao hàng',
      footer:
        'Mỗi khu vực xác định phạm vi cùng phí giao hàng và đơn hàng tối thiểu riêng. Khách hàng thấy khu vực phù hợp nhỏ nhất.',
      deleteConfirm: (label) => `Xóa khu vực "${label}"?`,
      deleteTitle: 'Xóa khu vực',
      deleted: 'Đã xóa khu vực',
    },
    deliveryZone: {
      newZone: 'Khu vực giao hàng mới',
      editZone: 'Chỉnh sửa khu vực',
      nameLabel: 'Tên khu vực',
      namePlaceholder: 'vd. Trung tâm thành phố, tối đa 5 km',
      deliveryArea: 'Khu vực giao hàng',
      mapDrawn: 'Vẽ trên bản đồ',
      mapDrawnFooter: 'Khu vực này được vẽ trên bản đồ và không thể chỉnh sửa tại đây.',
      distanceLabel: 'Giao hàng trong vòng (km)',
      distancePlaceholder: 'vd. 5',
      feeLabel: (currency) => `Phí giao hàng (${currency})`,
      minOrderLabel: (currency) => `Đơn hàng tối thiểu (${currency})`,
      minOrderPlaceholder: '0 = không tối thiểu',
      nameRequired: 'Đặt tên cho khu vực.',
      distanceRequired: 'Nhập khu vực này giao hàng xa bao nhiêu (km).',
      added: 'Đã thêm khu vực',
      updated: 'Đã cập nhật khu vực',
      saveFailed: 'Lưu khu vực thất bại',
    },
    paymentMethods: {
      title: 'Phương thức thanh toán thủ công',
      noMethods:
        'Chưa có phương thức thanh toán thủ công - chỉ các tùy chọn mặc định được cung cấp khi thanh toán.',
      active: 'Đang hoạt động',
      inactive: 'Không hoạt động',
      addMethod: '+ Thêm phương thức thanh toán',
      footer:
        'Các tùy chọn thanh toán khi đến nơi hoặc chuyển khoản ngân hàng được hiển thị khi thanh toán. Khách hàng làm theo hướng dẫn và nhân viên xác nhận biên lai thủ công.',
      deleteConfirm: (name) => `Xóa phương thức "${name}"?`,
      deleteTitle: 'Xóa',
      deleted: 'Đã xóa phương thức',
    },
    paymentMethod: {
      newMethod: 'Phương thức thanh toán mới',
      editMethod: 'Chỉnh sửa phương thức',
      nameLabel: 'Tên phương thức',
      namePlaceholder: 'vd. Chuyển khoản ngân hàng, PayPal',
      instructionsLabel: 'Hướng dẫn',
      instructionsPlaceholder: 'Khách hàng cần làm gì để thanh toán',
      shownAtCheckout: 'Hiển thị khi thanh toán',
      detail: (number) => `Chi tiết ${number}`,
      remove: 'Gỡ bỏ',
      detailLabel: 'Nhãn',
      detailLabelPlaceholder: 'vd. IBAN',
      detailValue: 'Giá trị',
      detailValuePlaceholder: 'vd. DE89 3704 0044 0532 0130 00',
      addDetail: '+ Thêm thông tin tài khoản',
      detailLabelInfo:
        'Tên trường mà khách hàng nhìn thấy (vd. IBAN, Chủ tài khoản, Tên ngân hàng).',
      detailValueInfo:
        'Thông tin thực tế mà khách hàng sao chép để thanh toán (vd. DE89 3704…, ACME Ltd).',
      detailsFooter:
        'Thông tin tài khoản được hiển thị thành các dòng có nhãn bên dưới hướng dẫn khi thanh toán - dùng cho IBAN, chủ tài khoản, địa chỉ PayPal, v.v.',
      nameRequired: 'Đặt tên cho phương thức.',
      instructionsRequired: 'Thêm hướng dẫn mà khách hàng cần làm theo.',
      detailsInvalid: 'Mỗi thông tin tài khoản cần có cả nhãn và giá trị.',
      added: 'Đã thêm phương thức',
      updated: 'Đã cập nhật phương thức',
      saveFailed: 'Lưu phương thức thất bại',
    },
    shifts: {
      title: 'Giờ đặt hàng',
      pickup: 'Lấy tại quầy',
      delivery: 'Giao hàng',
      capacityMode: 'Chế độ năng lực',
      simple: 'Đơn giản',
      simpleDescription: 'Một con số: bạn có thể nhận bao nhiêu đơn mỗi giờ.',
      simpleConfirm: 'Chuyển năng lực sang chế độ đơn giản?',
      simpleDetails:
        'Một khung là cửa sổ 60 phút - khung 19:00 tính mọi đơn được lên lịch từ 19:00 đến 19:59.\n\nMức giới hạn mặc định áp dụng khi không có khung giờ đặc biệt nào bao phủ thời điểm đó. Để trống nếu không cần giới hạn.',
      advanced: 'Nâng cao',
      advancedDescription: 'Chọn độ dài khung và giới hạn số đơn mỗi khung.',
      advancedConfirm: 'Chuyển năng lực sang chế độ nâng cao?',
      advancedDetails:
        'Đặt độ dài khung riêng của bạn (vd. 30 phút) và giới hạn số đơn mỗi khung - chi tiết hơn so với mô hình theo giờ đơn giản.\n\nMức giới hạn mặc định áp dụng khi không có khung giờ đặc biệt nào bao phủ thời điểm đó. Để trống nếu không cần giới hạn.',
      aboutMode: (mode) => `Về chế độ ${mode}`,
      defaultCapacity: 'Năng lực mặc định',
      ordersPerSlot: 'Số đơn mỗi khung',
      maxOrdersPerHour: 'Số đơn tối đa mỗi giờ',
      noCap: 'không giới hạn',
      slotLength: 'Độ dài khung (phút)',
      slotLengthPlaceholder: '30',
      kitchenPrepTime: 'Thời gian chuẩn bị tại bếp (phút)',
      noPrepPlaceholder: 'không chuẩn bị',
      minNoticeLabel: 'Thời gian báo trước tối thiểu cho đơn đặt trước (phút)',
      nonePlaceholder: 'không có',
      defaultFooter:
        'Đơn hàng trực tuyến tuân theo giờ mở cửa của bạn. Thêm giờ đặc biệt bên dưới cho các khung giờ khác nhau vào những ngày cụ thể.',
      specialHours: 'Giờ đặc biệt',
      noSpecialHours: 'Không có - mặc định áp dụng hàng ngày.',
      setDefaultFirst: 'Hãy đặt năng lực mặc định trước',
      capacityModeSet: (mode) => `Chế độ năng lực: ${mode}`,
      switchModeFailed: 'Chuyển chế độ năng lực thất bại',
    },
    shiftForm: {
      newSpecialHours: 'Giờ đặc biệt mới',
      editSpecialHours: 'Chỉnh sửa giờ đặc biệt',
      name: 'Tên',
      namePlaceholder: 'vd. Đêm Giáng sinh, giờ Chủ Nhật',
      days: 'Ngày',
      hours: 'Giờ',
      opens: 'Mở cửa',
      closes: 'Đóng cửa',
      capacity: 'Năng lực',
      preview: 'Xem trước',
      active: 'Đang hoạt động',
      activeFooter: 'Vô hiệu hóa quy tắc này nhưng tạm thời giữ lại.',
      daysFooter: (channel) =>
        `Vào những ngày này, quy tắc này thay thế giờ ${channel} thông thường. Các ngày khác giữ nguyên.`,
      capacityFooter:
        'Màu xám là mặc định của bạn - để trống để giữ nguyên, hoặc nhập một con số để dùng giá trị khác vào những ngày của quy tắc này.',
      deleteRule: 'Xóa quy tắc này',
      nameRequired: 'Đặt tên cho quy tắc này',
      dayRequired: 'Chọn ít nhất một ngày',
      timeInvalid: 'Giờ mở phải trước giờ đóng',
      capacityInvalid: 'Năng lực phải là số nguyên dương (hoặc để trống để dùng mặc định)',
      slotInvalid: 'Độ dài khung phải là số nguyên dương',
      leadInvalid:
        'Thời gian chuẩn bị / báo trước phải là số nguyên (hoặc để trống để dùng mặc định)',
      saveFailed: 'Không thể lưu',
      deleteConfirm: 'Xóa quy tắc này?',
      deleted: 'Đã xóa',
      deleteFailed: 'Không thể xóa',
    },
    holidayForm: {
      newTitle: 'Giờ ngày lễ mới',
      editTitle: 'Chỉnh sửa giờ ngày lễ',
      namePlaceholder: 'vd. Đêm Giáng sinh, Năm mới',
      dates: 'Ngày',
      datesFooter: (channel) =>
        `Vào những ngày này, ngày lễ thay thế CẢ giờ đặc biệt lẫn giờ ${channel} thông thường.`,
      starts: 'Bắt đầu',
      startAria: 'Ngày bắt đầu ngày lễ',
      ends: 'Kết thúc',
      endAria: 'Ngày kết thúc ngày lễ',
      on: 'Bật',
      activeFooter: 'Tắt để giữ lại ngày lễ này nhưng tạm ngừng ghi đè.',
      deleteHoliday: 'Xóa ngày lễ này',
      nameRequired: 'Đặt tên cho ngày lễ này',
      dateRangeInvalid: 'Ngày kết thúc phải cùng ngày hoặc sau ngày bắt đầu',
      hoursInvalid: 'Giờ mở và giờ đóng phải được đặt và khác nhau',
      capacityInvalid:
        'Số đơn mỗi khung phải là số nguyên dương (hoặc để trống nếu không giới hạn)',
      prepNoticeInvalid: 'Thời gian chuẩn bị và báo trước phải là số nguyên (từ 0 trở lên)',
      deleteConfirm: 'Xóa ngày lễ này?',
    },
    leadTime: {
      orderNow: 'Đặt ngay (sớm nhất có thể)',
      orderLabel: 'Đặt hàng',
      readyLabel: 'Sẵn sàng',
      deliveredLabel: 'Đã giao',
      deliveryDescription: (mins: number) =>
        `Giao hàng cộng thêm ${mins} phút sau khi chế biến — đó mới là lúc khách nhận được món.`,
      deliveryRangeDescription: (min: number, max: number) =>
        `Giao hàng cộng thêm ${min}–${max} phút sau khi chế biến, tùy khu vực — đó mới là lúc khách nhận được món.`,
      deliveryLiveDescription:
        'Thời gian giao được tính theo từng địa chỉ từ dữ liệu lái xe thực tế, nên mỗi đơn một khác.',
      readyDescription:
        'Sẵn sàng = thời gian đặt + thời gian chuẩn bị. Đây là thời gian khách chờ - nơi thời gian chuẩn bị quan trọng nhất. Thời gian báo trước tối thiểu không áp dụng.',
      noPrepBuffer: 'Không có thời gian chuẩn bị đệm - đơn sẵn sàng ngay lập tức.',
      orderLater: 'Đặt sau (đặt trước)',
      earliestSlot: 'Khung sớm nhất',
      minNoticeDescription: (time) =>
        `Thời gian báo trước tối thiểu - khung tương lai sớm nhất mà khách có thể chọn là ${time}.`,
      noNotice: 'Không cần báo trước - khách có thể chọn khung tiếp theo.',
      opensLabel: 'Mở cửa',
      firstSlotLabel: 'Khung đầu tiên',
      openingBufferDescription: (open: string, first: string) =>
        `Sớm nhất sau giờ mở cửa - khi bắt đầu nhận đơn lúc ${open}, khung sớm nhất khách có thể chọn là ${first}.`,
      noOpeningBuffer: 'Không có khoảng chờ sau giờ mở cửa - khách có thể chọn ngay giờ mở cửa.',
      kitchenStarts: 'Bếp bắt đầu',
      readySlot: 'Sẵn sàng · khung',
      driverLeaves: 'Tài xế xuất phát',
      deliveredSlot: 'Đã giao',
      kitchenStartsDeliveryDescription: (slot: string, startTime: string) =>
        `Với đơn giao lúc ${slot}, bếp bắt đầu lúc ${startTime} — quãng đường được trừ ngược từ giờ hẹn chứ không cộng thêm, nên khách vẫn nhận lúc ${slot}. Hiển thị theo khu vực xa nhất.`,
      kitchenStartsDeliveryLive:
        'Với khoảng cách lái xe thực tế, quãng đường được trừ theo từng địa chỉ, nên giờ bếp bắt đầu thay đổi theo mỗi đơn.',
      kitchenStartsDescription: (time, startTime) =>
        `Với khung ${time} đã chọn, bếp bắt đầu lúc ${startTime} - khách vẫn nhận được đúng vào lúc ${time}.`,
    },
    page: {
      pickup: 'Lấy tại quầy',
      delivery: 'Giao hàng',
      noConfig: 'Chưa cấu hình loại đặt hàng nào.',
      orderTypesTitle: 'Loại đặt hàng',
      canOrder: 'Khách hàng có thể đặt theo cách này',
      cannotOrder: 'Khách hàng không thể đặt theo cách này',
      readOnlyNotice: 'Bạn có thể xem các cài đặt này. Chỉ chủ hoặc quản lý mới có thể thay đổi.',
      orderTypesFooter:
        'Bật hoặc tắt một kênh. Tắt sẽ ẩn hoàn toàn khỏi khách hàng - để tạm dừng nhanh thay vì tắt, hãy dùng phần Tình trạng bên dưới.',
      toggledOn: (label) => `Đã bật ${label}`,
      toggledOff: (label) => `Đã tắt ${label}`,
      cardTitle: 'Thanh toán thẻ',
      acceptingCard: 'Đang nhận thẻ trực tuyến',
      cardOff: 'Tắt thẻ',
      cardFooter: 'Nhận thanh toán thẻ trực tuyến, theo từng kênh.',
      cardOnToast: (label) => `Đã bật thẻ ${label}`,
      cardOffToast: (label) => `Đã tắt thẻ ${label}`,
      cardOnHandoffTitle: 'Quẹt thẻ khi nhận',
      acceptingCardOnHandoff: 'Bật quẹt thẻ khi nhận',
      cardOnHandoffOff: 'Tắt quẹt thẻ khi nhận',
      cardOnHandoffHelp:
        'Khách quẹt thẻ trên máy POS của bạn khi lấy hàng hoặc nhận giao. Không cần nhà cung cấp trực tuyến - bạn tự thu và đối soát như tiền mặt.',
      autoConfirmTitle: 'Tự động xác nhận',
      autoConfirmOn: 'Tự động xác nhận tiền mặt & quẹt thẻ khi nhận',
      autoConfirmOff: 'Xác nhận thủ công',
      autoConfirmHelp:
        'Đơn tiền mặt và quẹt thẻ khi nhận được xác nhận tự động và phiếu bếp in ngay khi có đơn - không cần bấm Chấp nhận. Đơn trực tuyến đã tự xác nhận khi thanh toán; chuyển khoản vẫn cần bạn duyệt.',
      autoConfirmOnToast: (label) => `Đã bật tự động xác nhận ${label}`,
      autoConfirmOffToast: (label) => `Đã tắt tự động xác nhận ${label}`,
      autoCompleteTitle: 'Tự động hoàn tất đơn',
      autoCompleteOn: (minutes) => `Đóng sau giờ đã hẹn ${minutes} phút`,
      autoCompleteOff: 'Bạn tự hoàn tất từng đơn',
      autoCompleteHelp:
        'Đơn bạn chưa đóng sẽ được tự hoàn tất một lúc sau giờ đã hẹn với khách. Tắt nếu bạn tự bấm Hoàn tất - khi đó đơn sẽ mở cho tới khi bạn đóng.',
      autoCompleteOnToast: (label) => `Đơn ${label} tự hoàn tất`,
      autoCompleteOffToast: (label) => `Đơn ${label} mở cho tới khi bạn hoàn tất`,
      autoCompleteSaveFailed: 'Không lưu được thời gian chờ. Vui lòng thử lại.',
      autoCompleteDelayTitle: 'Chờ trước khi hoàn tất',
      autoCompleteDelayFooter: 'Số phút sau giờ đã hẹn thì đơn được đóng giúp bạn.',
      cardOnHandoffOnToast: (label) => `Đã bật quẹt thẻ khi nhận ${label}`,
      cardOnHandoffOffToast: (label) => `Đã tắt quẹt thẻ khi nhận ${label}`,
      availabilityTitle: 'Tình trạng',
      accepting: 'Đang nhận đơn',
      pausedUntilClose: 'Tạm dừng đến giờ đóng cửa',
      pausedResumes: (time) => `Tạm dừng · tiếp tục lúc ${time}`,
      paused: 'Tạm dừng',
      live: 'Đang hoạt động',
      disabled: 'Đã tắt',
      availabilityFooter:
        'Trạng thái thực tế của việc nhận đơn mới. Chạm vào một kênh để tạm dừng khi đông khách hoặc gặp sự cố bếp (theo thời gian / đến giờ đóng cửa) hoặc để tiếp tục. Việc này độc lập với việc bật loại đặt hàng ở trên - các đơn hiện có không bao giờ bị ảnh hưởng.',
      orderingLabel: (label) => `Đặt hàng ${label}`,
      pause30: 'Tạm dừng 30 phút',
      pause1Hour: 'Tạm dừng 1 giờ',
      pauseHours: (n) => `Tạm dừng ${n} giờ`,
      pauseUntilClose: 'Tạm dừng đến giờ đóng cửa',
      resumeNow: 'Tiếp tục ngay',
      cancel: 'Hủy',
      pausedUntilCloseToast: (label) => `Đã tạm dừng ${label} đến giờ đóng cửa`,
      pausedForToast: (label, minutes) => `Đã tạm dừng ${label} trong ${minutes} phút`,
      resumedToast: (label) => `Đã tiếp tục ${label}`,
      minimumOrderTitle: 'Đơn hàng tối thiểu',
      smallestBasket: 'Giỏ hàng nhỏ nhất cho phép',
      noMinimum: 'Không tối thiểu',
      minimumOrderFooter:
        'Tổng giá trị giỏ hàng nhỏ nhất mà khách có thể thanh toán, theo từng kênh. Đặt 0 để không có mức tối thiểu.',
      minPrompt: (label) => `Tổng đơn hàng ${label} tối thiểu (0 = không tối thiểu)`,
      minDialogTitle: 'Đơn hàng tối thiểu',
      minSet: (label, amount) => `Đã đặt ${label} tối thiểu thành ${amount}`,
      minRemoved: (label) => `Đã gỡ ${label} tối thiểu`,
      deliveryPricingTitle: 'Định giá giao hàng',
      deliveryPricingFooter:
        'Cách tính phí giao hàng - theo khoảng cách từ nhà hàng, hoặc theo khu vực vẽ trên bản đồ.',
      byDistance: 'Theo khoảng cách',
      byDistanceFooter: 'Tính phí theo bậc dựa trên khoảng cách của khách hàng.',
      byMapZones: 'Theo khu vực bản đồ',
      byMapZonesFooter: 'Vẽ các khu vực giao hàng trên bản đồ, mỗi khu vực có phí riêng.',
      straightLine: 'Khoảng cách đường thẳng',
      straightLineFooter: 'Theo đường chim bay. Miễn phí, tức thì.',
      drivingDistance: 'Khoảng cách lái xe (MapBox)',
      drivingDistanceFooter: 'Khoảng cách đường thực tế. Chính xác hơn; dùng MapBox.',
      deliveryWarnings: {
        title: 'Giao hàng chưa sẵn sàng cho khách',
        subtitle: 'Khách sẽ gặp các vấn đề này khi đặt hàng — mà không được cho biết lý do.',
        locationNotPinned: 'Nhà hàng chưa được ghim trên bản đồ',
        locationNotPinnedEffect:
          'Khoảng cách được tính từ nhà hàng, nên mọi địa chỉ đều bị báo là ngoài vùng giao.',
        noActiveZones: 'Chưa có vùng giao hàng cho cách tính phí đang chọn',
        noActiveZonesEffect: 'Mọi địa chỉ đều nhận thông báo không giao tới nơi đó.',
        zoneMissingTime: (zone: string) => `“${zone}” chưa có thời gian giao`,
        zoneMissingTimeEffect: 'Khách nhận thời gian chưa tính quãng đường, nên đơn hàng đến muộn.',
        noPaymentMethod: 'Chưa bật phương thức thanh toán nào',
        noPaymentMethodEffect: 'Khách chọn được món nhưng không đặt hàng được.',
      },
      pinRequiredForRouteTitle: 'Ghim nhà hàng trước',
      pinRequiredForRoute:
        'Khoảng cách lái xe được tính từ vị trí nhà hàng. Hãy đặt vị trí trên bản đồ trong cài đặt nhà hàng, rồi chuyển sang khoảng cách lái xe.',
      dispatchBufferTitle: 'Thời gian dự phòng khi giao',
      dispatchBufferFooter:
        'Số phút cộng thêm vào thời gian lái xe — để gộp nhiều đơn, tìm chỗ đỗ và đi tới cửa. Để 0 nếu thời gian tuyến đường đã sát thực tế.',
      dispatchBufferLabel: 'Số phút cộng thêm',
      restaurantLocation: 'Vị trí nhà hàng',
      pinned: 'Đã ghim',
      notSet: 'Chưa đặt',
      locationFooter:
        'Điểm để đo khoảng cách và thời gian lái xe giao hàng. Bắt buộc cho định giá theo khoảng cách; với khu vực bản đồ, điểm này dùng để tính ETA giao hàng trực tiếp (chưa chấm thì dùng ước tính tĩnh).',
      deliveryPricingSaveFailed: 'Lưu định giá giao hàng thất bại',
      switchModeConfirmTitle: 'Đổi cách tính phí?',
      switchModeConfirm:
        'Khi đổi cách tính phí, các vùng bạn đã tạo cho phương thức kia sẽ không còn được dùng nữa. Tiếp tục?',
      deliveryZonesTitle: 'Khu vực giao hàng',
      distanceBandsTitle: 'Dải giá theo khoảng cách',
      bandForm: {
        newTitle: 'Dải khoảng cách mới',
        editTitle: 'Sửa dải khoảng cách',
        back: 'Quay lại',
        nameLabel: 'Tên dải',
        namePlaceholder: 'vd: Trung tâm, Trong vòng 5 km',
        kmLabel: 'Giao trong vòng (km)',
        kmPlaceholder: 'vd: 5',
        feeLabel: 'Phí giao hàng',
        feePlaceholder: '0',
        minOrderLabel: 'Đơn tối thiểu',
        minOrderPlaceholder: '0 = không giới hạn',
        areaLabel: 'Khu vực giao',
        areaAfter: 'Vẽ trên bản đồ',
        areaFooter: 'Khu vực này được vẽ trên bản đồ và không sửa được ở đây.',
        nameRequired: 'Hãy đặt tên cho dải.',
        kmRequired: 'Đặt khoảng cách giao của dải này (km).',
        invalidInput: 'Giá trị không được âm - chưa lưu gì cả.',
        invalidNumber: 'Nhập một số, ví dụ 2.5.',
        wholeMinutes: 'Chỉ nhập số phút nguyên, ví dụ 30.',
        updated: 'Đã cập nhật dải khoảng cách',
        added: 'Đã thêm dải khoảng cách',
        deliveryTimeLabel: 'Thời gian giao (phút)',
        deliveryTimePlaceholder: 'ví dụ 45',
        deliveryTimeInfo: 'Chỉ thời gian lái xe — thời gian chế biến được cộng thêm.',
        deliveryTimeRequired: 'Hãy đặt số phút giao hàng cho khu vực này.',
        saveFailed: 'Lưu dải thất bại',
      },
      addDistanceBand: '+ Thêm dải khoảng cách',
      noDistanceBands: 'Chưa có dải khoảng cách nào - chưa giao được tới khi thêm ít nhất một dải.',
      distanceBandsFooter:
        'Tính phí cố định theo từng dải khoảng cách chim bay (vd ≤ 3 km → €2.50). Dải gần nhất phủ được địa chỉ sẽ áp dụng.',
      drivingBandsFooter:
        'Tính phí cố định theo từng dải khoảng cách lái xe (vd ≤ 3 km đường bộ → €2.50). Khoảng cách đo theo đường thực tế qua MapBox; dải gần nhất phủ được địa chỉ sẽ áp dụng.',
      noZones:
        'Chưa có khu vực giao hàng - giao hàng không khả dụng cho đến khi thêm ít nhất một khu vực.',
      mapArea: 'Vùng bản đồ',
      within: (km) => `Trong vòng ${km} km`,
      noRangeSet: 'Chưa đặt phạm vi',
      addZone: '+ Thêm khu vực giao hàng',
      drawArea: '+ Vẽ khu vực giao hàng',
      zonesFooter:
        'Mỗi khu vực xác định phạm vi cùng phí giao hàng và đơn hàng tối thiểu riêng. Khách hàng thấy khu vực phù hợp nhỏ nhất.',
      deleteZoneConfirm: (label) => `Xóa khu vực "${label}"?`,
      deleteZoneTitle: 'Xóa khu vực',
      zoneDeleted: 'Đã xóa khu vực',
      methodsTitle: 'Phương thức thanh toán thủ công',
      noMethods:
        'Chưa có phương thức thanh toán thủ công - chỉ các tùy chọn mặc định được cung cấp khi thanh toán.',
      active: 'Đang hoạt động',
      inactive: 'Không hoạt động',
      addMethod: '+ Thêm phương thức thanh toán',
      methodsFooter:
        'Các tùy chọn thanh toán khi đến nơi hoặc chuyển khoản ngân hàng được hiển thị khi thanh toán. Khách hàng làm theo hướng dẫn và nhân viên xác nhận biên lai thủ công.',
      deleteMethodConfirm: (name) => `Xóa phương thức "${name}"?`,
      deleteMethodTitle: 'Xóa',
      methodDeleted: 'Đã xóa phương thức',
      zoneMapForm: {
        newTitle: 'Khu vực giao hàng mới',
        editTitle: 'Chỉnh sửa khu vực',
        drawFooter:
          'Chạm vào công cụ vẽ đa giác (góc trên bên trái bản đồ) để bắt đầu, sau đó chạm vào từng góc của khu vực giao hàng; chạm đúp để đóng hình. Dùng công cụ thùng rác để vẽ lại. Sau đó đặt phí và mức tối thiểu bên dưới.',
        nameLabel: 'Tên khu vực',
        namePlaceholder: 'vd. Trung tâm thành phố',
        feeLabel: 'Phí giao hàng',
        feePlaceholder: '0',
        minOrderLabel: 'Đơn hàng tối thiểu',
        minOrderPlaceholder: '0 = không tối thiểu',
        deliveryTimeLabel: 'Thời gian giao (phút)',
        deliveryTimePlaceholder: 'ví dụ 45',
        deliveryTimeInfo: 'Chỉ thời gian lái xe — thời gian chế biến được cộng thêm.',
        nameRequired: 'Đặt tên cho khu vực.',
        drawRequired: 'Hãy vẽ khu vực giao hàng trên bản đồ trước.',
        minOrderRequired: 'Đặt đơn hàng tối thiểu (nhập 0 nếu không có mức tối thiểu).',
        deliveryTimeRequired: 'Hãy đặt số phút giao hàng cho khu vực này.',
        invalidNumber: 'Nhập một số, ví dụ 2.5.',
        wholeMinutes: 'Chỉ nhập số phút nguyên, ví dụ 30.',
        updated: 'Đã cập nhật khu vực',
        added: 'Đã thêm khu vực',
        saveFailed: 'Lưu khu vực thất bại',
      },
      locationForm: {
        tapPrompt: 'Chạm vào bản đồ để đặt vị trí nhà hàng của bạn.',
        saved: 'Đã lưu vị trí',
        saveFailed: 'Lưu vị trí thất bại',
        footer:
          'Kéo ghim (hoặc chạm vào bản đồ) đến đúng vị trí nhà hàng của bạn - chúng tôi đo khoảng cách giao hàng từ đây.',
        currentCoords: (lat, lng) => ` Hiện tại: ${lat}, ${lng}.`,
        clear: 'Xóa vị trí',
        cleared: 'Đã xóa vị trí',
        clearFailed: 'Không thể xóa vị trí',
      },
    },
    mapPicker: {
      searchPlaceholder: 'Tìm một địa chỉ…',
      search: 'Tìm kiếm',
      noResults: 'Không tìm thấy - hãy thử tên/địa chỉ cụ thể hơn, hoặc tự đặt ghim thủ công.',
      pickHint: 'Chọn kết quả gần đúng nhất, sau đó kéo ghim để tinh chỉnh:',
      unavailable: 'Bản đồ không khả dụng - đặt VITE_MAPBOX_TOKEN để bật ghim vị trí.',
    },
    polygonEditor: {
      unavailable: 'Bản đồ không khả dụng - đặt VITE_MAPBOX_TOKEN để vẽ khu vực giao hàng.',
      restaurant: 'Nhà hàng',
      editingArea: 'Khu vực này (đang chỉnh sửa)',
      newArea: 'Khu vực này (mới)',
    },
  },

  orderCapacity: {
    save: 'Lưu',
    saving: 'Đang lưu…',
    pickup: 'Lấy tại quầy',
    delivery: 'Giao hàng',
    unsavedConfirm: 'Bạn có thay đổi chưa lưu trên kênh này. Chuyển và bỏ thay đổi?',
    unsavedTitle: 'Thay đổi chưa lưu',
    everyDay: 'Mỗi ngày',
    dayNamesShort: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    dayNamesLong: ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy'],
    noCap: 'không giới hạn',
    ordersPerHour: (n) => `${n} đơn/giờ`,
    ordersPerSlotMin: (n, slot) => `${n} đơn / ${slot} phút`,
    holidayCapText: (max, slot) => `${max} đơn/${slot}phút`,
    ordersWithUnit: (cap, unit) => `${cap} đơn${unit}`,
    defaultCapacity: 'Sức chứa mặc định',
    defaultCapacityFooter:
      'Độ dài khung giờ, số đơn mỗi khung, thời gian chuẩn bị và thời gian báo trước tối thiểu cho kênh này. Để trống giới hạn để không giới hạn.',
    slotIntervalLabel: 'Khoảng cách khung giờ (phút)',
    slotLengthLabel: 'Độ dài khung (phút)',
    ordersPerSlotLabel: 'Số đơn mỗi khung',
    maxOrdersPerHourLabel: 'Số đơn tối đa mỗi giờ',
    capacityWindowLabel: 'Khung giới hạn (phút)',
    capacityWindowFooter:
      'Khoảng thời gian dùng để đếm giới hạn. Để trống để giới hạn theo từng khung đặt. Đặt rộng hơn (bội số của khoảng khung) để trải giới hạn trên thời gian dài hơn — ví dụ khung 15 + cửa sổ 60: khách đặt mỗi 15 phút nhưng giới hạn tính theo giờ.',
    capacityWindowAlert:
      'Khung giới hạn phải là bội số nguyên của khoảng khung (hoặc để trống để giới hạn theo từng khung).',
    prepTimeLabel: 'Thời gian chuẩn bị tại bếp (phút)',
    minNoticeLabel: 'Báo trước tối thiểu (phút)',
    openingBufferLabel: 'Sớm nhất sau giờ mở cửa (phút)',
    nonePlaceholder: 'không có',
    preview: 'Xem trước',
    defaultFooter:
      'Đặt hàng trực tuyến tuân theo giờ mở cửa của bạn. Thêm giờ đặc biệt bên dưới cho các khung giờ khác nhau vào những ngày cụ thể.',
    capAlert: 'Giới hạn phải là số nguyên dương (hoặc để trống nếu không giới hạn)',
    slotAlert: 'Độ dài khung phải là số nguyên dương',
    prepNoticeAlert: 'Thời gian chuẩn bị / báo trước phải là số nguyên (hoặc để trống)',
    openingBufferAlert: (max: number) =>
      `Sớm nhất sau giờ mở cửa phải là số nguyên từ 0 đến ${max}`,
    saveErrorGeneric: 'Không thể lưu năng lực mặc định - vui lòng tải lại trang và thử lại.',
    saveFailedTitle: 'Lưu thất bại',
    setDefaultFirst: 'Hãy đặt năng lực mặc định trước',
    specialHours: 'Giờ đặc biệt',
    noSpecialHours: 'Không có - mặc định áp dụng mỗi ngày.',
    pausedSuffix: (label) => `${label} · tạm dừng`,
    holidayHours: 'Giờ ngày lễ',
    holidayFooter:
      'Ghi đè theo khoảng ngày, thay thế CẢ giờ đặc biệt lẫn giờ thông thường (mở/đóng cửa + năng lực) khi đang áp dụng.',
    noHolidays: 'Không có - áp dụng giờ thông thường và giờ đặc biệt.',
    offSuffix: (name) => `${name} · tắt`,
  },

  orders: {
    acceptOrder: 'Nhận đơn',
    markCompleted: 'Đánh dấu hoàn thành',
    cancelOrder: 'Hủy đơn',
    undoCompletion: 'Hoàn tác hoàn thành',
    restoreOrder: 'Khôi phục đơn',
    status: {
      PENDING: 'Chờ xử lý',
      CONFIRMED: 'Đã xác nhận',
      COMPLETED: 'Đã hoàn thành',
      CANCELLED: 'Đã hủy',
    },
    type: {
      PICKUP: 'Lấy tại quán',
      DELIVERY: 'Giao hàng',
    },
    itemCount: (count) => `${count} món${count !== 1 ? '' : ''}`,
    emptyState: {
      noSelection: {
        title: 'Chưa chọn đơn nào',
        description: 'Chọn một đơn từ danh sách để xem chi tiết tại đây.',
      },
      notFound: {
        title: 'Không tìm thấy đơn',
      },
      loadError: {
        title: 'Không tải được đơn hàng',
        description: 'Vui lòng thử lại.',
      },
      noOrders: {
        title: 'Không có đơn hàng',
        filteredDescription: 'Không có đơn nào khớp với bộ lọc đã chọn.',
        defaultDescription: 'Đơn hàng sẽ hiển thị tại đây khi khách đặt.',
      },
    },
    action: {
      acceptOrder: {
        success: 'Đã nhận đơn',
      },
      completeOrder: {
        confirm: 'Đánh dấu đơn này là đã hoàn thành?',
        title: 'Hoàn thành đơn',
        success: 'Đã hoàn thành đơn',
      },
      cancelOrder: {
        confirm: 'Hủy đơn này?',
        title: 'Hủy đơn',
        success: 'Đã hủy đơn',
      },
      undoCompletion: {
        confirm:
          'Hoàn tác hoàn thành đơn này? Đơn chuyển sang đã hủy, tiền mặt tính là chưa thu và điểm đã cộng sẽ bị thu hồi. Khách không nhận được thông báo.',
        title: 'Hoàn tác hoàn thành',
        success: 'Đã hoàn tác',
      },
      restoreOrder: {
        confirm:
          'Khôi phục đơn này thành hoàn thành? Tiền mặt được tính là đã thu lại và điểm được cộng lại. Khách không nhận được thông báo.',
        title: 'Khôi phục đơn',
        success: 'Đã khôi phục đơn',
      },
    },
    acceptSheet: {
      title: 'Nhận đơn',
      confirm: 'Xác nhận & bắt đầu',
      failed: 'Không thể nhận đơn.',
      prepLabel: 'Thời gian chuẩn bị',
      deliveryLabel: 'Thời gian giao',
      minutes: (m) => `${m} phút`,
      readyForPickup: 'Sẵn sàng lấy',
      foodReady: 'Món xong',
      deliveredBy: 'Giao lúc',
      scheduledFor: 'Hẹn lúc',
      startPrepBy: 'Bắt đầu làm',
      driverLeaves: 'Tài xế xuất phát',
      now: 'Bây giờ',
    },
    cancelSheet: {
      keep: 'Giữ đơn',
      refundToggle: 'Hoàn tiền cho khách',
      refundLine: (amount: string, provider: string) =>
        `Hủy đơn sẽ hoàn ${amount} cho khách qua ${provider}.`,
      noRefundWarning: 'Hủy mà không hoàn tiền — khách sẽ không nhận lại tiền.',
      failed: 'Không thể hủy đơn hàng.',
    },
    payment: {
      acceptProof: {
        confirm: 'Chấp nhận bằng chứng thanh toán này?',
        title: 'Chấp nhận bằng chứng',
        success: 'Đã chấp nhận bằng chứng',
      },
      rejectProof: {
        prompt: 'Lý do từ chối',
        title: 'Từ chối bằng chứng',
        success: 'Đã từ chối bằng chứng',
      },
    },
    paymentStatus: {
      PENDING_COLLECTION: 'Chờ thanh toán',
      AWAITING_PROOF: 'Chờ bằng chứng',
      PROOF_SUBMITTED: 'Đã gửi bằng chứng',
      PROCESSING: 'Đang xử lý',
      PAID: 'Đã thanh toán',
      REJECTED: 'Đã từ chối',
      VOID: 'Vô hiệu',
      REFUNDED: 'Đã hoàn tiền',
      PARTIALLY_REFUNDED: 'Hoàn tiền một phần',
      AWAITING_CARD_PAYMENT: 'Chờ thanh toán thẻ',
    },
    paymentMethod: {
      CASH: 'Tiền mặt',
      MANUAL: 'Chuyển khoản',
      ONLINE: 'Thẻ',
    },
    refund: {
      reasons: {
        CUSTOMER_REQUEST: 'Khách yêu cầu',
        ITEM_UNAVAILABLE: 'Hết món',
        WRONG_ITEM: 'Sai món',
        LATE_DELIVERY: 'Giao hàng trễ',
        CANCELLED_BY_OWNER: 'Chủ quán hủy',
        OTHER: 'Khác',
      },
      issued: 'Đã hoàn tiền',
      now: 'Hoàn tiền ngay',
      confirmNow: (amount) => `Hoàn ${amount} cho khách ngay bây giờ?`,
      failed: 'Không thể thực hiện hoàn tiền.',
      failedReason: (reason) => `Hoàn tiền thất bại: ${reason}`,
      recordedPending: 'Đã ghi nhận hoàn tiền — chờ chi trả.',
      info: (amount) => `Hoàn được tối đa ${amount}.`,
      amountLabel: 'Số tiền',
      reasonLabel: 'Lý do',
      amountError: 'Nhập số tiền từ 0 đến số tiền còn được hoàn.',
      outOfBandNote:
        'Việc hoàn tiền cho khoản thanh toán thẻ này được xử lý bên ngoài ứng dụng qua nhà cung cấp thanh toán của bạn.',
      button: 'Hoàn tiền',
      submitButton: (amount) => `Hoàn ${amount}`,
    },
    section: {
      items: 'Món',
      deliveryAddress: 'Địa chỉ giao hàng',
      payment: 'Thanh toán',
      refund: 'Hoàn tiền',
      customerNote: 'Ghi chú của khách',
      timeline: 'Dòng thời gian',
      labels: 'Nhãn',
    },
    // Operator triage tags on an order (chip row on the detail, compact
    // pills on the list rows). Label NAMES are owner data — never translated.
    fields: {
      status: 'Trạng thái',
      kitchen: 'Bếp',
      subtotal: 'Tạm tính',
      deliveryFee: 'Phí giao hàng',
      discount: 'Giảm giá',
      promoCode: 'Mã khuyến mãi',
      total: 'Tổng cộng',
      method: 'Phương thức',
      placed: 'Đã đặt',
      scheduledFor: 'Hẹn vào',
      estimatedReady: 'Dự kiến sẵn sàng',
      prepStarted: 'Bắt đầu chế biến',
      refunded: 'Đã hoàn tiền',
      acceptProof: 'Chấp nhận bằng chứng',
      rejectProof: 'Từ chối bằng chứng',
    },
    kitchen: {
      QUEUED: 'Trong hàng đợi',
      PREPARING: 'Đang chế biến',
      READY: 'Sẵn sàng',
      SERVED: 'Đã phục vụ',
    },
    quickAction: {
      callCustomer: 'Gọi khách',
      messageCustomer: 'Nhắn tin cho khách',
      call: 'Gọi',
      message: 'Nhắn tin',
      printTicket: 'In bon',
      printTicketAria: 'In bon bếp cho đơn này',
      printQueued: 'Đã xếp hàng in bon',
      printQueuedMany: (n: number) => `Đã xếp hàng in ${n} bon`,
      printFailed: 'Không xếp hàng in bon được',
    },
    pause: {
      live: 'Đang mở',
      paused: 'Tạm dừng',
      pausedUntilClose: 'Tạm dừng · đóng cửa',
      pausedUntilTime: (time) => `Tạm dừng · ${time}`,
      action: {
        label: (label) => `Đặt ${label}`,
        pause30: 'Tạm dừng 30 phút',
        pause1hour: 'Tạm dừng 1 giờ',
        pauseHours: (n) => `Tạm dừng ${n} giờ`,
        pauseUntilClose: 'Tạm dừng đến khi đóng cửa',
        resumeNow: 'Tiếp tục ngay',
      },
      toast: {
        paused: (label) => `Đã tạm dừng ${label}`,
        pausedFor: (label, minutes) => `Đã tạm dừng ${label} trong ${minutes} phút`,
        pausedUntilClose: (label) => `Đã tạm dừng ${label} đến khi đóng cửa`,
        resumed: (label) => `Đã tiếp tục ${label}`,
      },
    },
    summary: {
      total: 'Tổng cộng',
      pending: 'Chờ xử lý',
      confirmed: 'Đã xác nhận',
    },
    page: {
      title: 'Đơn hàng',
    },
    detail: {
      title: 'Đơn hàng',
    },
    list: {
      section: {
        pending: 'Chờ xử lý',
        confirmed: 'Đã xác nhận',
        completed: 'Đã hoàn thành',
        cancelled: 'Đã hủy',
      },
    },
    stages: {
      NEEDS_REVIEW: 'Cần duyệt thanh toán',
      NEEDS_ACCEPTANCE: 'Đơn mới',
      IN_KITCHEN: 'Đang nấu',
      READY: 'Sẵn sàng',
      AWAITING_PAYMENT: 'Chờ khách thanh toán',
      COMPLETED: 'Đã hoàn thành',
      CANCELLED: 'Đã hủy',
    },
    summaryBar: {
      pending: 'Cần xử lý',
      active: 'Đang xử lý',
      overdue: 'Quá hạn',
    },
    all: 'Tất cả',
    filter: 'Bộ lọc',
    now: 'Bây giờ',
    copy: 'Sao chép',
    addressCopied: 'Đã sao chép địa chỉ',
    phoneCopied: 'Đã sao chép số điện thoại',
    tel: 'SĐT:',
    openInMaps: 'Mở trong Google Maps',
    mapRoute: 'Lộ trình',
    mapDestination: 'Điểm đến',
    deliveryDistance: (distance: string) => `Cách nhà hàng ${distance}`,
    expired: 'Đã hết hạn',
    autoCancelsIn: 'Tự động hủy sau',
    pickupLocation: 'Địa điểm lấy hàng',
    paymentProof: 'Bằng chứng thanh toán',
    zoneMethod: {
      STRAIGHT_LINE: 'khoảng cách đường thẳng',
      ROUTE_DISTANCE: 'khoảng cách lái xe (MapBox)',
      POLYGON: 'vùng trên bản đồ',
    },
    zoneLabel: (label, method) => `Vùng: ${label} · ${method}`,
    ordersCount: (n) => `${n} đơn`,
    ordersByHour: (n) => `${n} đơn theo giờ`,
    ordersByHourLabel: 'Đơn theo giờ',
    chartBusiest: (label, count) => `. Cao điểm ${label} · ${count}`,
    capacityPerHour: (cap, label) => `${cap}/giờ ${label}`,
    nextTwoHours: (n) => `2 giờ tới · ${n} đơn`,
    sectionCount: (label, count) => `${label} · ${count}`,
    proof: {
      openPdf: 'Mở bằng chứng PDF đã tải lên',
      alt: 'Bằng chứng thanh toán của khách',
      openFullSize: 'Mở kích thước đầy đủ',
      customerStated: (amount) => `Khách khai báo: ${amount}`,
      uploaded: (when) => `Tải lên ${when}`,
      rejectHint: 'Đơn vẫn mở - khách có thể tải lại cho đến hạn thanh toán.',
      rejectSuccess: 'Đã từ chối bằng chứng - đơn vẫn mở để tải lại',
    },
    paymentStatusLabels: {
      PENDING_COLLECTION: 'Chờ thu tiền',
      AWAITING_PROOF: 'Chờ bằng chứng',
      PROOF_SUBMITTED: 'Đã gửi bằng chứng',
      PROCESSING: 'Đang xử lý',
      ON_HOLD: 'Đang xem xét',
      PAID: 'Đã thanh toán',
      REJECTED: 'Đã từ chối',
      VOID: 'Vô hiệu',
      REFUNDED: 'Đã hoàn tiền',
      PARTIALLY_REFUNDED: 'Hoàn tiền một phần',
      awaitingCardPayment: 'Chờ thanh toán thẻ',
      underReviewByProvider: 'Nhà cung cấp đang xem xét',
      awaitingCardCollection: 'Chờ thu tiền thẻ',
    },
    methodKind: {
      CASH: 'Tiền mặt',
      CARD_ON_HANDOFF: 'Thẻ khi giao',
      MANUAL: 'Chuyển khoản',
      ONLINE: 'Thẻ',
      GIFT_CARD: 'Thẻ quà tặng',
    },
    pill: {
      paid: 'Đã thanh toán',
      refunded: 'Đã hoàn tiền',
      awaiting: 'Chờ thanh toán',
      failed: 'Thanh toán thất bại',
      refundNeeded: 'Cần hoàn tiền',
    },
    refundExtra: {
      max: (amount, currency) => `Tối đa ${amount} (${currency})`,
      confirmSettled: 'Xác nhận đã chi',
      settled: '✓ Đã chi',
      failed: 'Hoàn tiền thất bại',
      settlePrompt: 'Xác nhận bạn đã hoàn khoản tiền này cho khách bên ngoài ứng dụng?',
      settleTitle: 'Xác nhận đã hoàn tiền',
      settledToast: 'Đã hoàn tiền',
      pending: (amount) => `+${amount} đang chờ`,
      pendingShort: 'Đang chờ hoàn tiền',
    },
    channelStatus: {
      open: 'Đang mở',
      closed: 'Đã đóng',
      paused: 'Tạm dừng',
      close: 'đóng cửa',
    },
    timing: {
      asap: 'Tức thì',
      labelScheduled: 'Đã hẹn',
      labelReadyBy: 'Sẵn sàng lúc',
      labelDeliveredBy: 'Giao lúc',
      labelPlaced: 'Đã đặt',
      dueNow: 'đến hạn',
      inMin: (m) => `sau ${m} phút`,
      inHrMin: (h, m) => (m ? `sau ${h} giờ ${m} phút` : `sau ${h} giờ`),
      minOverdue: (m) => `quá hạn ${m} phút`,
      hrMinOverdue: (h, m) => (m ? `quá hạn ${h} giờ ${m} phút` : `quá hạn ${h} giờ`),
      placedAgo: (ago) => `đặt ${ago}`,
      justNow: 'vừa xong',
      minAgo: (m) => `${m} phút trước`,
      hrMinAgo: (h, m) => (m ? `${h} giờ ${m} phút trước` : `${h} giờ trước`),
      chipScheduled: 'đã hẹn',
      chipReady: 'sẵn sàng',
      chipOverdue: 'quá hạn',
      shortNow: 'ngay',
      shortMin: (m) => `${m}p`,
      shortHr: (h) => `${h}g`,
    },
    awaitingPayment: {
      title: 'Chờ khách thanh toán',
      tooltip: 'Chờ khách thanh toán',
      refresh: 'Làm mới',
      loadError: 'Không tải được các đơn chờ thanh toán.',
      empty: 'Không có đơn nào chờ thanh toán',
      emptyDescription:
        'Các đơn đang chờ bằng chứng chuyển khoản hoặc thanh toán trực tuyến sẽ hiển thị ở đây.',
      footer:
        'Các đơn này chưa vào hàng đợi bếp. Đơn sẽ chuyển sang mục Đơn hàng khi thanh toán được xác nhận và tự động bị huỷ khi hết hạn.',
      expiresIn: 'Hạn thanh toán:',
      noDeadline: 'không có hạn',
      call: (name: string) => `Gọi ${name}`,
    },
    history: {
      title: 'Lịch sử đơn hàng',
      tooltip: 'Lịch sử đơn hàng',
      refresh: 'Làm mới',
      loading: 'Đang tải đơn hàng…',
      loadError: 'Không tải được lịch sử.',
      tryAgain: 'Thử lại',
      empty: 'Không có đơn nào trong khoảng này.',
      today: 'Hôm nay',
      yesterday: 'Hôm qua',
      filters: 'Bộ lọc',
      reset: 'Đặt lại',
      showOrders: 'Xem đơn hàng',
      prevMonth: 'Tháng trước',
      nextMonth: 'Tháng sau',
      weekdayInitials: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
      tabs: {
        all: 'Tất cả',
        pending: 'Chờ xử lý',
        active: 'Đã xác nhận',
        done: 'Đã hoàn thành',
        void: 'Đã hủy',
      },
      statusLabel: {
        PENDING: 'Chờ xử lý',
        CONFIRMED: 'Đang xử lý',
        COMPLETED: 'Đã hoàn thành',
        CANCELLED: 'Đã hủy',
      },
    },
  },

  print: {
    // Server Direct Print (shared: Printers list + Printer add/edit form)
    serverDirectTitle: 'In trực tiếp từ máy chủ',
    serverDirectFooter:
      'Nhập hai URL này vào phần cài đặt In trực tiếp từ máy chủ của mỗi máy Epson, cùng với Mã máy in riêng của máy đó (hiển thị khi bạn mở máy in).',
    printUrlLabel: 'URL in',
    notificationUrlLabel: 'URL thông báo',
    printerIdLabel: 'Mã máy in',
    copyButton: 'Sao chép',
    copied: (label) => `Đã sao chép ${label}`,
    okButton: 'OK',

    // Printer status (shared: printer badges + status-history events)
    statusOnline: 'Trực tuyến',
    statusOffline: 'Ngoại tuyến',
    statusError: 'Lỗi',
    defaultBadge: 'Mặc định',

    // Printers list page
    couldntLoadPrinters: 'Không tải được máy in',
    noPrintersTitle: 'Chưa có máy in',
    noPrintersDesc: 'Thêm máy in bếp để các đơn được kích hoạt in ra. Nhấn + để bắt đầu.',
    printersTitle: 'Máy in',
    printersFooter:
      'Trạng thái cập nhật mỗi khi máy in báo về. Máy in chưa báo về gần đây sẽ hiển thị Ngoại tuyến; phiếu đang chờ sẽ đợi và in khi máy hoạt động trở lại.',
    queued: (n) => `${n} phiếu đang chờ`,
    noJobsQueued: 'Không có phiếu chờ',
    routingAndHistoryTitle: 'Định tuyến & lịch sử',
    routingTitle: 'Định tuyến phiếu',
    historyTitle: 'Lịch sử in',
    behaviourTitle: 'In những gì',

    // What-to-print settings page
    behaviourPageTitle: 'In những gì',
    behaviourPageFooter:
      'Chọn loại xác nhận nào sẽ tự động in phiếu. Phiếu được gửi tới máy in mặc định.',
    printOnlineOrdersLabel: 'Đơn hàng trực tuyến',
    printOnlineOrdersFooter: 'In phiếu bếp ngay khi bạn chấp nhận đơn lấy tại quầy hoặc giao hàng.',
    printReservationsLabel: 'Đặt bàn đã xác nhận',
    printReservationsFooter: 'In phiếu phục vụ khi bạn xác nhận một lượt đặt bàn. Mặc định tắt.',
    onlineOrdersUpdated: 'Đã cập nhật in đơn trực tuyến',
    reservationsUpdated: 'Đã cập nhật in đặt bàn',

    // Ticket text size
    textSizeTitle: 'Chữ trên phiếu',
    textSizeLabel: 'Cỡ chữ',
    textSizeMedium: 'Vừa',
    textSizeLarge: 'Lớn',
    textSizeFooter:
      'Chữ lớn dễ đọc từ xa trong bếp, nhưng mỗi dòng chứa được ít hơn và tốn khoảng gấp đôi giấy. Dùng In thử trên một máy in để xem trước.',
    textSizeUpdated: 'Đã cập nhật cỡ chữ phiếu in',
    itemCategoryLabel: 'Hiện danh mục dưới mỗi món',
    itemCategoryFooter:
      'In danh mục thực đơn trong ngoặc dưới từng món, ví dụ [Đồ uống]. Hữu ích khi một máy in phục vụ nhiều khu; tắt đi để phiếu ngắn hơn.',
    itemCategoryUpdated: 'Đã cập nhật dòng danh mục',
    itemLabelTitle: 'Nhãn món',
    itemLabelName: 'Chỉ tên',
    itemLabelCodeAndName: 'Mã và tên',
    itemLabelCodeOnly: 'Chỉ mã',
    itemLabelFooter:
      'Mã món giúp phiếu ngắn lại, rõ nhất khi để cỡ chữ lớn. Món chưa có mã luôn in tên, dù bạn chọn kiểu nào.',
    itemLabelUpdated: 'Đã cập nhật nhãn món',
    dateTimeFormatLabel: 'Định dạng ngày',
    dateTimeFormatFooter: 'Cách in ngày trên mọi phiếu. Giờ luôn in theo dạng 24 giờ, ví dụ 19:30.',
    dateTimeFormatUpdated: 'Đã cập nhật định dạng ngày',
    // Xem trước hoá đơn
    previewTitle: 'Xem trước hoá đơn',
    previewFooter:
      'Hoá đơn mẫu theo cài đặt ở trên — đúng như máy in sẽ in ra. Cỡ chữ, danh mục món và nhãn món cập nhật ngay.',
    previewError: 'Không tạo được bản xem trước.',

    // Printer add/edit form
    editPrinterTitle: 'Sửa máy in',
    addPrinterTitle: 'Thêm máy in',
    printerGone: 'Máy in này không còn tồn tại.',
    nameLabel: 'Tên',
    namePlaceholder: 'vd. Bếp, Quầy bar, Khu thu ngân',
    activeLabel: 'Hoạt động',
    defaultPrinterLabel: 'Máy in mặc định',
    defaultPrinterFooter:
      'Phiếu cho các danh mục thực đơn không có máy in riêng - và mọi đơn trực tuyến - sẽ in ra máy in mặc định.',
    migratingTitle: 'Chuyển đổi từ máy in cũ?',
    migratingFooter:
      'Đã cài đặt một máy Epson trên hệ thống cũ? Dán Mã máy in của nó vào đây để tiếp tục in mà không cần ghép nối lại. Để trống nếu muốn tạo mã mới.',
    existingIdLabel: 'Mã máy in đã có',
    existingIdPlaceholder: 'Để trống để tạo mã mới',
    printerSetupTitle: 'Cài đặt máy in',
    printerSetupFooter:
      'Mở phần cài đặt In trực tiếp từ máy chủ của máy in và nhập URL in, URL thông báo cùng Mã máy in này để ghép nối với In-House.',
    // In thử
    testPrintButton: 'In thử một phiếu',
    testPrintSending: 'Đang gửi…',
    testPrintFooter:
      'Gửi một phiếu in thử tới máy in này. Phiếu sẽ ra sau vài giây, khi máy in kết nối lần tới.',
    testPrintQueued: 'Đã gửi phiếu in thử — hãy xem máy in',
    testPrintFailed: 'Không gửi được phiếu in thử.',

    statusHistoryTitle: 'Lịch sử trạng thái',
    eventConnected: 'Đã kết nối',
    noStatusEvents: 'Chưa ghi nhận thay đổi trạng thái nào',
    noStatusEventsFooter: 'Tình trạng kết nối và lỗi sẽ hiển thị tại đây khi xảy ra.',
    nameRequired: 'Hãy đặt tên cho máy in.',
    saveFailed: 'Không thể lưu.',
    idFormatInvalid: 'Mã máy in phải có 8–16 ký tự chữ và số.',
    printerUpdated: 'Đã cập nhật máy in',
    printerAdded: 'Đã thêm máy in',

    // Ticket routing page (stations / pages)
    routingNoPrintersDesc: 'Thêm máy in trước, sau đó thiết lập nơi in cho mỗi đơn.',
    noneSet: 'Chưa đặt',
    noMenuCategories: 'Chưa có danh mục thực đơn.',
    mainPrinterLabel: 'Máy in chính',
    mainPrinterFooter:
      'Toàn bộ đơn sẽ in tại đây - và những món chưa gán cho trạm nào bên dưới cũng in tại đây.',
    splitTitle: 'Tách theo trạm',
    splitToggleLabel: 'Tách phiếu bếp',
    splitFooter:
      'Bật: mỗi đơn được tách ra các máy in theo trạm bên dưới. Tắt: toàn bộ đơn in thành một phiếu trên máy in chính.',
    splitUpdated: 'Đã cập nhật tách phiếu',
    stationsTitle: 'Các trạm',
    stationsFooter:
      'Mỗi trạm in các danh mục thực đơn bạn gán cho nó. Danh mục không thuộc trạm nào sẽ in ở máy in chính.',
    addStationLabel: 'Thêm trạm',
    stationCategoriesCount: (n) => `${n} danh mục`,
    stationSelectionSummary: (categories: number, products: number) => {
      const cat = `${categories} danh mục`;
      if (products === 0) return cat;
      return `${cat} · ${products} sản phẩm`;
    },
    expoTitle: 'Phiếu tổng',
    expoToggleLabel: 'In thêm một phiếu đầy đủ ra máy in chính',
    expoFooter:
      'In một phiếu gồm tất cả các món ra máy in chính - bản dành cho khâu ra món. Các trạm vẫn nhận phiếu riêng của mình.',
    expoUpdated: 'Đã cập nhật phiếu tổng',

    // Station (page) edit form
    editStationTitle: 'Sửa trạm',
    addStationTitle: 'Thêm trạm',
    stationNameLabel: 'Tên',
    stationNamePlaceholder: 'vd. Bếp nóng, Quầy bar, Nướng',
    stationPrinterTitle: 'Máy in',
    noActivePrinters: 'Không có máy in hoạt động. Hãy thêm hoặc kích hoạt một máy in trước.',
    stationCategoriesTitle: 'Danh mục thực đơn',
    stationCategoriesFooter: 'Chọn các danh mục mà trạm này sẽ in.',
    stationMenuTitle: 'Thực đơn — nhấn vào danh mục để mở',
    stationMenuFooter:
      'Tick danh mục để in toàn bộ. Mở ra và tick từng món để chuyển riêng món đó về trạm này.',
    viaCategory: 'theo danh mục',
    legendAll: 'Cả danh mục in ở trạm này',
    legendPartial: 'Một phần — vài món đã chuyển sang trạm khác',
    legendOther: 'Trạm khác đang giữ mục này',
    stationProductsTitle: 'Sản phẩm cụ thể',
    stationProductsFooter:
      'Sản phẩm chọn ở đây sẽ ưu tiên hơn danh mục — dùng khi một danh mục dùng chung nhiều trạm.',
    noMenuProducts: 'Chưa có sản phẩm trong thực đơn.',
    claimedByStation: (station: string) => `Ở ${station}`,
    stationDeleteButton: 'Xóa trạm',
    stationGone: 'Trạm này không còn tồn tại.',
    stationSaved: 'Đã lưu trạm',
    stationDeleted: 'Đã xóa trạm',
    stationNameRequired: 'Hãy đặt tên cho trạm.',
    stationPrinterRequired: 'Hãy chọn một máy in.',

    // Print history (jobs) page
    jobStatusAll: 'Tất cả',
    jobStatusQueued: 'Đang chờ',
    jobStatusPrinting: 'Đang in',
    jobStatusPrinted: 'Đã in',
    jobStatusFailed: 'Thất bại',
    couldntLoadJobs: 'Không tải được lịch sử in',
    noJobsTitle: 'Chưa có phiếu in',
    noJobsDesc: 'Phiếu sẽ hiển thị tại đây khi đơn hàng được lên.',
    receiptLabel: 'Hóa đơn',
    kitchenTicketLabel: 'Phiếu bếp',
    reprintButton: 'In lại',
    reprintQueued: 'Đã đưa lệnh in lại vào hàng chờ',
    copyContent: 'Sao chép nội dung in',
    contentCopied: 'Đã sao chép nội dung in',
    reprintFooter:
      'Chạm vào một phiếu in để in lại - một phiếu mới sẽ được đưa vào hàng chờ; phiếu gốc vẫn được giữ trong lịch sử.',
  },

  promotions: {
    title: 'Khuyến mãi',
    newPromotion: 'Khuyến mãi mới',
    editPromotion: 'Sửa khuyến mãi',
    details: 'Chi tiết',
    name: 'Tên',
    namePlaceholder: 'Cuối tuần giảm 10%',
    description: 'Mô tả',
    descriptionPlaceholder: 'Hiển thị cho khách trên gian hàng',
    discount: 'Giảm giá',
    discountType: {
      percentage: 'Giảm theo phần trăm',
      fixedAmount: 'Giảm số tiền cố định',
      freeDelivery: 'Miễn phí giao hàng',
    },
    percentOff: 'Giảm theo phần trăm',
    percentOffHint: 'vd. 10 nghĩa là giảm 10%',
    maxDiscount: (currency) => `Giảm tối đa (${currency}, tùy chọn)`,
    maxDiscountPlaceholder: 'Không giới hạn',
    amountOff: (currency) => `Số tiền giảm (${currency})`,
    amountOffPlaceholder: '5.00',
    appliesto: 'Áp dụng cho',
    scope: {
      wholeOrder: 'Toàn bộ đơn hàng',
      selectedItems: 'Món được chọn',
    },
    conditions: 'Điều kiện',
    orderType: {
      dineIn: 'Ăn tại quán',
      pickup: 'Lấy tại quán',
      delivery: 'Giao hàng',
    },
    paymentMethodsTitle: 'Phương thức thanh toán',
    paymentMethodsFooter: 'Để trống = áp dụng cho mọi phương thức',
    paymentMethod: {
      cash: 'Tiền mặt',
      cardOnHandoff: 'Thẻ khi nhận',
      online: 'Thanh toán online',
      manual: 'Chuyển khoản',
    },
    minimumOrder: (currency) => `Đơn tối thiểu (${currency}, tùy chọn)`,
    minimumOrderPlaceholder: 'Không tối thiểu',
    dateWindow: 'Khoảng thời gian',
    starts: 'Bắt đầu',
    startDate: 'Ngày bắt đầu',
    ends: 'Kết thúc',
    endDate: 'Ngày kết thúc',
    howUnlocked: 'Cách mở khóa',
    trigger: {
      automatic: 'Tự động (không cần mã)',
      codeRequired: 'Cần mã',
    },
    codeType: {
      shared: 'Mã dùng chung (một mã, mọi người)',
      personal: 'Phiếu cá nhân (cấp riêng cho từng khách)',
    },
    code: 'Mã',
    codePlaceholder: 'SAVE10',
    maxRedemptions: 'Số lần sử dụng tối đa (tùy chọn)',
    maxRedemptionsPlaceholder: 'Không giới hạn',
    oncePerCustomer: 'Một lần mỗi khách',
    visibilityStacking: 'Hiển thị & cộng dồn',
    showOnStorefront: 'Hiển thị trên gian hàng',
    showOnStorefrontFooter: 'Biểu ngữ + huy hiệu sản phẩm cho khách',
    stackable: 'Cộng dồn được',
    stackableFooter: 'Có thể kết hợp với các khuyến mãi cộng dồn khác',
    priority: 'Ưu tiên',
    priorityHint: 'Số nhỏ hơn được áp dụng trước',
    savePromotion: 'Lưu khuyến mãi',
    giveNameError: 'Hãy đặt tên cho khuyến mãi.',
    pickOrderTypeError: 'Chọn ít nhất một loại đơn hàng.',
    chooseDiscountError: 'Chọn đối tượng áp dụng giảm giá.',
    saved: 'Đã lưu khuyến mãi',
    issuePersonalCoupon: 'Cấp phiếu cá nhân',
    customer: 'Khách hàng',
    customerSearchPlaceholder: 'Tìm theo tên hoặc số điện thoại',
    change: 'Thay đổi',
    couponCode: 'Mã phiếu',
    couponCodePlaceholder: 'VIP-JANE',
    sharable: 'Có thể chia sẻ',
    sharableFooter: 'Bất kỳ ai có mã đều có thể dùng, không chỉ khách này',
    issuing: 'Đang cấp…',
    issueCoupon: 'Cấp phiếu',
    pickCustomerError: 'Hãy chọn khách hàng trước.',
    enterCouponError: 'Nhập mã phiếu.',
    couponIssuedTo: (customerName) => `Đã cấp phiếu cho ${customerName}`,
    active: 'Đang hoạt động',
    all: 'Tất cả',
    couldNotLoadError: 'Không tải được khuyến mãi',
    noneRunning: 'Không có khuyến mãi nào đang chạy',
    noneRunningDescription: 'Ưu đãi đã hết hạn và sắp tới nằm ở tab Tất cả.',
    noneYet: 'Chưa có khuyến mãi',
    noneYetDescription:
      'Tạo một ưu đãi - giảm theo phần trăm hoặc số tiền cố định, mở khóa tự động hoặc bằng mã. Nhấn +.',
    codeDisplay: (code) => `Mã: ${code}`,
    archivedBadge: 'Đã lưu trữ',
    scheduledBadge: 'Lên lịch',
    expiredBadge: 'Hết hạn',
    codeBadge: 'Mã',
    archive: 'Lưu trữ',
    archiveConfirm: (name) =>
      `Lưu trữ "${name}"? Khuyến mãi sẽ ngừng ngay lập tức; lịch sử sử dụng vẫn được giữ lại.`,
    archiveTitle: 'Lưu trữ khuyến mãi',
    archived: 'Đã lưu trữ khuyến mãi',
    howWorks: 'Cách khuyến mãi hoạt động',
    howWorksDescription:
      'Khuyến mãi tự động được áp dụng khi thanh toán mà không cần mã. Khuyến mãi theo mã cần một mã dùng chung (cho mọi người) hoặc một phiếu cá nhân bạn cấp cho khách. Mức giảm hiển thị trên gian hàng và giảm tổng tiền đơn hàng.',
    // Nhãn rút gọn trên danh sách khuyến mãi.
    summaryPercent: (pct) => `giảm ${pct}%`,
    summaryAmount: (amount) => `giảm ${amount}`,
    summaryWholeOrder: 'toàn đơn',
    summaryCategories: (n) => `${n} danh mục`,
    summaryProducts: (n) => `${n} sản phẩm`,
    summaryCashOnly: 'Chỉ tiền mặt',
    // Trạng thái & lỗi bổ sung trên trang sửa.
    endBeforeStartError: 'Ngày kết thúc không được trước ngày bắt đầu.',
    scheduleWindowError: 'Kiểm tra lại khung ngày & giờ - giờ kết thúc phải sau giờ bắt đầu.',
    loadingMenu: 'Đang tải thực đơn…',
    menuLoadError: 'Không tải được thực đơn. Kéo để thử lại.',
    noCategoriesYet: 'Chưa có danh mục - thêm trong mục Thực đơn trước.',
    noProductsYet: 'Chưa có sản phẩm - thêm trong mục Thực đơn trước.',
    // Lịch theo ngày/giờ trong tuần.
    daysAndHours: 'Ngày & giờ',
    limitToDays: 'Giới hạn theo ngày & giờ',
    limitToDaysFooter: 'Tắt = áp dụng mọi ngày trong khoảng ngày ở trên',
    windowLabel: (n) => `Khung ${n}`,
    hours: 'Giờ',
    addWindow: 'Thêm khung giờ',
    startAria: (day) => `${day} bắt đầu`,
    endAria: (day) => `${day} kết thúc`,
    removeWindow: 'Xoá khung giờ',
    customerFallback: 'Khách hàng',
    // Lịch sử mã đã cấp (trang chi tiết) + ví mã riêng của khách.
    issuedCoupons: 'Mã đã cấp',
    noCouponsIssued: 'Chưa cấp mã nào',
    customerCoupons: 'Mã riêng',
    noCustomerCoupons: 'Chưa có mã riêng',
    couponUnused: 'Chưa dùng',
    couponRedeemed: 'Đã dùng',
    couponIssuedOn: (date) => `Cấp ${date}`,
    couponRedeemedOn: (date) => `Dùng ${date}`,
    loadingCoupons: 'Đang tải mã…',
    couldNotLoadCoupons: 'Không tải được mã',
    // Chế độ Đơn giản / Nâng cao.
    simpleMode: 'Đơn giản',
    advancedMode: 'Nâng cao',
    advancedValuesHint:
      'Ưu đãi này dùng tùy chọn nâng cao - chuyển sang Nâng cao để xem và chỉnh sửa.',
    // Nhãn các ô chọn.
    discountTypeLabel: 'Loại',
    triggerLabel: 'Kích hoạt',
    codeTypeLabel: 'Loại mã',
  },

  reports: {
    overview: {
      netSales: 'Doanh thu thuần',
      onlineOrders: 'Đơn online',
      dineInTabs: 'Bàn tại quán',
      tips: 'Tiền tip',
      refunds: 'Hoàn tiền',
      discounts: 'Giảm giá',
      vsPrevious: (baseline) => `so với ${baseline}`,
      couldntLoad: 'Không tải được báo cáo',
      noSales: 'Chưa có doanh thu trong kỳ này',
      noSalesHint: 'Hãy chọn kỳ khác, hoặc quay lại khi bắt đầu có đơn hàng.',
      seeAllItems: 'Xem tất cả',
      detailedReports: 'Báo cáo chi tiết',
      tabSales: 'Doanh thu',
      tabOperations: 'Vận hành',
      trendNeedsMoreDays: 'Chọn kỳ dài hơn để thấy xu hướng.',
      byHour: 'Theo giờ',
      tablesUsed: 'Bàn đã dùng',
      turnsPerTable: (turns) => `${turns} lượt mỗi bàn`,
      avgDwell: 'TB thời gian ngồi',
      minutes: (count) => `${count} phút`,
      busiestTables: 'Bàn đông khách nhất',
      turns: (count) => `${count} lượt`,
    },
    periodSelector: {
      current: 'Kỳ',
      compare: 'So với',
      basis: {
        previousPeriod: 'Kỳ trước',
        samePeriodLastYear: 'Năm ngoái',
      },
    },
    salesOverview: {
      title: 'Tổng quan doanh số',
      netSales: 'Doanh thu thuần',
      gross: 'Doanh thu gộp',
      covers: 'Lượt khách',
      avgTab: 'Hóa đơn TB',
      revenueTrend: 'Xu hướng doanh thu',
      byChannel: 'Theo kênh',
      online: 'Trực tuyến',
      dineIn: 'Tại quán',
      byTimeOfDay: 'Theo thời điểm trong ngày',
    },
    dayParts: {
      breakfast: 'Bữa sáng',
      lunch: 'Bữa trưa',
      afternoon: 'Buổi chiều',
      dinner: 'Bữa tối',
      late: 'Khuya',
    },
    dayEnd: {
      title: 'Chốt ngày',
      day: 'Ngày',
      couldntLoad: 'Không tải được chốt ngày',
      netReceived: 'Thực nhận',
      takings: 'Tiền thu',
      refunds: 'Hoàn tiền',
      serviceCharge: 'Phí phục vụ',
      tipsPayout: 'Tiền tip (chi trả)',
      vat: 'Thuế GTGT',
      openTabsWarning: (count, plural) =>
        `${count} ${plural} đang mở - đây là tiền thu đến hiện tại, chưa phải con số cuối cùng.`,
      tabPlural: 'hóa đơn',
      tabsPluralForm: 'hóa đơn',
      reconciliation: 'Từ doanh thu thuần đến tiền thu',
      netSales: 'Doanh thu thuần',
      deliveryFees: 'Phí giao hàng',
      refundsAddedBack: 'Hoàn tiền (đã trừ ở trên)',
      otherDifference: 'Thanh toán vào ngày khác',
      byPaymentMethod: 'Theo phương thức thanh toán',
      cashUp: 'Kiểm tiền mặt',
      expectedInDrawer: 'Dự kiến trong ngăn kéo',
      counted: 'Đã đếm',
      countedPlaceholder: 'Nhập số tiền đã đếm',
      balanced: 'Khớp',
      over: 'Dư',
      short: 'Thiếu',
    },
    paymentReconciliation: {
      title: 'Đối soát thanh toán',
      couldntLoad: 'Không tải được báo cáo',
      paymentCount: (count, plural) => `${count} ${plural}`,
      paymentSingular: 'thanh toán',
      paymentPlural: 'thanh toán',
      grossTaken: 'Tổng thu gộp',
      refunds: 'Hoàn tiền',
      net: 'Thuần',
      tips: 'Tiền tip',
    },
    topItems: {
      title: 'Bán chạy nhất',
      byQuantity: 'Theo số lượng',
      byRevenue: 'Theo doanh thu',
      couldntLoad: 'Không tải được báo cáo',
      noSalesYet: 'Chưa có doanh số',
      noItemsSoldInRange: 'Không có món nào bán ra trong giai đoạn này.',
      sold: (quantity) => `đã bán ${quantity}`,
    },
    rangePresets: {
      today: 'Hôm nay',
      yesterday: 'Hôm qua',
      thisWeek: 'Tuần này',
      last7: '7 ngày qua',
      thisMonth: 'Tháng này',
    },
  },

  reservationSetup: {
    title: 'Thiết lập đặt bàn',
    bookings: 'Lượt đặt',
    bookingsFooter:
      'Bật hoặc tắt đặt bàn trực tuyến, tự động xác nhận yêu cầu, hoặc tạm ngừng cho hết hôm nay.',
    acceptingReservations: 'Đang nhận đặt bàn',
    on: 'Bật',
    off: 'Tắt',
    stopAcceptingOnline:
      'Ngừng nhận đặt bàn trực tuyến? Trang đặt bàn sẽ bị ẩn khỏi khách và các yêu cầu mới sẽ bị từ chối cho đến khi bạn bật lại.',
    turnReservationsOff: 'Tắt đặt bàn',
    startAcceptingOnline: 'Nhận lại đặt bàn trực tuyến?',
    turnReservationsOn: 'Bật đặt bàn',
    reservationsTurnedOff: 'Đã tắt đặt bàn',
    reservationsTurnedOn: 'Đã bật đặt bàn',
    confirmation: 'Xác nhận',
    howBookingsConfirmed: 'Cách xác nhận lượt đặt',
    automaticConfirm: 'Tự động - xác nhận ngay lập tức',
    bookingsAutoConfirmed: 'Lượt đặt được xác nhận tự động',
    manualConfirm: 'Thủ công - nhân viên duyệt từng yêu cầu',
    bookingsManualReview: 'Lượt đặt cần duyệt thủ công',
    confirmationAutomatic: 'Tự động',
    confirmationManual: 'Duyệt thủ công',
    confirmationFooter:
      'Khi tắt, trang đặt bàn bị ẩn khỏi khách và các lượt đặt trực tuyến mới sẽ bị từ chối. Với xác nhận tự động, yêu cầu được đặt ngay; duyệt thủ công sẽ giữ yêu cầu ở trạng thái chờ cho đến khi nhân viên chấp nhận.',
    partySize: 'Số khách',
    partySizeFooter:
      'Nhóm khách lớn nhất có thể đặt trực tuyến, và thông báo hiển thị khi vượt quá mức đó.',
    largestParty: 'Nhóm lớn nhất',
    maxGuestsPerBooking: 'Số khách tối đa mỗi lượt đặt',
    partySizeUpdated: 'Đã cập nhật số khách',
    guestsCount: (count) => `${count} khách`,
    largePartyMessage: 'Thông báo cho nhóm lớn',
    largePartyMessageHidden: 'Đã ẩn',
    shownToGuestsAboveMax: 'Hiển thị cho khách có nhóm vượt quá mức tối đa (để trống để ẩn)',
    messageUpdated: 'Đã cập nhật thông báo',
    partySizeRange:
      'Phạm vi số khách mà khách có thể chọn khi đặt bàn trực tuyến. Các nhóm lớn hơn sẽ thấy thông báo cho nhóm lớn thay vì biểu mẫu đặt bàn.',
    bookingWindow: 'Khung thời gian đặt',
    bookingWindowFooter:
      'Khách có thể đặt trước bao xa, hạn chót phút chót, và khoảng cách giữa các thời điểm có thể đặt.',
    guestsCanBookUpTo: 'Khách có thể đặt trước tối đa',
    bookingHorizon: 'Phạm vi đặt trước',
    daysAheadGuests: 'Khách có thể đặt trước bao nhiêu ngày',
    bookingWindowUpdated: 'Đã cập nhật khung thời gian đặt',
    daysAhead: (count) => `${count} ngày trước`,
    lastMinuteCutoff: 'Hạn chót phút chót',
    hoursBeforeSlot: 'Số giờ trước khung giờ để ngừng nhận đặt (0 = đến lúc bắt đầu)',
    cutoffUpdated: 'Đã cập nhật hạn chót',
    untilStart: 'Đến lúc bắt đầu',
    hoursBefore: (hours) => `${hours} giờ trước`,
    slotSpacing: 'Khoảng cách khung giờ',
    minutesBetweenBookableTimes: 'Số phút giữa các thời điểm có thể đặt',
    slotSpacingUpdated: 'Đã cập nhật khoảng cách khung giờ',
    lastBookingBeforeClose: 'Lần đặt cuối trước giờ đóng cửa',
    stopBookingsBeforeClose: 'Ngừng nhận đặt bàn trước giờ đóng cửa',
    upToClose: 'Đến giờ đóng cửa',
    lastBookingBeforeCloseUpdated: 'Đã cập nhật lần đặt cuối trước giờ đóng cửa',
    everyMinutes: (minutes) => `Mỗi ${minutes} phút`,
    bookingWindowControls:
      'Kiểm soát lịch mở trước bao xa, khách có thể đặt sát giờ phục vụ đến mức nào, và khoảng cách giữa các thời điểm họ có thể chọn.',
    tableTiming: 'Thời gian giữ bàn',
    tableTimingFooter:
      'Thời gian giữ một bàn cho mỗi lượt đặt, để bàn trống lại cho khách tiếp theo.',
    defaultTableTime: 'Thời gian giữ bàn mặc định',
    tableHeldPerBooking: 'Thời gian giữ bàn cho mỗi lượt đặt, tính bằng phút (tối thiểu 15)',
    tableTimeUpdated: 'Đã cập nhật thời gian giữ bàn',
    tableTimingHint:
      'Thời gian mỗi lượt đặt giữ bàn theo mặc định. Tùy chỉnh riêng theo ca nằm trong mục Sức chứa; khoảng đệm xoay vòng giữa các nhóm cũng được thiết lập ở đó (chế độ nâng cao).',
    noShows: 'Vắng mặt',
    noShowsFooter: 'Sau bao lâu kể từ giờ đặt, một khách chưa đến sẽ được tính là vắng mặt.',
    noShowGracePeriod: 'Thời gian chờ vắng mặt',
    minutesPastBooking: 'Số phút sau giờ đặt trước khi khách bị tính là vắng mặt',
    gracePeriodUpdated: 'Đã cập nhật thời gian chờ',
    noShowsHint:
      'Thời gian chờ điều khiển cảnh báo vắng mặt - nhân viên được thông báo khi một lượt đặt quá hạn số phút này.',
    enterWholeNumber: (min) => `Nhập một số nguyên từ ${min} trở lên`,
    enterWholeNumberBetween: (min, max) => `Nhập một số nguyên từ ${min} đến ${max}`,
    saveFailed: 'Lưu thất bại',
    invalidValue: 'Giá trị không hợp lệ',
    couldntLoadSettings: 'Không thể tải cài đặt đặt bàn',
    checkConnection: 'Kiểm tra kết nối và thử lại.',
    capacity: 'Sức chứa',
    capacityMode: 'Chế độ sức chứa',
    capacityModeFooter:
      'Chọn cách quản lý bàn và số khách - một giới hạn chung, hoặc bàn theo từng khu vực với nhịp độ riêng.',
    simpleMode: 'Đơn giản',
    simpleModeDesc:
      'Giới hạn theo từng khung giờ cho số lượt đặt / số khách. Không phân bổ theo từng bàn.',
    simpleModeConfirm: 'Chuyển sức chứa sang chế độ đơn giản?',
    simpleModeDetails:
      'Một khung giờ là khoảng đặt bàn 60 phút - ví dụ khung 19:00 đếm mọi lượt đặt từ 19:00 đến 19:59.\n\nGiới hạn mặc định áp dụng khi không có ca theo thời gian cụ thể nào bao phủ một lượt đặt. Nếu không có mặc định, lượt đặt chỉ được chấp nhận trong các ca theo thời gian cụ thể.',
    advancedMode: 'Nâng cao',
    advancedModeDesc: 'Giới hạn nhịp độ (số khách / số nhóm mỗi 15 phút) và phân bổ theo từng bàn.',
    advancedModeConfirm: 'Chuyển sức chứa sang chế độ nâng cao?',
    advancedModeDetails:
      'Giới hạn nhịp độ áp dụng theo mỗi khung trượt 15 phút - chi tiết hơn mô hình khung giờ đơn giản và phù hợp hơn với những lúc đông khách.\n\nMỗi lượt đặt cũng được phân bổ vào một bàn cụ thể trên sơ đồ mặt bằng, nên sức chứa bị giới hạn bởi cả giới hạn nhịp độ lẫn số chỗ ngồi thực tế.',
    capacityModeColon: (mode) => `Chế độ sức chứa: ${mode}`,
    failedSwitchMode: 'Không thể chuyển chế độ sức chứa',
    // Trang Sức chứa - gạch đầu dòng tính năng của ô chế độ
    simpleFeature1: 'Giới hạn theo khung giờ cho lượt đặt & số khách',
    simpleFeature2: 'Một khung đặt bàn 60 phút mỗi khung giờ',
    simpleFeature3: 'Không phân bổ theo từng bàn',
    advancedFeature1: 'Giới hạn nhịp độ theo mỗi khung trượt 15 phút',
    advancedFeature2: 'Giới hạn đồng thời (hoạt động cùng lúc)',
    advancedFeature3: 'Phân bổ theo từng bàn từ sơ đồ mặt bằng',
    // Trang Sức chứa - trạng thái lỗi tải
    couldntLoadCapacity: 'Không thể tải cài đặt sức chứa',
    serverNoResponse: 'Máy chủ không phản hồi. Vui lòng thử lại.',
    retrying: 'Đang thử lại…',
    tryAgain: 'Thử lại',
    // Trang Sức chứa - nhãn / chỗ giữ chỗ / chân trang (noLimitation dùng lại ở bên dưới)
    capacityAndLimit: 'Sức chứa & giới hạn',
    pacingTitle: 'Nhịp nhận khách',
    concurrentTitle: 'Phục vụ đồng thời',
    concurrentFooter: 'Để trống để không giới hạn. Thường đặt thấp hơn số bàn của bạn.',
    unassignedZone: 'Chưa phân khu',
    aboutSection: (title) => `Giới thiệu về ${title}`,
    topGroup: (count, seats) => `${count}× bàn ${seats} chỗ`,
    tblShortSeats: (count, seats) => `${count} bàn · ${seats} chỗ`,
    noBookableTablesPrefix: 'Chưa thiết lập bàn nào có thể đặt.',
    noBookableTablesSuffix: 'để lập kế hoạch sức chứa NÂNG CAO.',
    // Trang Sức chứa - định dạng danh sách ca
    everyDay: 'Mỗi ngày',
    dayNamesShort: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    dayNamesLong: ['Chủ nhật', 'Thứ hai', 'Thứ ba', 'Thứ tư', 'Thứ năm', 'Thứ sáu', 'Thứ bảy'],
    coversPer15: (n) => `${n} khách/15phút`,
    partiesPer15: (n) => `${n} nhóm/15phút`,
    windowSubtitle: (start, end, days) => `${start}–${end} · ${days}`,
    // Trang Sức chứa - chú giải dòng thời gian xem trước (resSlot/coversSlot/pacingCovers dùng lại bên dưới)
    capResCoversPerSlot: (res, covers) => `${res} lượt đặt / ${covers} khách mỗi khung giờ`,
    tablesAvailable: 'Bàn khả dụng',
    manage: 'Quản lý',
    noBookableTables:
      'Chưa thiết lập bàn nào có thể đặt. Thêm bàn để lập kế hoạch sức chứa NÂNG CAO.',
    addTables: 'Thêm bàn',
    tblSeats: (count, seats) => `${count} bàn · ${seats} chỗ`,
    // Vietnamese has no plural inflection - the `plural` marker is ignored here.
    bookableTablesInfo: (tables, seats, zones, _plural) =>
      `${tables} bàn có thể đặt · ${seats} chỗ trải trên ${zones} khu. Sức chứa NÂNG CAO phân bổ mỗi lượt đặt vào một bàn cụ thể, nên sức chứa chỗ ngồi bị giới hạn bởi những gì có trên mặt bằng.`,
    tableturnaround: 'Xoay vòng bàn',
    tableturnaroundInfo:
      'Số phút một bàn bị khóa sau khi một lượt đặt kết thúc, trước khi nhóm tiếp theo có thể ngồi vào - dọn dẹp, sắp xếp lại, thanh toán.\n\nĐược cộng thêm vào thời lượng của mỗi lượt đặt khi phân bổ bàn. Chỉ dùng ở chế độ nâng cao (chế độ đơn giản đếm khung giờ, không tính mức sử dụng bàn).',
    bufferMin: 'Đệm (phút)',
    bufferUpdated: 'Đã cập nhật khoảng đệm',
    bufferMustBePositive: 'Khoảng đệm phải là 0 phút trở lên',
    bufferInfo:
      'Khoảng cách giữa hai nhóm tại cùng một bàn. 0 = liên tiếp. Áp dụng cho mọi ca nâng cao.',
    defaultPacing: 'Nhịp nhận khách mặc định (mỗi 15 phút)',
    pacingInfo:
      'Nhịp độ giới hạn tốc độ đến - bao nhiêu lượt đặt mới có thể BẮT ĐẦU trong bất kỳ khung trượt 15 phút nào.\n\n"Số khách tối đa" giới hạn tổng số khách; "số nhóm tối đa" giới hạn tổng số lượt đặt. Hai nhóm cách nhau 20 phút sẽ không bao giờ rơi vào cùng một khung nhịp độ, dù chúng trùng nhau trên mặt bằng - hãy dùng giới hạn đồng thời bên dưới cho trường hợp đó.\n\nBảo vệ thời điểm khách bước vào: khởi động bếp, năng suất đón tiếp / xếp chỗ.',
    maxCovers: 'Số khách tối đa',
    maxParties: 'Số nhóm tối đa',
    defaultConcurrent: 'Đồng thời mặc định (đang phục vụ cùng lúc)',
    concurrentInfo:
      'Giới hạn đồng thời giới hạn bao nhiêu lượt đặt có thể đang HOẠT ĐỘNG tại bất kỳ thời điểm nào - những lượt có khoảng [bắt đầu, bắt đầu + thời lượng) bao phủ thời gian yêu cầu.\n\nHữu ích như một giới hạn mềm dưới mức chỗ ngồi thực tế: ví dụ bạn có 12 bàn nhưng chỉ đủ nhân viên để phục vụ thoải mái 8 nhóm cùng lúc.\n\nĐộc lập với nhịp độ: hai nhóm cách nhau một giờ không bao giờ chung khung nhịp độ nhưng vẫn có thể cùng được xếp chỗ.',
    leaveBlankNoLimitation: 'Để trống để không giới hạn.',
    shiftOverrideWarning:
      'Ca theo giờ bên dưới ĐÈ LÊN các giới hạn mặc định này trong giờ của nó - phải đặt giới hạn cho từng ca, nếu không sẽ không áp dụng.',
    detailOverrideWarning:
      'Ca này ĐÈ LÊN giới hạn mặc định trong khung giờ của nó. Đặt giới hạn riêng ở đây.',
    preview: 'Xem trước',
    defaultCoverage: 'Mặc định · cả ngày',
    maxReservationsSlot: 'Số lượt đặt tối đa / khung giờ',
    capsLimit:
      'Giới hạn số lượt đặt (số nhóm) có thể bắt đầu trong cùng khung giờ 60 phút - bảo vệ tải vận hành, bất kể quy mô mỗi nhóm. Để trống để không giới hạn.',
    maxCoversSlot: 'Số khách tối đa / khung giờ',
    coversCapLimit:
      'Giới hạn tổng số khách bắt đầu trong cùng khung giờ - tổng số khách của tất cả các nhóm. Bảo vệ sức chứa chỗ ngồi. Để trống để không giới hạn.',
    clearDefault: 'Xóa mặc định',
    removeDefaultCapacity:
      'Gỡ bỏ sức chứa mặc định? Các lượt đặt ngoài ca theo thời gian cụ thể sẽ bị từ chối.',
    timeSpecificShifts: 'Ca theo thời gian cụ thể',
    noTimeSpecificShifts:
      'Không có ca theo thời gian cụ thể. Thêm một ca để siết chặt sức chứa (hoặc mở giờ đặt cho một khung cụ thể).',
    addAShift: 'Thêm ca',
    newTimeSpecificShift: 'Ca theo thời gian cụ thể mới',
    name: 'Tên',
    lunchDinner: 'Trưa / Tối …',
    startTime: 'Giờ bắt đầu',
    endTime: 'Giờ kết thúc',
    shiftFooter:
      'Hoạt động vào mọi ngày trong tuần, với các giới hạn kế thừa từ mặc định. Chạm vào ca mới để tinh chỉnh ngày và siết chặt giới hạn.',
    shift: 'Ca',
    shiftNotFound: 'Không tìm thấy ca.',
    baselineEditedInline: 'Ca này là ca cơ sở. Chỉnh sửa từ trang Sức chứa.',
    timeSpecificShiftTitle: 'Ca theo thời gian cụ thể',
    daysActive: 'Ngày hoạt động',
    capsSimple: 'Giới hạn (Đơn giản)',
    maxReservationsSlotLabel: 'Số lượt đặt tối đa / khung giờ',
    maxReservationsInfo:
      'Giới hạn số lượt đặt (số nhóm) có thể bắt đầu trong cùng khung giờ 60 phút - bảo vệ tải vận hành, bất kể quy mô mỗi nhóm.',
    maxCoversSlotLabel: 'Số khách tối đa / khung giờ',
    maxCoversInfo:
      'Giới hạn tổng số khách bắt đầu trong cùng khung giờ - tổng số khách của tất cả các nhóm. Bảo vệ sức chứa chỗ ngồi.',
    leaveBlankStricter: 'Để trống để không giới hạn. Chặt hơn ca cơ sở → ưu tiên trong khung này.',
    pacingSimple: 'Nhịp độ (mỗi 15 phút)',
    concurrentSimple: 'Đồng thời (hoạt động cùng lúc)',
    partySizePacing:
      'Các nhóm nhịp độ theo quy mô nhóm được giữ nguyên - chưa có giao diện cho chúng ở đây.',
    deleteShift: 'Xóa ca',
    deleteShiftConfirm: (label) => `Xóa ca "${label}"?`,
    shiftSaved: 'Đã lưu ca',
    failedSaveShift: 'Không thể lưu ca',
    failedDeleteShift: 'Không thể xóa ca',
    nameRequired: 'Tên là bắt buộc',
    timesMustBeHHmm: 'Giờ phải theo định dạng HH:mm',
    startBeforeEnd: 'Giờ bắt đầu phải trước giờ kết thúc',
    pickAtLeastOneDay: 'Chọn ít nhất một ngày',
    capsPositiveWhole: 'Giới hạn phải là số nguyên dương (hoặc để trống để không giới hạn)',
    tables: 'Bàn',
    tableManagement: 'Quản lý bàn',
    noZones: 'Chưa có khu nào. Thêm một khu trước, rồi thêm bàn.',
    addAZone: 'Thêm khu',
    noTablesYet: 'Chưa có bàn nào',
    addTablesLink: '+ Thêm bàn',
    seatTables: (seats) => `Bàn ${seats} chỗ`,
    seatsTotal: (seats, count) => `Tổng cộng ${seats * count} chỗ`,
    tablesCount: (count) => `${count} bàn`,
    addZone: '+ Thêm khu',
    newZone: 'Khu mới',
    zoneName: 'Tên khu',
    zoneNameExample: 'ví dụ: Chính, Sân hiên, Quầy bar',
    zoneAdded: 'Đã thêm khu',
    renameZone: 'Đổi tên khu',
    zoneRenamed: 'Đã đổi tên khu',
    deleteZone: 'Xóa khu',
    addTableZone: (zone) => `Thêm bàn - ${zone}`,
    seatsPerTable: 'Số chỗ mỗi bàn',
    numberOfTables: 'Số lượng bàn',
    addedTables: (count) => `Đã thêm ${count} bàn`,
    editSeatTables: (seats, zone) => `Bàn ${seats} chỗ - ${zone}`,
    setToDeactivateAll: 'Đặt thành 0 để vô hiệu hóa tất cả',
    tableUpdated: 'Đã cập nhật bàn',
    removeAllTables: (count, seats, zone) => `Gỡ tất cả ${count} × bàn ${seats} chỗ khỏi ${zone}?`,
    removeTables: 'Gỡ bàn',
    tablePlan: 'Sơ đồ bàn',
    advancedTables: 'Bàn nâng cao',
    simplesMode: 'Đơn giản',
    simpleModeTableDesc:
      'Quản lý bàn theo số lượng và sức chứa chỗ ngồi. Không cần sơ đồ mặt bằng.',
    switchSimple: 'Chuyển sang chế độ đơn giản?',
    advancedModeTable: 'Nâng cao',
    advancedModeTableDesc: 'Đặt bàn trên sơ đồ mặt bằng 2D để bố trí chính xác và phân bổ tự động.',
    switchAdvanced: 'Chuyển sang chế độ nâng cao?',
    tableModeColon: (mode) => `Chế độ bàn: ${mode}`,
    failedSwitchTableMode: 'Không thể chuyển chế độ bàn',
    tablesFloorPlan: 'Bàn & sơ đồ mặt bằng',
    manageTables: 'Quản lý bàn',
    batchAddTables: 'Thêm bàn hàng loạt',
    labelPrefix: 'Tiền tố nhãn',
    labelPrefixExample: 'Bàn sẽ được đánh nhãn T1, T2 … (tiếp tục từ số cao nhất hiện có)',
    seatCategories: 'Loại chỗ ngồi',
    seats: 'Chỗ',
    qty: '× Số lượng',
    addSeatCategory: '+ Thêm loại chỗ ngồi',
    createdTables: (count) => `Đã tạo ${count} bàn`,
    editTable: 'Chỉnh sửa bàn',
    labelOverride: 'Ghi đè nhãn',
    useAutoGenerated: 'Để trống để dùng nhãn tự động tạo',
    active: 'Hoạt động',
    countsForCapacity: 'Tính vào sức chứa',
    bookableOnline: 'Có thể đặt trực tuyến',
    tableGone: 'Bàn này không còn tồn tại.',
    decrease: 'Giảm',
    increase: 'Tăng',
    noTablesConfigured: 'Chưa có bàn nào. Dùng "Thêm hàng loạt" để tạo bàn.',
    floorPlan: 'Sơ đồ mặt bằng',
    dragDropEditor:
      'Trình chỉnh sửa sơ đồ mặt bằng kéo-thả sẽ ra mắt tiếp theo. Backend đã sẵn sàng - màn hình này sẽ hiển thị một canvas nơi bạn có thể đặt bàn, thay đổi kích thước và xoay, vẽ tường, và đặt ảnh nền.',
    floorPlanVersion: (version, placed, total) =>
      `Phiên bản ${version} · đã đặt ${placed} trong ${total} bàn.`,
    editorLargerScreen:
      'Trình chỉnh sửa sơ đồ mặt bằng cần màn hình lớn hơn với chuột - mở bảng điều khiển trên máy tính để chỉnh sửa. Đây là bản tóm tắt chỉ đọc:',
    placed: (count) => `Đã đặt (${count})`,
    noTablesPlaced: 'Chưa có bàn nào được đặt trên canvas.',
    notPlaced: (count) => `Chưa đặt (${count})`,
    zones: 'Khu',
    noZonesYet:
      'Chưa có khu nào. Khu nhóm các bàn ở gần nhau về mặt vật lý - chúng giới hạn những bàn nào có thể được gộp cho một lượt đặt.',
    deleteZoneConfirm: (label) =>
      `Xóa khu "${label}"? Các bàn được giữ lại nhưng sẽ không thuộc khu nào.`,
    failedCreateZone: 'Không thể tạo khu',
    failedDeleteZone: 'Không thể xóa khu',
    zoneNamePrompt: 'Tên khu (ví dụ "Sân hiên", "Trong nhà")',
    largePartyMessagePrompt: 'Hiển thị cho khách có nhóm vượt quá mức tối đa (để trống để ẩn)',
    tablesToPlace: (count, plural) => `${count} bàn${plural} cần đặt`,
    autoPlace: 'Tự động đặt',
    removeTable: 'Gỡ bàn',
    zoomIn: 'Phóng to',
    zoomOut: 'Thu nhỏ',
    fitToTables: 'Vừa với các bàn',
    fitToPlan: 'Vừa với sơ đồ',
    seater: (seats) => `${seats} chỗ`,
    seatersCount: (count) => `· ${count}`,
    // --- AdvancedTablesPage (page-specific copy) ---
    noZoneLabel: 'Không có khu',
    inactiveBadge: 'Không hoạt động',
    noCapacityBadge: 'Không tính vào sức chứa',
    notOnlineBadge: 'Không thể đặt trực tuyến',
    seatsCount: (n) => `${n} chỗ`,
    deleteTablesTitle: 'Xóa bàn',
    deleteTablesConfirm: (count, _plural) => `Xóa ${count} bàn? Không thể hoàn tác.`,
    tablesDeleted: (count) => `Đã xóa ${count} bàn`,
    deleteCount: (count) => `Xóa (${count})`,
    addCount: (count) => `Thêm (${count})`,
    floorPlanSaved: 'Đã lưu sơ đồ mặt bằng',
    failedSaveFloorPlan: 'Không thể lưu',
    failedBatchCreate: 'Thất bại',
    done: 'Xong',
    aboutMode: (mode) => `Về chế độ ${mode}`,
    noPacingLimit: 'Không có giới hạn nhịp độ - lượt khách đến không bị giới hạn tốc độ.',
    coversPaceTrips: (max, parties, covers) =>
      `Nhịp độ số khách (${max}) chạm ngưỡng trước: ${parties} nhóm = ${covers} khách bắt đầu trong 15 phút, nhóm tiếp theo bị dời sang sau.`,
    partyPaceTrips: (max, covers) =>
      `Nhịp độ số nhóm (${max}) chạm ngưỡng trước: chỉ ${max} lượt đặt có thể bắt đầu mỗi 15 phút (${covers} khách cho đến nay).`,
    bothPacingHit: (parties, covers) =>
      `Cả hai giới hạn nhịp độ đều đạt - ${parties} nhóm / ${covers} khách trong 15 phút.`,
    noConcurrentLimit: 'Không có giới hạn đồng thời - chỉ bị giới hạn bởi số bàn của bạn.',
    concurrentCoversTrips: (max, covers) =>
      `Số khách đồng thời (${max}) chạm ngưỡng trước: ${covers} khách đang hoạt động vào lúc cao điểm.`,
    concurrentPartiesTrips: (max, covers) =>
      `Số nhóm đồng thời (${max}) chạm ngưỡng trước: ${max} lượt đặt hoạt động cùng lúc (${covers} khách).`,
    bothConcurrentHit: (parties, covers) =>
      `Cả hai giới hạn đồng thời đều đạt - ${parties} nhóm / ${covers} khách cùng lúc.`,
    slotFitsTypical: 'Một tổ hợp điển hình vẫn vừa - khung giờ vẫn mở để nhận thêm lượt đặt.',
    coversCapsFirst: (max, parties, covers, size) =>
      `Giới hạn số khách (${max}) đạt trước: ${parties} nhóm = ${covers} khách, và nhóm tiếp theo gồm ${size} người sẽ vượt quá.`,
    reservationsCapsFirst: (max, parties, covers) =>
      `Giới hạn số lượt đặt (${max}) đạt trước: khung giờ đầy ở mức ${parties} lượt đặt, bất kể quy mô nhóm (${covers} khách cho đến nay).`,
    bothCapsHit: (parties, covers) =>
      `Cả hai giới hạn đều đạt cùng lúc - ${parties} nhóm / ${covers} khách.`,
    slotClosesWhenHit: 'Một khung giờ đóng lại ngay khi đạt một trong hai giới hạn.',
    noLimitsSlot: 'Không có giới hạn - khung giờ không bao giờ tự đầy (các ca khác vẫn áp dụng).',
    onlyOneSlot: 'Một khung giờ 60 phút · nhóm đến',
    typicalOverlapFits:
      'Một mức chồng lấn điển hình vẫn vừa - không đạt giới hạn mềm nào dưới số bàn của bạn.',
    turnedAway: (size) => `${size} bị từ chối`,
    weeklyCompileCoverage: 'Phạm vi theo tuần',
    noLimitation: 'không giới hạn',
    resSlot: (count) => `${count} lượt đặt/khung giờ`,
    coversSlot: (count) => `${count} khách/khung giờ`,
    pacingCovers: (count) => `${count} khách nhịp độ`,
    advCapCompact: (pacing, concurrent) => `${pacing} · ${concurrent}`,
    advCap: (pacing, concurrent) => `${pacing}/15' · ${concurrent} cùng lúc`,
    // --- ReservationSetupPage (page-specific copy) ---
    bookingForm: 'Biểu mẫu đặt bàn',
    bookingFormFooter:
      'Các trường tùy chọn khách có thể điền khi đặt bàn - dịp đặc biệt và ưu tiên chỗ ngồi.',
    enableBookings: 'Bật đặt bàn',
    enableBookingsAria: 'Giới thiệu về bật đặt bàn',
    enableBookingsTooltip:
      'Khi tắt, trang đặt bàn bị ẩn khỏi khách và các lượt đặt trực tuyến mới sẽ bị từ chối.',
    autoConfirmBookings: 'Tự động xác nhận lượt đặt',
    autoConfirmAria: 'Giới thiệu về xác nhận',
    autoConfirmTooltip:
      'Khi bật, yêu cầu được xác nhận ngay lập tức. Khi tắt, yêu cầu ở trạng thái chờ cho đến khi nhân viên duyệt và chấp nhận.',
    bookingsAutoConfirmedToast: 'Đã bật tự động xác nhận lượt đặt',
    bookingsNeedReview: 'Lượt đặt cần duyệt thủ công',
    pauseToday: 'Tạm dừng nhận đặt mới hôm nay',
    pauseTodayAria: 'Giới thiệu về tạm dừng đặt mới',
    pauseTodayTooltip:
      'Chỉ ngừng nhận đặt trực tuyến mới trong phần còn lại của hôm nay - các ngày sau vẫn mở.',
    bookingsPausedToday: 'Đã tạm dừng nhận đặt mới cho hôm nay',
    bookingsResumed: 'Đã tiếp tục nhận đặt',
    occasionField: 'Dịp đặc biệt',
    occasionFieldAria: 'Giới thiệu về trường dịp đặc biệt',
    occasionFieldTooltip: 'Hiển thị hoặc ẩn bộ chọn “Dịp đặc biệt” trên biểu mẫu đặt bàn.',
    occasionFieldShown: 'Đã hiển thị trường dịp đặc biệt',
    occasionFieldHidden: 'Đã ẩn trường dịp đặc biệt',
    seatingAccessField: 'Chỗ ngồi & tiếp cận',
    seatingAccessAria: 'Giới thiệu về trường chỗ ngồi & tiếp cận',
    seatingAccessTooltip:
      'Hiển thị hoặc ẩn bộ chọn “Chỗ ngồi & tiếp cận” (chỗ ngồi + khả năng tiếp cận, ví dụ ghế em bé) trên biểu mẫu đặt bàn.',
    seatingAccessShown: 'Đã hiển thị trường chỗ ngồi & tiếp cận',
    seatingAccessHidden: 'Đã ẩn trường chỗ ngồi & tiếp cận',
    largestPartyAria: 'Giới thiệu về nhóm lớn nhất',
    largestPartyTooltip: 'Số khách tối đa cho phép mỗi lượt đặt trực tuyến.',
    largePartyMessageAria: 'Giới thiệu về thông báo cho nhóm lớn',
    largePartyMessageTooltip:
      'Hiển thị thay cho biểu mẫu đặt bàn đối với các nhóm vượt quá số khách lớn nhất.',
    bookingHorizonAria: 'Giới thiệu về phạm vi đặt trước',
    bookingHorizonTooltip: 'Lịch đặt bàn mở trước bao nhiêu ngày.',
    lastMinuteCutoffMinutes: 'Hạn chót phút chót (phút)',
    lastMinuteCutoffAria: 'Giới thiệu về hạn chót phút chót',
    lastMinuteCutoffMsg: 'Số phút trước khung giờ để ngừng nhận đặt (0 = đến lúc bắt đầu)',
    lastMinuteCutoffTooltip: 'Số phút trước một khung giờ để ngừng nhận đặt (0 = đến lúc bắt đầu).',
    minBefore: (minutes) => `${minutes} phút trước`,
    slotSpacingAria: 'Giới thiệu về khoảng cách khung giờ',
    slotSpacingTooltip: 'Số phút giữa các thời điểm khách có thể chọn để đặt.',
    lastBookingBeforeCloseAria: 'Giới thiệu về lần đặt cuối trước giờ đóng cửa',
    lastBookingBeforeCloseTooltip:
      'Ngừng cung cấp khung giờ đặt bàn bao lâu trước khi mỗi ca phục vụ đóng cửa. Nhân viên vẫn có thể làm quá giờ — đây chỉ là mức muộn nhất khách được đặt online. Ví dụ 60 phút nghĩa là đóng cửa lúc 22:00 thì khung giờ cuối là 21:00.',
    everyMinShort: (minutes) => `Mỗi ${minutes} phút`,
    defaultTableTimeMsg: 'Thời gian giữ bàn cho mỗi lượt đặt, tính bằng phút (tối thiểu 15)',
    defaultTableTimeAria: 'Giới thiệu về thời gian giữ bàn mặc định',
    defaultTableTimeTooltip:
      'Thời gian giữ bàn cho mỗi lượt đặt theo mặc định. Tùy chỉnh riêng theo ca nằm trong mục Sức chứa.',
    shareBookingLink: 'Chia sẻ liên kết đặt bàn',
    shareBookingLinkAria: 'Giới thiệu về chia sẻ liên kết đặt bàn',
    shareBookingLinkTooltip: 'Sao chép liên kết đặt bàn công khai để chia sẻ với khách.',
    copy: 'Sao chép',
    noShowGracePeriodMsg: 'Số phút sau giờ đặt trước khi khách bị tính là vắng mặt',
    noShowGracePeriodAria: 'Giới thiệu về thời gian chờ vắng mặt',
    noShowGracePeriodTooltip:
      'Số phút một lượt đặt có thể quá hạn trước khi nhân viên nhận cảnh báo vắng mặt.',
    minCount: (minutes) => `${minutes} phút`,
    fmtNone: 'Không',
    fmtHoursMinutes: (hours, minutes) => `${hours} giờ ${minutes} phút`,
    fmtHours: (hours) => `${hours} giờ`,
    fmtMinutes: (minutes) => `${minutes} phút`,
    bookingLinkCopied: 'Đã sao chép liên kết đặt bàn',
    bookingLink: 'Liên kết đặt bàn',
    // --- Zones/Tables/Floor-plan pages (simple mode) ---
    add: 'Thêm',
    failed: 'Thất bại',
    rename: 'Đổi tên',
    zonesFooter:
      'Mỗi bàn tham chiếu đến khu vực qua id của nó - xóa khu vực sẽ khiến các bàn đó không còn thuộc khu vực nào.',
    deleteZoneNoZoneConfirm: (label) =>
      `Xóa "${label}"? Các bàn của khu này không bị xóa - chúng sẽ chuyển sang "Không có khu" và vẫn có thể đặt được.`,
    orphanTablesNote:
      'Các bàn này thuộc một khu vực đã bị xóa. Chúng vẫn đang hoạt động và có thể đặt được. Hãy gán chúng vào một khu vực bằng cách chỉnh sửa từng bàn.',
    floorPlanAriaLabel: 'Sơ đồ mặt bằng nhà hàng',
  },

  reservationsFeature: {
    edit: {
      title: 'Chỉnh sửa đặt bàn',
      updated: 'Đã cập nhật đặt bàn',
      updateFailed: 'Không thể cập nhật đặt bàn.',
      guestNamePlaceholder: 'Tên khách',
      durationPlaceholder: '60',
      notesPlaceholder: 'Ghi chú của nhân viên…',
    },
    actions: {
      confirmReservation: 'Xác nhận đặt bàn',
      declineReservation: 'Từ chối đặt bàn',
      cancelReservation: 'Hủy đặt bàn',
      markArrived: 'Đánh dấu đã đến',
      markNoShow: 'Đánh dấu vắng mặt',
      markCompleted: 'Đánh dấu hoàn tất',
    },
    card: {
      guestLabel: (_count) => 'Khách',
      guestLabelPlural: 'Khách',
      swipeAccept: 'Chấp nhận',
      swipeDecline: 'Từ chối',
    },
    inspector: {
      closeButton: 'Đóng',
      noReservationTitle: 'Chưa chọn đặt bàn',
      noReservationDesc: 'Chọn một đặt bàn từ danh sách để xem chi tiết tại đây.',
      notFoundTitle: 'Không tìm thấy đặt bàn',
      durationUnit: 'phút',
      callGuest: 'Gọi',
      messageGuest: 'Nhắn tin',
      emailGuest: 'Email',
      editGuest: 'Chỉnh sửa',
      statusLabel: 'Trạng thái',
      specialRequests: 'Yêu cầu đặc biệt',
      occasion: 'Dịp',
      seating: 'Chỗ ngồi',
      notes: 'Ghi chú',
      guestInfo: 'Thông tin khách',
      phone: 'Điện thoại',
      source: 'Nguồn',
      internalNote: 'Ghi chú nội bộ',
      cancellationReason: 'Lý do hủy',
      timeline: 'Dòng thời gian',
      created: 'Đã tạo',
      confirmed: 'Đã xác nhận',
      arrived: 'Đã đến',
      completed: 'Đã hoàn tất',
      cancelled: 'Đã hủy',
      noShow: 'Vắng mặt',
      markedArrived: 'Đã đánh dấu đã đến',
      markedCompleted: 'Đã đánh dấu hoàn tất',
      markedNoShow: 'Đã đánh dấu vắng mặt',
    },
    summary: {
      total: 'Tổng',
      pending: 'Đang chờ',
      confirmed: 'Đã xác nhận',
      arrived: 'Đã đến',
      completed: 'Đã hoàn tất',
      noShow: 'Vắng mặt',
    },
    create: {
      title: 'Đặt bàn mới',
      guestSection: 'Khách',
      nameLabel: 'Họ và tên',
      namePlaceholder: 'ví dụ: Nguyễn Văn A',
      phoneLabel: 'Điện thoại',
      phonePlaceholder: '+84 90 123 4567',
      emailLabel: 'Email',
      emailPlaceholder: 'john@example.com',
      existingGuests: 'Khách hiện có - chạm để dùng lại',
      bookingSection: 'Lượt đặt',
      dateLabel: 'Ngày',
      timeLabel: 'Giờ',
      partySizeLabel: 'Số khách',
      sourceSection: 'Nguồn',
      sourcePhone: 'Điện thoại',
      sourceWalkIn: 'Khách vãng lai',
      notesSection: 'Ghi chú',
      notesLabel: 'Ghi chú nội bộ',
      notesPlaceholder: 'Chỉ dành cho nhân viên...',
      button: 'Tạo đặt bàn',
      success: 'Đã tạo đặt bàn',
      nameRequired: 'Tên khách là bắt buộc.',
      emailRequired: 'Email khách là bắt buộc.',
      phoneRequired: 'Điện thoại khách là bắt buộc.',
      noRestaurant: 'Chưa chọn nhà hàng.',
      error: 'Không thể tạo đặt bàn. Vui lòng thử lại.',
    },
    pending: {
      title: 'Đang chờ',
      confirmed: 'Đã xác nhận đặt bàn',
      confirmFailed: 'Không thể xác nhận đặt bàn.',
      rejectPrompt: 'Lý do từ chối:',
      rejectTitle: 'Từ chối đặt bàn',
      rejected: 'Đã từ chối đặt bàn',
      rejectFailed: 'Không thể từ chối đặt bàn.',
      empty: 'Đã xong tất cả!',
      emptyDesc: 'Không có đặt bàn nào đang chờ duyệt.',
    },
    detail: {
      title: 'Đặt bàn',
    },
    list: {
      emptyError: 'Không tải được đặt bàn',
      emptyRetry: 'Vui lòng thử lại.',
      noReservations: 'Không có đặt bàn',
      noReservationsDesc: 'Không có đặt bàn nào cho ngày này.',
      today: 'Hôm nay',
      countLabel: (_count) => 'đặt bàn',
      countLabelPlural: 'đặt bàn',
      cancelConfirm: 'Hủy đặt bàn này?',
      cancelTitle: 'Hủy đặt bàn',
      cancelled: 'Đã hủy đặt bàn',
      cancelFailed: 'Không thể hủy đặt bàn.',
    },
    plan: {
      noZone: 'Không có khu',
      seatSingular: 'chỗ',
      seatPlural: 'chỗ',
      tableAriaLabel: (name, seats) => `Bàn ${name}, ${seats} ${seats === 1 ? 'chỗ' : 'chỗ'}`,
      empty: 'Chưa có bàn nào',
      emptyDesc: 'Thêm bàn trong Cài đặt → Thiết lập đặt bàn để xem sơ đồ mặt bằng.',
    },
    timeline: {
      unassignedCount: (count) => `${count} lượt đặt`,
      empty: 'Chưa có gì để hiển thị',
      emptyDesc:
        'Thêm bàn trong thiết lập sức chứa và các lượt đặt sẽ hiển thị tại đây dưới dạng thanh.',
      seatTopLabel: (seats) => `Bàn ${seats} chỗ`,
    },
    calendar: {
      error: 'Không tải được đặt bàn',
      errorRetry: 'Vui lòng thử lại.',
    },
  },

  restaurantSetupFeature: {
    branding: {
      title: 'Giao diện cửa hàng',
      storefrontTheme: 'Giao diện cửa hàng',
      storefrontThemeDescription:
        'Chọn giao diện cho cửa hàng công khai của bạn. Mỗi bản xem trước dùng đúng màu sắc và hình dạng mà khách hàng của bạn sẽ thấy.',
      orderButtonPreview: 'Đặt món',
      themeSavedMessage: 'Đã lưu giao diện - cửa hàng của bạn sẽ cập nhật ở lần tải tiếp theo',
      couldNotSaveTheme: 'Không thể lưu giao diện.',
      saveTheme: 'Lưu giao diện',
      brandingImages: 'Ảnh thương hiệu',
      brandingImagesDescription:
        'Logo và ảnh bìa cho cửa hàng công khai của bạn. Ảnh bìa cũng hiển thị khi link cửa hàng được chia sẻ trong ứng dụng chat.',
      logoLabel: 'Logo',
      logoHint: 'Ảnh vuông, hiển thị cạnh tên nhà hàng. Kéo thả file vào đây để tải lên.',
      coverLabel: 'Ảnh bìa',
      coverHint:
        'Ảnh ngang, khuyến nghị 1200×630 - hiển thị ở đầu trang và trong bản xem trước khi chia sẻ link. Kéo thả file vào đây để tải lên.',
      uploadImage: 'Tải lên',
      replaceImage: 'Thay ảnh',
      removeImage: 'Xoá',
      imageSavedMessage: 'Đã lưu ảnh - cửa hàng của bạn sẽ cập nhật ở lần tải tiếp theo',
      imageRemovedMessage: 'Đã xoá ảnh',
      imageUploadFailed: 'Không thể tải ảnh lên.',
      imageTooLarge: 'Ảnh quá lớn (tối đa 10 MB).',
      imageWrongType: 'Định dạng không hỗ trợ. Dùng JPG, PNG hoặc WebP.',
      galleryLabel: 'Thư viện ảnh',
      galleryHint:
        'Tối đa 9 ảnh, hiển thị dạng lưới trên trang cửa hàng. Ảnh vuông (1:1) đẹp nhất. Kéo thả để sắp xếp.',
      addPhotos: 'Thêm ảnh',
      dropFilesHint: 'hoặc kéo thả file vào đây',
      galleryFull: 'Thư viện chỉ chứa tối đa 9 ảnh.',
    },
  },

  profile: {
    title: 'Hồ sơ của tôi',
    personalInfo: 'Thông tin cá nhân',
    firstName: 'Tên',
    lastName: 'Họ',
    email: 'Email',
    notAvailableYet: 'Chưa khả dụng',
    contactAdminNote:
      'Để cập nhật tên hoặc thông tin cá nhân, vui lòng liên hệ quản trị viên - hiện chưa thể chỉnh sửa tại đây.',
    currentRestaurantRole: 'Vai trò hiện tại tại nhà hàng',
    nameInRestaurant: 'Tên tại nhà hàng',
    restaurant: 'Nhà hàng',
    role: 'Vai trò',
  },

  settingsHealth: {
    title: 'Hoàn tất thiết lập',
    location: {
      title: 'Đặt vị trí nhà hàng',
      description: 'Giao hàng không thể tính khoảng cách cho đến khi bạn ghim vị trí trên bản đồ.',
    },
    openingHours: {
      title: 'Thêm giờ mở cửa',
      description: 'Cửa hàng của bạn hiển thị là đã đóng cho đến khi bạn thiết lập.',
    },
    deliveryPricing: {
      title: 'Thiết lập phí giao hàng',
      description: 'Thêm khu vực giao hàng, nếu không mọi địa chỉ đều bị từ chối vì ngoài khu vực.',
    },
    deliveryTime: {
      title: 'Đặt thời gian giao hàng',
      description: 'Vùng giao chưa có thời gian sẽ báo khách giờ nhận không tính quãng đường.',
    },
    paymentMethod: {
      title: 'Bật một phương thức thanh toán',
      description: 'Khách chọn được món nhưng không đặt hàng được.',
    },
    menu: {
      title: 'Thêm món vào thực đơn',
      description: 'Đặt hàng online không có gì để hiển thị cho đến khi thực đơn có món.',
    },
    menuNotLive: {
      title: 'Bật thực đơn cho đặt hàng online',
      description:
        'Chưa có thực đơn nào được bật cho mang đi hoặc giao hàng, khách chỉ thấy "chưa nhận đặt món online".',
    },
  },

  settingsFeature: {
    features: 'Tính năng',
    privacy: 'Quyền riêng tư',
    shareUsageData: 'Chia sẻ dữ liệu sử dụng',
    shareUsageDataHint:
      'Giúp chúng tôi biết bạn thực sự dùng công cụ nào. Không bao giờ gồm thông tin khách hay đơn hàng.',
    assistant: 'Trợ lý',
    aiAssistant: 'Trợ lý AI',
    notifications: 'Thông báo',
    inbox: 'Hộp thư',
    inboxNewCount: (count) => `${count} mới`,
    reports: 'Báo cáo',
    salesOverview: 'Tổng quan doanh số',
    dayEnd: 'Chốt ngày',
    topItems: 'Món bán chạy',
    paymentReconciliation: 'Đối soát thanh toán',
    reservationSetup: 'Thiết lập đặt bàn',
    onlineOrders: 'Đơn hàng trực tuyến',
    orderSetup: 'Thiết lập đặt món',
    orderShifts: 'Sức chứa đơn hàng',
    labels: 'Nhãn',
    tidyUp: 'Dọn gọn danh sách',
    promotions: 'Khuyến mãi',
    loyalty: 'Khách hàng thân thiết',
    giftCards: 'Thẻ quà tặng',
    staff: 'Nhân viên',
    tableOrdering: 'Đặt món tại bàn',
    dineInSetup: 'Thiết lập dùng tại chỗ',
    printing: 'In ấn',
    printers: 'Máy in',
    customers: 'Khách hàng',
    allCustomers: 'Tất cả khách hàng',
    branding: 'Giao diện cửa hàng',
    storefrontLink: 'Liên kết cửa hàng',
    openingHours: 'Giờ mở cửa',
    holidays: 'Ngày lễ và ngày nghỉ',
    reservationHours: 'Giờ nhận đặt bàn',
    orderHours: 'Giờ nhận đơn',
    pickupHours: 'Giờ lấy hàng',
    deliveryHours: 'Giờ giao hàng',
    orderHistory: 'Lịch sử đơn hàng',
    payments: 'Thanh toán',
    myProfile: 'Hồ sơ của tôi',
  },

  storefrontLink: {
    title: 'Liên kết cửa hàng',
    language: 'Ngôn ngữ',
    default: 'Mặc định',
    linkLabel: 'Liên kết',
    linksTitle: 'Liên kết',
    homepage: 'Trang chủ',
    reservation: 'Đặt bàn',
    onlineOrder: 'Đặt món trực tuyến',
    linkUnavailable: 'Liên kết không khả dụng',
    copy: 'Sao chép',
    copied: 'Đã sao chép',
    open: 'Mở',
    linkCopied: 'Đã sao chép liên kết cửa hàng',
    okButton: 'OK',
  },

  settingHistory: {
    title: 'Lịch sử thay đổi cài đặt',
    navTitle: 'Nhật ký cài đặt',
    empty: 'Chưa ghi nhận thay đổi cài đặt nào.',
    columnActor: 'Người sửa',
    columnWhen: 'Thời gian',
    columnWhat: 'Sửa cái gì',
    columnAction: 'Hành động',
    details: 'Chi tiết',
    detailsTitle: 'Chi tiết thay đổi',
    totalEntries: (total: number) => `${total} bản ghi`,
    actions: {
      CREATED: 'Thêm',
      UPDATED: 'Sửa',
      DELETED: 'Xoá',
    },
    valueHidden: 'đã thay đổi (không lưu giá trị)',
    on: 'Bật',
    off: 'Tắt',
    unitMinutes: (n: string) => `${n} phút`,
    unitHours: (n: string) => `${n} giờ`,
    unitDays: (n: string) => `${n} ngày`,
    unitPeople: (n: string) => `${n} khách`,
    unitKm: (n: string) => `${n} km`,
    photoCount: (n: number) => `${n} ảnh`,
    partySizePacingRule: (minPartySize: number, maxParties: number) =>
      `Nhóm từ ${minPartySize} khách: tối đa ${maxParties} nhóm`,
    ruleFields: {
      slotMinutes: 'Độ dài khung',
      maxReservationsPerSlot: 'Số lượt đặt tối đa / khung giờ',
      maxCoversPerSlot: 'Số khách tối đa / khung giờ',
      pacingMaxCovers: 'Nhịp nhận khách, số khách tối đa',
      pacingMaxParties: 'Nhịp nhận khách, số nhóm tối đa',
      maxConcurrentCovers: 'Phục vụ đồng thời, số khách tối đa',
      maxConcurrentParties: 'Phục vụ đồng thời, số nhóm tối đa',
      partySizePacing: 'Nhịp nhận khách theo cỡ nhóm',
      maxOrdersPerSlot: 'Số đơn mỗi khung',
      capacityWindowMinutes: 'Khung giới hạn',
    },
    detailBefore: 'Trước',
    detailAfter: 'Sau',
    showRaw: 'Xem dữ liệu gốc',
    hideRaw: 'Ẩn dữ liệu gốc',
    tableAttributes: {
      WINDOW: 'Cạnh cửa sổ',
      BOOTH: 'Bàn khoang',
      OUTDOOR: 'Ngoài trời',
      BAR: 'Quầy bar',
      HIGH_TOP: 'Bàn cao',
      PRIVATE_ROOM: 'Phòng riêng',
      QUIET: 'Góc yên tĩnh',
      WHEELCHAIR: 'Phù hợp xe lăn',
      NEAR_FIREPLACE: 'Gần lò sưởi',
      KIDS_FRIENDLY: 'Phù hợp trẻ em',
    },
    fields: {
      name: 'Tên',
      address: 'Địa chỉ',
      city: 'Thành phố',
      postalCode: 'Mã bưu chính',
      phone: 'Số điện thoại',
      email: 'Email',
      timezone: 'Múi giờ',
      latitude: 'Vĩ độ',
      longitude: 'Kinh độ',
      isActive: 'Đang hoạt động',
      slug: 'Đường dẫn web',
      websiteUrl: 'Website',
      facebookUrl: 'Facebook',
      instagramUrl: 'Instagram',
      tiktokUrl: 'TikTok',
      logoKey: 'Logo',
      coverImageKey: 'Ảnh bìa',
      galleryKeys: 'Thư viện ảnh',
      themeId: 'Giao diện',
      shifts: 'Khung giờ mở cửa',
      dayOfWeek: 'Ngày trong tuần',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
      type: 'Loại',
      services: 'Áp dụng cho',
      reason: 'Lý do',
      label: 'Tên gọi',
      sortOrder: 'Thứ tự hiển thị',
      zoneId: 'Khu vực',
      seats: 'Số chỗ ngồi',
      attributes: 'Thuộc tính',
      customTags: 'Thẻ tuỳ chỉnh',
      countsForCapacity: 'Tính vào sức chứa',
      isBookableOnline: 'Cho đặt trực tuyến',
      isMergeable: 'Có thể ghép bàn',
      tableMode: 'Cách quản lý bàn',
      enabled: 'Nhận đặt bàn trực tuyến',
      occasionEnabled: 'Hỏi dịp đặc biệt',
      seatingPreferenceEnabled: 'Hỏi chỗ ngồi mong muốn',
      duration: 'Thời lượng dùng bữa',
      bufferTime: 'Thời gian đệm giữa các lượt',
      autoConfirmMode: 'Cách xác nhận',
      maxPartySize: 'Số khách tối đa',
      largePartyMsg: 'Thông báo cho nhóm lớn',
      advanceWindow: 'Cho đặt trước tối đa',
      cutoffTime: 'Ngừng nhận đặt trước giờ đến',
      slotInterval: 'Khoảng cách khung giờ',
      closingBufferMinutes: 'Ngừng nhận đặt trước giờ đóng cửa',
      gracePeriod: 'Thời gian chờ khách đến',
      pausedUntil: 'Tạm dừng nhận đặt đến',
      shiftMode: 'Cách quản lý sức chứa',
      scope: 'Phạm vi áp dụng',
      startTime: 'Giờ bắt đầu',
      endTime: 'Giờ kết thúc',
      daysOfWeek: 'Các ngày áp dụng',
      defaultDurationMinutes: 'Thời lượng mặc định',
      mode: 'Chế độ',
      rules: 'Quy tắc sức chứa',
      minOrderCents: 'Giá trị đơn tối thiểu',
      cashEnabled: 'Thanh toán tiền mặt',
      onlineEnabled: 'Thanh toán trực tuyến',
      cardOnHandoffEnabled: 'Thẻ khi nhận hàng',
      autoConfirmHandoff: 'Tự động nhận đơn',
      deliveryPriceMode: 'Cách tính phí giao hàng',
      distanceCalculation: 'Cách tính khoảng cách',
      deliveryBufferMinutes: 'Thời gian đệm giao hàng',
      autoCompleteEnabled: 'Tự động hoàn tất',
      completeStaleAfterMinutesFromReadyAt: 'Tự hoàn tất đơn sau',
      cancelPendingAfterHours: 'Tự huỷ đơn chưa nhận sau',
      expireUnpaidAfterMinutes: 'Tự huỷ đơn chưa thanh toán sau',
      prepTimeMinutes: 'Thời gian chuẩn bị',
      schedulingLeadMinutes: 'Thời gian báo trước cho đơn hẹn giờ',
      openingBufferMinutes: 'Khung sớm nhất sau giờ mở cửa',
      credentials: 'Thông tin kết nối',
      instructions: 'Hướng dẫn thanh toán',
      defaultLanguage: 'Ngôn ngữ nhà hàng',
      feeCents: 'Phí giao hàng',
      maxDistanceKm: 'Khoảng cách tối đa',
      deliveryMinutes: 'Thời gian giao',
      polygon: 'Khu vực giao hàng',
      displayOrder: 'Thứ tự hiển thị',
      accountFields: 'Thông tin tài khoản',
      qrImageBlobKey: 'Ảnh QR',
      color: 'Màu',
      connection: 'Kết nối',
      isDefault: 'Máy in mặc định',
      printOnlineOrders: 'In đơn trực tuyến',
      printReservations: 'In phiếu đặt bàn',
      textSize: 'Cỡ chữ',
      splitKitchenTickets: 'Tách phiếu bếp',
      printExpoTicket: 'In phiếu tổng hợp',
      printItemCategory: 'Hiện nhóm món trên phiếu',
      dateTimeFormat: 'Định dạng ngày trên phiếu',
      ownerNotifyEnabled: 'Thông báo đơn hàng',
      ownerNotifyCashEnabled: 'Thông báo đơn tiền mặt',
      ownerNotifyManualEnabled: 'Thông báo đơn chuyển khoản',
      ownerNotifyOnlineEnabled: 'Thông báo đơn thanh toán trực tuyến',
      ownerNotifyCancellationEnabled: 'Thông báo huỷ đặt bàn',
      ownerNotifyNoShowEnabled: 'Thông báo khách không đến',
      prepReminderEnabled: 'Nhắc bắt đầu chuẩn bị',
      customerEmailEnabled: 'Email cho khách',
      customerEmailCashEnabled: 'Email cho đơn tiền mặt',
      customerEmailManualEnabled: 'Email cho đơn chuyển khoản',
      customerEmailOnlineEnabled: 'Email cho đơn thanh toán trực tuyến',
      ownerEmailEnabled: 'Email cho chủ quán',
      reminderEnabled: 'Email nhắc lịch',
      reminderOffsetsMinutes: 'Thời điểm gửi nhắc',
    } as Record<string, string>,
    values: {
      STRAIGHT_LINE: 'Mức khoảng cách',
      POLYGON: 'Khu vực đã vẽ',
      ROUTE_DISTANCE: 'Quãng đường lái xe',
      AUTO: 'Tự động',
      MANUAL: 'Thủ công',
      SIMPLE: 'Đơn giản',
      ADVANCED: 'Nâng cao',
      BASELINE: 'Khung mặc định',
      WINDOW: 'Khung giờ riêng',
      CLOSED: 'Đóng cửa',
      MODIFIED: 'Đổi giờ',
      DISTANCE: 'Theo khoảng cách',
      ZONE: 'Theo khu vực',
      DIRECT: 'Đường chim bay',
      ROUTE: 'Theo đường đi',
      MEDIUM: 'Vừa',
      LARGE: 'Lớn',
      DMY_SLASH: 'DD/MM/YYYY',
      DMY_DOT: 'DD.MM.YYYY',
      YMD_DASH: 'YYYY-MM-DD',
      MDY_SLASH: 'MM/DD/YYYY',
      PICKUP: 'Tự đến lấy',
      DELIVERY: 'Giao hàng',
      DINE_IN: 'Ăn tại quán',
    } as Record<string, string>,
  },

  staff: {
    title: 'Nhân viên',
    inviteTitle: 'Mời thành viên',
    nameLabel: 'Tên',
    namePlaceholder: 'Jane Smith',
    emailLabel: 'Email',
    emailPlaceholder: 'jane@example.com',
    roleLabel: 'Vai trò',
    roles: {
      MANAGER: 'Quản lý',
      STAFF: 'Phục vụ',
      KITCHEN: 'Bếp',
      CASHIER: 'Thu ngân',
    },
    inviting: 'Đang mời…',
    sendInvite: 'Gửi lời mời',
    couldNotLoadTitle: 'Không thể tải nhân viên',
    noStaffTitle: 'Chưa có nhân viên',
    noStaffDescription:
      'Mời đội ngũ của bạn - phục vụ, bếp, thu ngân - và thiết lập quyền cho từng người. Nhấn +.',
    inactive: 'Ngừng hoạt động',
    roleAriaLabel: (name) => `Vai trò của ${name}`,
    remove: 'Xóa',
    validation: {
      nameAndEmail: 'Nhập tên và địa chỉ email.',
    },
    toast: {
      invitationSent: 'Đã gửi lời mời',
      couldNotInvite: 'Không thể mời người này.',
      couldNotChangeRole: 'Không thể thay đổi vai trò.',
      couldNotUpdate: 'Không thể cập nhật.',
      removed: (name) => `Đã xóa ${name}`,
      couldNotRemove: 'Không thể xóa.',
    },
    removeConfirm: (name) => `Xóa ${name} khỏi nhà hàng này?`,
    removeConfirmTitle: 'Xóa nhân viên',
  },

  tableOrdering: {
    attachReservation: {
      title: 'Liên kết đặt bàn',
      noAttachable: 'Không có đặt bàn nào để liên kết.',
      confirmAttach: (name: string) => `Liên kết đặt bàn của ${name} và đánh dấu đã đến?`,
      partyOf: (n: number) => `Nhóm ${n} khách`,
      onThisTable: ' · bàn này',
    },
    inspector: {
      selectTable: 'Chọn một bàn',
      selectTableDesc: 'Chọn một bàn trên sơ đồ để xem hóa đơn, gọi món và thu tiền.',
      addRound: 'Thêm lượt gọi',
      bill: 'Hóa đơn',
      attach: 'Liên kết',
      guest: 'Khách',
      addGuest: 'Thêm khách',
      activity: 'Hoạt động',
      needsAttention: 'Cần chú ý',
      guestCalledServer: 'Khách đã gọi phục vụ',
      guestRequestedBill: 'Khách đã yêu cầu tính tiền',
      resolve: 'Xử lý',
      rounds: 'Lượt gọi',
      noRounds: 'Chưa có lượt gọi nào - "Thêm lượt gọi" để gọi món.',
      total: 'Tổng cộng',
      paid: 'Đã thanh toán',
      billRequestedStatus: 'Đã yêu cầu tính tiền',
      openStatus: 'Đang mở',
      closedStatus: 'Đã đóng',
      walkIn: 'Khách vãng lai',
      openedTime: 'đã mở',
      visit: 'lần ghé',
      visits: 'lần ghé',
      visitsCount: (n: number) => `${n} lần ghé`,
      roundStatus: {
        placed: 'Chờ xác nhận',
        fired: 'Đang ở bếp',
        ready: 'Sẵn sàng',
        served: 'Đã phục vụ',
        cancelled: 'Đã hủy',
      },
      roundNum: (seq: number) => `Lượt gọi ${seq}`,
      roundFired: (seq: number) => `Lượt gọi ${seq} đã chuyển bếp`,
      roundAccepted: (seq: number) => `Lượt gọi ${seq} đã được chấp nhận`,
      roundReadyToast: (seq: number) => `Lượt gọi ${seq} đã sẵn sàng`,
      roundServedToast: (seq: number) => `Lượt gọi ${seq} đã phục vụ`,
      roundReopened: (seq: number) => `Lượt gọi ${seq} đã trả về bếp`,
      cancelRoundPrompt: 'Lý do hủy lượt gọi này',
      roundCancelledToast: (seq: number) => `Lượt gọi ${seq} đã hủy`,
      voidItemPrompt: (name: string) => `Hủy "${name}"? Thêm lý do (tùy chọn)`,
      voidItemTitle: 'Hủy món',
      restoreAria: (name: string) => `Khôi phục ${name}`,
      voidAria: (name: string) => `Hủy ${name}`,
    },
    roundActions: {
      acceptFire: 'Xác nhận & chuyển bếp',
      cancelRound: 'Hủy lượt gọi',
      markReady: 'Đánh dấu sẵn sàng',
      markServed: 'Đánh dấu đã phục vụ',
      sendBackKitchen: 'Trả về bếp',
    },
    zonePicker: {
      open: 'đang mở',
      noOpenTabs: 'Không có hóa đơn đang mở',
      openCount: (n: number) => `${n} đang mở`,
    },
    assignCustomer: {
      title: 'Gán khách',
      change: 'Đổi khách',
      currentGuest: 'Khách hiện tại',
      unlinkGuest: 'Hủy liên kết khách',
      findAddGuest: 'Tìm hoặc thêm khách',
      linkDifferent: 'Liên kết khách khác',
      nameLabel: 'Tên',
      guestNamePlaceholder: 'Tên khách',
      phoneLabel: 'Điện thoại',
      phoneNumberPlaceholder: 'Số điện thoại',
      existingGuests: 'Khách hiện có - nhấn để liên kết',
      linkNewGuest: 'Liên kết khách mới',
      linkGuest: 'Liên kết khách',
      guestLinked: 'Đã liên kết khách',
      guestUnlinked: 'Đã hủy liên kết khách',
      enterNamePhone: 'Nhập tên và số điện thoại.',
      linkedName: (name: string) => `Đã liên kết ${name}`,
      visitsFooter: (n: number) => `${n} lần ghé`,
    },
    floorPlan: {
      noFloorPlanAdvanced:
        'Chưa vẽ sơ đồ mặt bằng - các bàn được hiển thị theo nhóm khu vực. Vẽ sơ đồ tại Cài đặt → Bàn (Nâng cao) và nó sẽ hiển thị tại đây.',
      simpleMode:
        'Các bàn đang ở chế độ đơn giản - hiển thị theo nhóm khu vực. Chuyển sang "Nâng cao" tại Cài đặt → Sơ đồ mặt bằng để tạo sơ đồ.',
    },
    tableGrid: {
      couldntLoadTables: 'Không thể tải các bàn',
      noTables: 'Không có bàn',
      noTablesDesc: 'Thêm bàn tại Cài đặt → Bàn để bắt đầu gọi món.',
      noTablesZone: 'Không có bàn trong khu vực này',
      noTablesZoneDesc: 'Chọn khu vực khác hoặc thêm bàn tại Cài đặt → Bàn.',
      other: 'Khác',
      reserved: 'Đã đặt trước',
      free: 'Trống',
      openTab: 'Hóa đơn đang mở',
      tryAgain: 'Vui lòng thử lại.',
      zoneCount: (label: string, n: number) => `${label} · ${n}`,
      occupiedSub: (rounds: number, money: string, calls: number) =>
        `${rounds} lượt gọi · ${money}${calls > 0 ? ` · ${calls} cuộc gọi` : ''}`,
      reservedAt: (time: string) => `Đã đặt trước · ${time}`,
      seatsCount: (n: number) => `${n} chỗ ngồi`,
      roundsAbbrev: (n: number) => `${n} lượt`,
    },
    billCollect: {
      collectPayments: 'Thu tiền',
      noSplit: 'Chưa chia hóa đơn',
      noSplitDesc: 'Thiết lập chia hóa đơn trước - sau đó mỗi phần sẽ hiển thị tại đây để thu.',
      splitBill: 'Chia hóa đơn',
      collectedFull: 'Đã thu đủ',
      shares: 'Các phần',
      awaiting: 'Đang chờ · nhấn để thu',
      done: 'Hoàn tất',
      tapNote:
        'Nhấn vào từng phần đang chờ để thu tiền. Hóa đơn sẽ tự đóng khi thu phần cuối cùng.',
      collectedCountOf: (count: number, total: number) => `Đã thu ${count}/${total}`,
      shareNum: (i: number) => `Phần ${i}`,
      methodTipFooter: (method: string, tip: string) => `${method} · +${tip} tiền tip`,
      methodCollectedFooter: (method: string) => `${method} · đã thu`,
    },
    addRound: {
      title: 'Thêm lượt gọi',
      send: 'Gửi',
      menu: 'Thực đơn',
      order: 'Đơn gọi',
      searchMenu: 'Tìm trong thực đơn',
      noMenu: 'Không có thực đơn nào đang hoạt động. Hãy xuất bản một thực đơn trước.',
      chooseOptions: 'Chọn tùy chọn',
      noItems: 'Chưa có món nào - chuyển sang thực đơn và nhấn vào món để tạo lượt gọi.',
      roundSentKitchen: 'Đã gửi lượt gọi đến bếp',
      failedSend: 'Gửi lượt gọi thất bại',
      assignTo: 'Gán món này cho',
      shared: 'Dùng chung',
      addSeat: '+ Thêm chỗ ngồi',
      seatAdded: 'Đã thêm chỗ ngồi',
      edit: 'Sửa',
      noteName: 'Ghi chú cho bếp (tùy chọn)',
      orderTab: (count: number) => `Đơn gọi${count > 0 ? ` · ${count}` : ''}`,
      seatOrdinal: (n: number) => `Chỗ ${n}`,
      addedItem: (name: string) => `Đã thêm ${name}`,
      tapDishes: 'Nhấn vào món để tạo lượt gọi.',
      summaryLine: (count: number, total: string) =>
        `${count} món · ${total} - nhấn "Gửi" để chuyển lượt gọi`,
    },
    configureItem: {
      title: 'Tùy chỉnh',
      dishUnavailable: 'Món không khả dụng',
      dishUnavailableDesc: 'Món này không còn trong thực đơn. Quay lại và chọn món khác.',
      updateItem: (money: string) => `Cập nhật · ${money}`,
      addItem: (money: string) => `Thêm · ${money}`,
      chooseOne: 'Chọn 1',
      chooseAny: 'Chọn tùy ý',
      chooseExact: (n: number, picked: number) => `Chọn ${n} · ${picked}/${n}`,
      upTo: (n: number, picked: number) => `Tối đa ${n} · ${picked}/${n}`,
      chooseRange: (min: number, max: number, picked: number) =>
        `Chọn ${min}-${max} · ${picked}/${max}`,
      atLeast: (n: number, picked: number) => `Ít nhất ${n} · ${picked}`,
      pickMore: (count: number, name: string) => `Chọn thêm ${count} ${name}`,
      maxReached: (max: number) => `Đã đạt tối đa ${max} - bỏ một lựa chọn để đổi`,
      optionShortage: (name: string, available: number, total: number, min: number) =>
        `${name}: chỉ còn ${available}/${total} lựa chọn, cần ${min}`,
      temporarilyUnavailable: 'Tạm thời không có sẵn',
      required: 'Bắt buộc',
      optional: 'Tùy chọn',
    },
    settings: {
      title: 'Gọi món tại bàn',
      dineInOrdering: 'Gọi món tại chỗ',
      enabled: 'Đã bật',
      tableOrderingOn: 'Đã bật gọi món tại bàn',
      tableOrderingOff: 'Đã tắt gọi món tại bàn',
      friendlyMessage:
        'Khi tắt, quét mã QR của bàn sẽ hiển thị thông báo thân thiện "Hãy hỏi nhân viên" và không có thực đơn.',
      howItWorks: 'Cách hoạt động',
      orderingMode: 'Chế độ gọi món',
      modeGuest: 'Khách',
      modeStaff: 'Nhân viên',
      modeHybrid: 'Kết hợp',
      roundHandling: 'Xử lý lượt gọi',
      autoPrintKitchen: 'Tự động in phiếu bếp',
      charges: 'Phí',
      serviceCharge: 'Phí dịch vụ',
      tipSuggestions: 'Gợi ý tiền tip',
      tableQRCodes: 'Mã QR của bàn',
      printableQR: 'Trang mã QR để in',
      printQRDesc: 'Mỗi bàn một mã QR. In, cắt và đặt lên bàn - khách quét để mở hóa đơn.',
      whoPlacesOrders: 'Ai gọi món?',
      guestOrderThemselves: 'Khách tự gọi món',
      staffTakeOrders: 'Nhân viên nhận tất cả đơn gọi',
      guestOrderStaffConfirm: 'Khách gọi món, nhân viên xác nhận lượt đầu',
      orderingModeUpdated: 'Đã cập nhật chế độ gọi món',
      whenRoundPlaced: 'Khi một lượt gọi được đặt',
      sendKitchenImmediately: 'Gửi ngay đến bếp',
      holdStaffAccept: 'Giữ lại đến khi nhân viên chấp nhận',
      roundHandlingUpdated: 'Đã cập nhật xử lý lượt gọi',
      serviceChargePrompt:
        'Phí dịch vụ được thêm vào mỗi hóa đơn (phần trăm, ví dụ 12,5). Đặt 0 để tắt.',
      enter0100: 'Nhập 0–100',
      serviceChargeUpdated: 'Đã cập nhật phí dịch vụ',
      tipPresetsPrompt:
        'Các nút gợi ý tiền tip hiển thị cho khách - phần trăm, cách nhau bằng dấu phẩy (ví dụ 5, 10, 15). Để trống nếu không có.',
      tipPresetsUpdated: 'Đã cập nhật gợi ý tiền tip',
      firingAuto: 'Tự động',
      firingConfirm: 'Xác nhận',
      kitchenTicketUpdated: 'Đã cập nhật cài đặt in phiếu bếp',
      chargeOff: 'Tắt',
      tipsNone: 'Không có',
    },
    billSplit: {
      title: 'Chia hóa đơn',
      billTotal: 'Tổng hóa đơn',
      even: 'Đều nhau',
      byAmount: 'Theo số tiền',
      bySeat: 'Theo chỗ ngồi',
      noSeats:
        'Chưa có chỗ ngồi nào. Thêm chỗ ngồi (hoặc gán món cho một chỗ ngồi trên phiếu gọi món), sau đó mỗi chỗ ngồi tự trả phần của mình - món dùng chung được chia đều.',
      noItems: 'Chưa có món nào',
      nothingShared: 'Không có món dùng chung',
      moveItem: 'Chuyển món sang',
      seatAdded: 'Đã thêm chỗ ngồi',
      atLeastOneSeat: 'Hãy thêm ít nhất một chỗ ngồi trước',
      atleastTwoAmounts: 'Nhập ít nhất hai số tiền',
      splitCreated: 'Đã tạo phần chia',
      createSplit: 'Tạo phần chia',
      seatFallback: (ordinal: number) => `Chỗ ${ordinal}`,
      movedToSeat: (label: string) => `Đã chuyển sang ${label}`,
      splitNote: (n: number) =>
        `Nhấn vào một món để chuyển. Món dùng chung được chia đều cho ${n} chỗ ngồi.`,
      perPersonWays: (ways: number) => `mỗi người · chia ${ways}`,
      partyLabel: (n: number) => `Nhóm ${n}`,
      addParty: 'Thêm nhóm',
    },
    history: {
      title: 'Lịch sử',
      couldntLoadHistory: 'Không thể tải lịch sử',
      noClosedTabs: 'Không có hóa đơn đã đóng',
      noClosedTabsDesc:
        'Các hóa đơn được thanh toán trong ngày này sẽ hiển thị tại đây. Chọn ngày khác ở trên.',
      splitEven: 'Chia · đều nhau',
      splitByAmount: 'Chia · theo số tiền',
      splitBySeat: 'Chia · theo chỗ ngồi',
      single: 'Đơn',
      forceClosed: 'Đóng cưỡng chế',
      tryAgain: 'Vui lòng thử lại.',
      tabsSummary: (n: number, money: string) => `${n} hóa đơn · ${money} đã thu`,
      closedAt: (time: string) => `Đóng lúc ${time}`,
      roundsCount: (n: number) => `${n} lượt gọi`,
      mixed: 'Hỗn hợp',
      card: 'Thẻ',
      giftCard: 'Thẻ quà tặng',
    },
    bill: {
      title: 'Hóa đơn',
      paidInFull: 'Đã thanh toán đủ',
      balanceDue: 'Số dư phải trả',
      subtotal: 'Tạm tính',
      serviceCharge: 'Phí dịch vụ',
      finishMeal: 'Hoàn tất bữa ăn trước khi tính tiền',
      backToTab: 'Quay lại hóa đơn',
      settle: 'Thanh toán',
      collectPayments: 'Thu tiền',
      takePayment: 'Nhận thanh toán',
      splitBill: 'Chia hóa đơn',
      splitOptions: 'Đều nhau, theo số tiền hoặc theo chỗ ngồi',
      takeFullPayment: 'Nhận thanh toán toàn bộ',
      paymentsTaken: 'Các khoản đã thu',
      manage: 'Quản lý hóa đơn',
      viewActivity: 'Xem hoạt động',
      markBillRequested: 'Đánh dấu đã yêu cầu',
      moveTabAnother: 'Chuyển hóa đơn sang bàn khác',
      mergeAnother: 'Gộp hóa đơn khác',
      forceCloseWalkout: 'Đóng cưỡng chế (bỏ trốn / miễn phí)…',
      tabClosed: 'Đã đóng hóa đơn',
      tabClosedDesc: 'Hóa đơn này đã được thanh toán và đóng. Phần tóm tắt ở trên chỉ để xem.',
      closeConfirm: 'Đóng hóa đơn đã thanh toán đủ này?',
      closeTitle: 'Đóng hóa đơn',
      forceClosePrompt: 'Lý do (bỏ trốn, miễn phí, lỗi…) - được ghi vào dòng thời gian',
      forceCloseTitle: 'Đóng cưỡng chế hóa đơn',
      forceCloseDone: 'Đã đóng cưỡng chế hóa đơn',
      noFreeTable: 'Không có bàn trống để chuyển sang',
      moveTitle: 'Chuyển hóa đơn sang',
      noOtherTab: 'Không có hóa đơn đang mở nào khác để gộp',
      mergeTitle: 'Gộp hóa đơn khác vào hóa đơn này',
      mergeDesc:
        'Các lượt gọi của hóa đơn kia sẽ được chuyển vào đây; hóa đơn đó đóng dưới dạng đã gộp.',
      markedBillRequested: 'Đã đánh dấu yêu cầu',
      roundsNotServed: (_count: number, seqs: string) => `Lượt gọi ${seqs} chưa được phục vụ`,
      finishMealDesc: (roundsText: string) =>
        `${roundsText}. Phục vụ hoặc hủy mọi lượt gọi trên hóa đơn, sau đó quay lại để thanh toán.`,
      collectPaymentsFooter: (collected: number, total: number, amount: string) =>
        `Đã thu ${collected}/${total} · còn ${amount}`,
      takePaymentFooter: (amount: string) => `Còn ${amount} · tiền mặt hoặc thẻ`,
      guestSuggested: (mode: string) => `Khách đề xuất: ${mode}`,
      bySeatFooter: (n: number) => `Theo chỗ ngồi (${n}), đều nhau hoặc theo số tiền`,
      takeFullPaymentFooter: (amount: string) => `${amount} · một lần thanh toán`,
      paymentTipFooter: (status: string, tip: string) => `${status} · +${tip} tiền tip`,
      payStatus: {
        pendingCollection: 'Chờ thanh toán',
        awaitingProof: 'Chờ chứng từ',
        proofSubmitted: 'Đã nộp chứng từ',
        processing: 'Đang xử lý',
        paid: 'Đã thanh toán',
        rejected: 'Bị từ chối',
        void: 'Đã hủy',
        refunded: 'Đã hoàn tiền',
        partiallyRefunded: 'Hoàn tiền một phần',
      },
      movedTo: (label: string) => `Đã chuyển sang ${label}`,
      mergedWith: (label: string) => `Đã gộp ${label}`,
      billTitleFor: (label: string) => `Hóa đơn · ${label}`,
    },
    payment: {
      collect: 'Thu một phần',
      takePayment: 'Nhận thanh toán',
      method: 'Phương thức',
      cash: 'Tiền mặt',
      cardTerminal: 'Thẻ / Máy POS',
      amount: 'Số tiền',
      tip: 'Tiền tip',
      enterAmount: 'Nhập số tiền thanh toán',
      shareCollected: 'Đã thu phần',
      paymentRecorded: 'Đã ghi nhận thanh toán',
      shareOf: (i: number, total: number) => `Phần ${i}/${total}`,
      collectAmount: (amount: string) => `Thu ${amount}`,
      recordAmountPayment: (amount: string) => `Ghi nhận thanh toán ${amount}`,
    },
    workspace: {
      tables: 'Bàn',
      floor: 'Sơ đồ mặt bằng',
      list: 'Danh sách',
      openTabTitle: 'Mở hóa đơn',
      noZone: 'Không có khu vực',
      zoneFallback: 'Khu vực',
      openTabConfirm: (label: string) => `Mở hóa đơn mới cho ${label}?`,
      tabOpened: (label: string) => `Đã mở hóa đơn · ${label}`,
      tabFallback: 'Bàn',
    },
    qrSheet: {
      title: 'Trang mã QR',
      print: 'In',
      noQR: 'Không có mã QR của bàn',
      noQRDesc: 'Thêm bàn tại Cài đặt → Bàn; mỗi bàn sẽ tự động có một mã QR.',
      hint: 'In trang này, cắt theo các thẻ và đặt một thẻ lên mỗi bàn.',
      noQRYet: 'Chưa có mã QR:',
      reseeding: 'Các bàn này cần một token QR - khởi tạo lại hoặc lưu bàn sẽ gán một token.',
      tryAgain: 'Vui lòng thử lại.',
      qrAlt: (label: string) => `Mã QR cho ${label}`,
    },
    timeline: {
      activity: 'Hoạt động',
      noActivity: 'Chưa có hoạt động nào',
      noActivityDesc:
        'Mọi thao tác trên hóa đơn này - gọi món, bếp, thanh toán - sẽ hiển thị tại đây.',
      tabOpened: 'Đã mở hóa đơn',
      roundPlaced: 'Đã đặt lượt gọi',
      sentKitchen: 'Đã gửi đến bếp',
      roundReady: 'Lượt gọi sẵn sàng',
      roundServed: 'Đã phục vụ lượt gọi',
      roundCancelled: 'Đã hủy lượt gọi',
      itemVoided: 'Đã hủy món',
      itemRestored: 'Đã khôi phục món',
      reservationAttached: 'Đã liên kết đặt bàn',
      serviceRequested: 'Đã yêu cầu phục vụ',
      serviceResolved: 'Đã xử lý phục vụ',
      billRequested: 'Đã yêu cầu tính tiền',
      paymentTaken: 'Đã nhận thanh toán',
      forceClosedTimeline: 'Đóng cưỡng chế',
      movedTable: 'Đã chuyển bàn',
      mergedAnother: 'Đã gộp vào hóa đơn khác',
      tabClosed3: 'Đã đóng hóa đơn',
      seatedReservation: 'Được xếp chỗ từ đặt bàn',
      guest: 'Khách',
      staff: 'Nhân viên',
      system: 'Hệ thống',
    },
    arrivals: {
      title: 'Khách dự kiến đến',
      noArrivals: 'Không có khách dự kiến đến',
      noArrivalsDesc:
        'Các lượt đặt bàn sắp tới trong hôm nay sẽ hiển thị tại đây để xếp chỗ chỉ với một lần nhấn.',
      overdue: 'Quá giờ',
      seatTitle: 'Xếp chỗ cho khách',
      seatConfirm: (name: string, n: number) => `Xếp chỗ cho ${name} (nhóm ${n} khách)?`,
      seatedToast: (name: string) => `Đã xếp chỗ cho ${name}`,
    },
  },

  waitlist: {
    title: 'Danh sách chờ',
    partyOf: (partySize) => `Nhóm ${partySize} người`,
    addForm: {
      title: 'Thêm khách vãng lai',
      partySize: 'Số người',
      guestName: 'Tên khách',
      guestNamePlaceholder: 'ví dụ: Sarah',
      phone: 'Điện thoại (tùy chọn)',
      phonePlaceholder: 'Để gọi họ khi có bàn trống',
      adding: 'Đang thêm…',
      addButton: 'Thêm vào danh sách chờ',
    },
    validation: {
      nameRequired: 'Vui lòng nhập tên của khách.',
    },
    toasts: {
      added: (guestName, quotedWaitMinutes) =>
        `Đã thêm ${guestName} - thời gian chờ ước tính ${quotedWaitMinutes} phút`,
      marked_notified: (guestName) => `Đã thông báo cho ${guestName}`,
      could_not_update: 'Cập nhật thất bại.',
      no_free_tables: 'Hiện không có bàn trống.',
      seated: (guestName) => `Đã xếp chỗ cho ${guestName}`,
      could_not_seat: 'Không thể xếp chỗ cho nhóm này.',
      removed: (guestName) => `Đã xóa ${guestName}`,
      could_not_remove: 'Xóa thất bại.',
      marked_noshow: (guestName) => `Đã đánh dấu ${guestName} là không đến`,
      could_not_add: 'Không thể thêm nhóm này.',
    },
    actions: {
      seat: {
        label: (guestName, partySize) => `Xếp chỗ cho ${guestName} (${partySize} khách)`,
        tableOption: (tableLabel, zoneLabelFormatted, seats) =>
          `${tableLabel}${zoneLabelFormatted} - ${seats} chỗ ngồi`,
      },
      seatButton: 'Xếp chỗ',
      cancel: {
        confirm: (guestName) => `Xóa ${guestName} khỏi danh sách chờ?`,
        title: 'Xóa nhóm',
      },
      noShow: {
        confirm: (guestName) => `Đánh dấu ${guestName} là không đến?`,
        title: 'Không đến',
      },
      notify: 'Thông báo',
      noshow: 'Không đến',
      remove: 'Xóa',
    },
    error: {
      loading: 'Không thể tải danh sách chờ',
    },
    empty: {
      title: 'Không có ai đang chờ',
      description:
        'Khi một nhóm khách đến mà không còn bàn trống, hãy thêm họ vào đây và báo thời gian chờ. Nhấn +.',
    },
    status: {
      notified: 'Đã thông báo',
    },
  },

  shared: {
    restaurantNotFound: 'Nhà hàng này không còn tồn tại - hãy chọn một nhà hàng khác.',
    failedLoadRestaurantConfig: 'Tải cấu hình nhà hàng thất bại.',
    unableToConnect: 'Không thể kết nối. Vui lòng kiểm tra kết nối của bạn.',
    retry: 'Thử lại',
    chooseAnotherRestaurant: 'Chọn nhà hàng khác',
    language: 'Ngôn ngữ',
    empty: 'trống',
    noRestaurantsAvailable: 'Không có nhà hàng nào khả dụng.',
    restaurant: 'Nhà hàng',
  },

  forms: {
    required: 'Trường này là bắt buộc.',
    tooLong: (max) => `Tối đa ${max} ký tự.`,
    invalidEmail: 'Nhập email hợp lệ như xin.chao@nha-hang.com.',
    invalid: 'Vui lòng kiểm tra giá trị này.',
    invalidUrl: 'Nhập địa chỉ web hợp lệ.',
  },

  // Order label settings (create / rename / recolor the triage tag set).
  purge: {
    history: {
      pageTitle: 'Lịch sử ẩn',
      couldntLoad: 'Không tải được lịch sử',
      empty: 'Chưa dọn dẹp gì',
      emptyWhy: 'Khi có gì đó được ẩn — bởi bạn hoặc vào ban đêm — nó sẽ hiện ở đây.',
      footer: 'Được lưu lại để bạn luôn thấy điều gì đã bị ẩn và vì sao.',
      hidSummary: (what: string) => `Đã ẩn ${what}`,
      orders: (n: number) => `${n.toLocaleString()} đơn hàng`,
      reservations: (n: number) => `${n.toLocaleString()} đặt bàn`,
      statusLabel: {
        RUNNING: 'Đang chạy',
        COMPLETED: 'Xong',
        PARTIAL: 'Chỉ một phần',
        FAILED: 'Chưa hoàn tất',
      },
      sourceLabel: {
        SCHEDULED: 'Ban đêm',
        MANUAL_RULE: 'Thủ công',
        MANUAL_CRITERIA: 'Thủ công',
        MANUAL_SELECTION: 'Thủ công',
      },
      detailTitle: 'Chi tiết đợt dọn dẹp',
      when: 'Khi nào',
      outcome: 'Kết quả',
      hiddenCount: 'Số bản ghi đã ẩn',
      startedBy: 'Khởi chạy',
      criteriaTitle: 'Đã tìm những gì',
      whatKind: 'Loại',
      fromRule: 'Quy tắc',
      olderThan: 'Cũ hơn',
      tags: 'Thẻ',
      pickedByHand: 'Chọn thủ công',
      criteriaFrozen: 'Lưu đúng như lúc đó, nên đổi tên thẻ sau này không bao giờ làm thay đổi.',
      skippedTitle: 'Được giữ lại',
      skippedFooter: 'Những mục này khớp nhưng được bảo vệ. Không có gì trong đây bị ẩn.',
      skipReason: {
        STILL_LIVE: 'Vẫn đang hoạt động',
        CARRIES_MONEY: 'Có liên quan đến tiền',
        CONCURRENT_CHANGE: 'Thay đổi khi đang chạy',
        CAP_REACHED: 'Quá nhiều cùng lúc',
      },
      errorTitle: 'Điều gì đã sai',
    },
    cleanupTitle: 'Dọn dẹp ngay',
    cleanupIntro:
      'Ẩn hàng loạt bản ghi cũ đã hoàn tất trong một lần. Không có gì bị xóa, nhưng đơn hàng đã ẩn sẽ không còn được tính vào báo cáo doanh thu.',
    cleanupTagsTitle: 'Giới hạn theo thẻ',
    pickATagToCount: 'Chọn ít nhất một thẻ để xem sẽ ẩn bao nhiêu.',
    cleanupSomeTags: 'Chỉ những bản ghi mang một trong các thẻ ở trên được tính.',
    cleanupReassurance:
      'Chỉ đơn hàng đã hoàn tất và đã huỷ mới đủ điều kiện. Đơn hàng được tính khi: không có thanh toán, thanh toán bị từ chối hoặc bị huỷ, đã hoàn tất và trả bằng tiền mặt, hoặc đã huỷ và được hoàn tiền đầy đủ.',
    working: 'Đang xử lý…',
    confirmTitle: 'Ẩn những mục này?',
    zeroDayAutoTitle: 'Dọn từ hôm nay?',
    zeroDayAutoBody:
      'Với "Trước hôm nay" và bật tự động, mỗi lần chạy theo lịch sẽ xóa mọi mục khớp cũ hơn nửa đêm, kể cả của hôm nay. Không thể hoàn tác. Tiếp tục?',
    autoTitle: 'Tự động ẩn',
    autoOnFooter:
      'Chạy theo lịch trong Cài đặt nâng cao. Bạn vẫn có thể dọn dẹp thủ công bất cứ lúc nào.',
    pageTitle: 'Dọn gọn danh sách',
    intro:
      'Các bản ghi cũ đã hoàn tất sẽ được ẩn khỏi danh sách, không bị xoá. Đơn hàng đã ẩn sẽ không còn được tính vào báo cáo doanh thu, và mỗi lần bạn dọn dẹp đều có trong Lịch sử ẩn.',
    couldntLoad: 'Không tải được cài đặt dọn dẹp',
    noAccess: 'Bạn không có quyền truy cập trang này',
    couldNotSave: 'Không lưu được. Vui lòng thử lại.',
    noLabels: 'Chưa có nhãn nào.',
    pickATagFirst: 'Chọn ít nhất một thẻ trước khi bật.',
    dayRequired: 'Giữ ít nhất một ngày được chọn.',
    counting: 'Đang đếm…',
    couldntCount: 'Hiện chưa đếm được. Kiểm tra kết nối và thử lại.',
    seeThem: 'Xem',
    close: 'Đóng',
    loadMore: 'Tải thêm',
    nothingToShow: 'Không có gì để hiển thị.',
    showingOf: (a: number, b: number) => `Đang hiển thị ${a} trên ${b.toLocaleString()}.`,
    olderThanOption: (days: number) =>
      days === 0
        ? 'Trước hôm nay'
        : days === 1
          ? '1 ngày'
          : days === 30
            ? '1 tháng'
            : days === 90
              ? '3 tháng'
              : days === 180
                ? '6 tháng'
                : '1 năm',
    advancedTitle: 'Cài đặt nâng cao',
    advancedFooter: 'Tinh chỉnh cách tính tuổi và thời điểm dọn dẹp hằng đêm.',
    advanced: {
      ageBasisLabel: 'Tính tuổi từ',
      ageBasisCreated: 'Lúc được tạo',
      ageBasisService: 'Giờ phục vụ',
      matchLabel: 'Phải mang',
      matchAny: 'Bất kỳ thẻ nào',
      matchAll: 'Tất cả các thẻ',
      kindLabel: 'Chạy',
      kindDaily: 'Hằng ngày',
      kindWeekly: 'Hằng tuần',
      kindMonthly: 'Hằng tháng',
      weekdayLabel: 'Vào',
      monthDayLabel: 'Vào ngày',
      hourLabel: 'Lúc',
      hourOption: (h: number) => `${String(h).padStart(2, '0')}:00`,
      scheduleFooter: 'Dọn dẹp hằng đêm chạy vào giờ này, theo giờ địa phương của nhà hàng.',
    },
    managedInAdvanced: 'Được quản lý bởi quy tắc riêng',
    managedInAdvancedFooter: (n: number) =>
      `Danh sách này có ${n} quy tắc riêng không được tạo trên màn hình này. Các tuỳ chọn được ẩn đi để không âm thầm sửa chỉ một trong số đó.`,
    orders: {
      confirmBody: (n: number) =>
        `${n.toLocaleString()} đơn hàng sẽ được ẩn khỏi danh sách này và không còn được tính vào báo cáo doanh thu.`,
      hideAction: (n: number) => `Ẩn ${n.toLocaleString()} đơn hàng`,
      hidden: (done: number, asked: number) =>
        done === asked
          ? `Đã ẩn ${done.toLocaleString()} đơn hàng.`
          : `Đã ẩn ${done.toLocaleString()} trên ${asked.toLocaleString()}. Số còn lại đã thay đổi trong lúc bạn chọn.`,
      title: 'Đơn hàng',
      previewTitle: 'Đơn hàng sẽ bị ẩn',
      switchTitle: 'Tự động dọn gọn danh sách đơn hàng',
      olderThanLabel: 'Ẩn đơn hàng đã hoàn tất & đã huỷ cũ hơn',
      wouldHide: (n: number) =>
        n === 0
          ? 'Hiện chưa có gì để ẩn.'
          : `Hiện tại thao tác này sẽ ẩn ${n.toLocaleString()} đơn hàng.`,
    },
    reservations: {
      confirmBody: (n: number) =>
        `${n.toLocaleString()} đặt bàn sẽ được ẩn khỏi danh sách này. Báo cáo của bạn không thay đổi.`,
      hideAction: (n: number) => `Ẩn ${n.toLocaleString()} đặt bàn`,
      hidden: (done: number, asked: number) =>
        done === asked
          ? `Đã ẩn ${done.toLocaleString()} đặt bàn.`
          : `Đã ẩn ${done.toLocaleString()} trên ${asked.toLocaleString()}. Số còn lại đã thay đổi trong lúc bạn chọn.`,
      title: 'Đặt bàn',
      previewTitle: 'Lượt đặt bàn sẽ bị ẩn',
      switchTitle: 'Tự động dọn gọn danh sách đặt bàn',
      olderThanLabel: 'Ẩn lượt đặt bàn đã hoàn tất cũ hơn',
      wouldHide: (n: number) =>
        n === 0
          ? 'Hiện chưa có gì để ẩn.'
          : `Hiện tại thao tác này sẽ ẩn ${n.toLocaleString()} lượt đặt bàn.`,
    },
  },
  labels: {
    none: 'Chưa có nhãn nào.',
    setUp: 'Thiết lập nhãn',
    couldNotAssign: 'Không lưu được nhãn. Vui lòng thử lại.',
    more: (n: number) => `+${n}`,
    systemOwnedNote: 'Đây là nhãn hệ thống. Bạn có thể đổi tên hoặc đổi màu, nhưng không thể xóa.',
    pageTitle: 'Nhãn',
    addLabel: 'Nhãn mới',
    editLabel: 'Sửa nhãn',
    nameLabel: 'Tên',
    namePlaceholder: 'ví dụ: VIP',
    nameRequired: 'Nhập tên nhãn.',
    colorLabel: 'Màu',
    customColor: 'Màu tùy chỉnh',
    preview: 'Xem trước',
    labelAdded: 'Đã thêm nhãn',
    labelUpdated: 'Đã cập nhật nhãn',
    labelDeleted: 'Đã xóa nhãn',
    deleteTitle: 'Xóa nhãn',
    deleteConfirmation: (name: string) =>
      `Xóa "${name}"? Nhãn sẽ bị gỡ khỏi mọi đơn hàng đang gắn.`,
    couldNotSave: 'Không lưu được nhãn.',
    couldNotDelete: 'Không xóa được nhãn.',
    couldntLoadLabels: 'Không tải được nhãn',
    noLabelsTitle: 'Chưa có nhãn',
    noLabelsDescription:
      'Tạo nhãn như "VIP" hay "Khiếu nại", rồi chạm để gắn vào đơn hàng cho cả nhóm cùng thấy.',
    listFooter:
      'Nhân viên có thể gắn các nhãn này vào bất kỳ đơn hàng trực tuyến nào. Xóa nhãn sẽ gỡ nó khỏi mọi đơn hàng.',
    cancel: 'Hủy',
  },
  suspension: {
    heading: 'Nhà hàng này đã bị tạm khóa',
    body: 'Quyền truy cập ứng dụng đang tạm dừng. Vui lòng liên hệ bộ phận hỗ trợ để mở lại.',
    reasonLabel: 'Lý do',
    contactLabel: 'Hỗ trợ',
    whatsApp: 'Nhắn tin qua WhatsApp',
    checkAgain: 'Kiểm tra lại',
  },
  voiceInput: {
    start: 'Nhập bằng giọng nói',
    stop: 'Dừng nhập bằng giọng nói',
    recordingOnly: 'Đang ghi âm — chữ sẽ hiện khi bạn dừng.',
    permissionDenied:
      'Quyền dùng micrô đang tắt. Hãy bật trong cài đặt thiết bị hoặc trình duyệt để nhập bằng giọng nói.',
    noMicrophone: 'Không tìm thấy micrô trên thiết bị này.',
    unsupported: 'Thiết bị này không hỗ trợ nhập bằng giọng nói.',
    failed: 'Không thể chuyển giọng nói thành chữ. Vui lòng thử lại.',
  },
};
